import React, { useState, useEffect, useMemo } from 'react';
import { initializeApp, getApps, getApp } from "firebase/app"; 
import { getDatabase, ref, onValue, push, remove, set, update, query, orderByChild, endAt, get, runTransaction } from "firebase/database";
import { getAuth, signInWithPopup, signInWithRedirect, GoogleAuthProvider, onAuthStateChanged, signOut, setPersistence, browserLocalPersistence } from "firebase/auth";
import './styles.css';
import Swal from 'sweetalert2';
import BracketTorneo from './BracketTorneo';

const firebaseConfig = {
  apiKey: "AIzaSyAX0kz-kvMONPJpBxV-u33rP8_cDaA9j2I",
  authDomain: "astros-tenis-de-mesa.firebaseapp.com",
  databaseURL: "https://astros-tenis-de-mesa-default-rtdb.firebaseio.com",
  projectId: "astros-tenis-de-mesa",
  storageBucket: "astros-tenis-de-mesa.firebasestorage.app",
  messagingSenderId: "529735621693",
  appId: "1:529735621693:web:320dbf0fe3e790167a1e54",
  measurementId: "G-EKSJZQX411"
};

const ADMIN_EMAIL = "palermoprints@gmail.com"; 
const STAFF_EMAIL = "alejo.fv@gmail.com";
const URL_TIENDA = "https://astrostenisdemesa.empretienda.com.ar/"; // Reemplazá con tu link real

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
const db = getDatabase(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
// Forzamos a que la sesión sea persistente en el dispositivo
setPersistence(auth, browserLocalPersistence);

const ESQUEMA = {
  Martes: [{ h: "17:00", s: "Fulgor", n: "Azul" }, { h: "18:30", s: "Fulgor", n: "Violeta" }, { h: "20:00", s: "Fulgor", n: "Violeta" }, { h: "17:30", s: "Chacarita", n: "Negro" }, { h: "19:00", s: "Chacarita", n: "Azul" }, { h: "20:30", s: "Chacarita", n: "Azul" }],
  Miercoles: [{ h: "17:00", s: "Fulgor", n: "Azul" }, { h: "18:30", s: "Fulgor", n: "Violeta" }, { h: "20:00", s: "Fulgor", n: "Negro" }],
  Jueves: [{ h: "17:00", s: "Fulgor", n: "Negro" }, { h: "18:30", s: "Fulgor", n: "Violeta" }, { h: "20:00", s: "Fulgor", n: "Azul" }],
  Viernes: [{ h: "17:00", s: "Fulgor", n: "Azul" }, { h: "18:30", s: "Fulgor", n: "Violeta" }, { h: "20:00", s: "Fulgor", n: "Negro" }, { h: "17:30", s: "Chacarita", n: "Azul" }, { h: "19:00", s: "Chacarita", n: "Azul" }, { h: "20:30", s: "Chacarita", n: "Azul" }],
  Sabado: [{ h: "15:00", s: "Fulgor", n: "Violeta" }, { h: "16:30", s: "Fulgor", n: "Negro" }]
};

const TODOS_LOS_TURNOS = Object.entries(ESQUEMA).flatMap(([dia, turnos]) => 
  turnos.map(t => ({ ...t, dia }))
);

const diasSemana = ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"];

export default function App() {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [nivelUser, setNivelUser] = useState("Azul"); 
  const [pizarron, setPizarron] = useState([]);
  const [historialIntercambios, setHistorialIntercambios] = useState([]);
  const [usuariosAdmin, setUsuariosAdmin] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [fechaSel, setFechaSel] = useState("");
  const [opcionesDia, setOpcionesDia] = useState([]);
  const [turnoElegido, setTurnoElegido] = useState(null);
  const [filtroNivel, setFiltroNivel] = useState("Todos");
  const [filtroHistorial, setFiltroHistorial] = useState("Todos");
  const [filtroDisponibles, setFiltroDisponibles] = useState("Todos");
  const [pestañaActiva, setPestañaActiva] = useState("pizarron");
  const [eventos, setEventos] = useState([]);
  const [noticias, setNoticias] = useState([]); // <-- Nuevo: Para guardar las noticias
  const [nuevaNoticia, setNuevaNoticia] = useState({ titulo: '', contenido: '' }); // <-- Nuevo: Para el formulario admin
  const [verHistorial, setVerHistorial] = useState(false);
  const [verFijos, setVerFijos] = useState(false);
const [busquedaPlanilla, setBusquedaPlanilla] = useState("");
const [ordenPlanilla, setOrdenPlanilla] = useState("nombre"); // nombre, mayor_credito, mayor_deuda
const [busquedaFinanzas, setBusquedaFinanzas] = useState("");
const [preciosCuotas, setPreciosCuotas] = useState({ p1: 0, p2: 0, p3: 0, p4: 0 });
const [feriados, setFeriados] = useState({});
const [subPestañaAdmin, setSubPestañaAdmin] = useState("socios");
const [subPestañaComp, setSubPestañaComp] = useState("proximos"); // "proximos", "resultados" o "admin"
const [filtroSemestre, setFiltroSemestre] = useState("2026-2");
const [encuentros, setEncuentros] = useState([]);
const [podioData, setPodioData] = useState({ activo: false, p1: '', p2: '', p3: '' });
const [podiosSemanales, setPodiosSemanales] = useState({});
const [cargando, setCargando] = useState(false);
const [vitrinaColectiva, setVitrinaColectiva] = useState({});
const [filtroCat, setFiltroCat] = useState('TODAS');
const categoriasPosibles = ['TODAS', 'Copa de Clubes', '1ra', '2da', '3ra', '4ta', '5ta', '6ta', '7ma', '8va'];
const [filtroSemestreGestion, setFiltroSemestreGestion] = useState("2026-2");
const [filtroCatGestion, setFiltroCatGestion] = useState("TODAS");
const [online, setOnline] = useState(false);
// Definimos un estado local para la subpestaña de Torneos y Eventos
const [subPestañaTorneos, setSubPestañaTorneos] = useState("torneos"); // "torneos", "eventos", "ranking", "resultados", "admin"
const [torneosActivos, setTorneosActivos] = useState([]);
const [torneosResultados, setTorneosResultados] = useState([]);
const [filtroTorneoResultado, setFiltroTorneoResultado] = useState("TODOS");
const [filtroJugadorResultado, setFiltroJugadorResultado] = useState('');
// Estados para el Head to Head
const [h2hJugador1, setH2hJugador1] = useState("");
const [h2hJugador2, setH2hJugador2] = useState("");
const [verCuentaCorriente, setVerCuentaCorriente] = useState(false);
const [verTomados, setVerTomados] = useState(false);
const [verMenuHeader, setVerMenuHeader] = useState(false);
const [modoVacaciones, setModoVacaciones] = useState(false);

// Variables auxiliares para los formularios de Admin Torneos
const [nuevoTorneo, setNuevoTorneo] = useState({
  nombre: '',
  formato: 'Round Robin',
  modo: 'singles',
  esFinals: false,
  cupo: 16,
  precio: '$5000',
  fechaInicio: '' // <--- Nuevo campo para fecha y hora de inicio
});

const [cargaPartido, setCargaPartido] = useState({
  torneoId: '',
  modo: 'singles',
  esFinals: false,
  fase: 'Zona', // <--- Nueva propiedad (opción por defecto)
  fasePersonalizada: '', // <--- Para cuando eligen "Otra..."
  jugador1: '',
  jugador2: '',
  doblesA1: '', doblesA2: '',
  doblesB1: '', doblesB2: '',
  ganador: 1,
  sets: [
    { p1: '', p2: '' },
    { p1: '', p2: '' },
    { p1: '', p2: '' },
    { p1: '', p2: '' },
    { p1: '', p2: '' }
  ]
});

useEffect(() => {
  // Listener de Torneos Activos
  const torneosRef = ref(db, 'torneos_activos');
  const unsubTorneos = onValue(torneosRef, (snapshot) => {
    const data = snapshot.val();
    if (data) {
      const lista = Object.entries(data).map(([id, val]) => ({ id, ...val }));
      setTorneosActivos(lista); // <--- Al usarlo acá se le quita el color gris
    } else {
      setTorneosActivos([]);    // <--- Y acá
    }
  });

  // Listener de Resultados
  const resultadosRef = ref(db, 'torneos_resultados');
  const unsubResultados = onValue(resultadosRef, (snapshot) => {
    const data = snapshot.val();
    if (data) {
      const lista = Object.entries(data).map(([id, val]) => ({ id, ...val }));
      setTorneosResultados(lista.reverse()); // <--- Al usarlo acá también
    } else {
      setTorneosResultados([]);              // <--- Y acá
    }
  });

  return () => {
    unsubTorneos();
    unsubResultados();
  };
}, []);

useEffect(() => {
  const connectedRef = ref(db, ".info/connected");
  
  // El onValue devuelve una función que sirve para desuscribirse
  const unsubscribe = onValue(connectedRef, (snap) => {
    if (snap.val() === true) {
      setOnline(true);
    } else {
      setOnline(false);
    }
  });
  return () => unsubscribe(); 
}, []);

useEffect(() => {
  const vitrinaRef = ref(db, 'config/vitrinaColectiva');
  const unsubscribe = onValue(vitrinaRef, (snap) => {
    if (snap.exists()) setVitrinaColectiva(snap.val());
  });
  return () => unsubscribe();
}, []);

useEffect(() => {
  const semanalesRef = ref(db, 'config/podiosSemanales');
  const unsubscribe = onValue(semanalesRef, (snap) => {
    if (snap.exists()) setPodiosSemanales(snap.val());
    else setPodiosSemanales({});
  });
  return () => unsubscribe();
}, []);

// 2. Escucha con desuscripción
useEffect(() => {
  const podioRef = ref(db, 'config/podioMensual');
  
  // Guardamos la función de desuscripción que nos da Firebase
  const unsubscribe = onValue(podioRef, (snap) => {
    if (snap.exists()) {
      setPodioData(snap.val());
    }
  });

  // Cuando el componente se cierra (o cambias de pestaña), se apaga el listener
  return () => unsubscribe();
}, []);

useEffect(() => {
  const preciosRef = ref(db, 'config/precios_cuotas');
  const unsubscribe = onValue(preciosRef, (snapshot) => {
    if (snapshot.exists()) {
      setPreciosCuotas(snapshot.val());
    }
  });
  return () => unsubscribe();
}, []);

useEffect(() => {
  // 1. Variables para guardar los "unsubscribes" (cables que desconectaremos)
  let unsubUser = null;
  let unsubAdmin = null;
  let unsubTurnos = null;
  let unsubIntercambios = null;
  let unsubEventos = null;
  let unsubNoticias = null;

  // 2. Listener de Autenticación
  const unsubscribeAuth = onAuthStateChanged(auth, (u) => {
    setUser(u);
    
    // Limpiamos listeners previos si el usuario cambia o cierra sesión
    if (unsubUser) unsubUser();
    if (unsubAdmin) unsubAdmin();

    if (u) {
      // --- DATOS DEL USUARIO LOGUEADO ---
      const userRef = ref(db, `usuarios/${u.uid}`);
      unsubUser = onValue(userRef, s => {
        const d = s.val();
        if (d) {
          const ahora = new Date().getTime();
          const vigentes = d.detalles_creditos 
            ? Object.values(d.detalles_creditos).filter(c => c.vence > ahora).length 
            : 0;
          const deudaTotal = d.deudas ? Object.keys(d.deudas).length : 0;

          // ✅ NORMALIZACIÓN: Garantizamos que nivel siempre esté definido dentro del objeto
          const nivelDefinido = d.nivel || "Azul";
          const usuarioActualizado = {
            ...d,
            nivel: nivelDefinido,
            realCreditos: vigentes,
            realDeuda: deudaTotal
          };

          setUserData(usuarioActualizado);
          setNivelUser(nivelDefinido);
        } else {
          set(userRef, { nombre: u.displayName, email: u.email, nivel: "Azul", aprobado: false });
        }
      });

      // --- LISTA GENERAL DE USUARIOS (Para Ranking, Desplegables y Admin) ---
      unsubAdmin = onValue(ref(db, 'usuarios'), s => {
        const data = s.val();
        if (data) {
          const ahora = new Date().getTime();
          const lista = Object.keys(data).map(uid => {
            const uData = data[uid];
            const creditosVigentes = uData.detalles_creditos 
              ? Object.values(uData.detalles_creditos).filter(c => c.vence > ahora).length 
              : 0;
            return { 
              uid, 
              ...uData, 
              nivel: uData.nivel || "Azul", // ✅ Misma garantía para la lista global
              realCreditos: creditosVigentes, 
              realDeuda: uData.deudas ? Object.keys(uData.deudas).length : 0 
            };
          }).sort((a, b) => (a.nombre || "").localeCompare(b.nombre || ""));

          setUsuariosAdmin(lista);
        } else {
          setUsuariosAdmin([]);
        }
      });
    } else {
      setUserData(null);
      setUsuariosAdmin([]);
    }
  });

  // 3. Listeners Globales (No dependen del usuario, pero se abren una sola vez)
  
  // TURNOS
  unsubTurnos = onValue(ref(db, 'turnos'), s => {
    const d = s.val();
    const ahora = new Date();
    const hoyStr = ahora.toISOString().split("T")[0];
    if (d) {
      const listaOriginal = Object.keys(d).map(k => ({ id: k, ...d[k] }));
      const listaFiltrada = listaOriginal.filter(t => {
        const [hh, mm] = t.h.split(':');
        const fechaTurno = new Date(`${t.dia}T${hh}:${mm}:00`);
        return (fechaTurno.getTime() + 600000) >= ahora.getTime() && t.dia >= hoyStr;
      });
      listaFiltrada.sort((a, b) => a.dia.localeCompare(b.dia) || a.h.localeCompare(b.h));
      setPizarron(listaFiltrada);
    } else setPizarron([]);
  });

  // INTERCAMBIOS
  unsubIntercambios = onValue(ref(db, 'intercambios_completados'), s => {
    const d = s.val();
    if (d) {
      const hoy = new Date(); hoy.setHours(0,0,0,0);
      const lista = Object.entries(d).map(([id, info]) => ({ ...info, idFirebase: id }));
      const vigentes = lista.filter(h => new Date(h.dia + "T00:00:00") >= hoy);
      vigentes.sort((a, b) => a.dia.localeCompare(b.dia) || a.h.localeCompare(b.h));
      setHistorialIntercambios(vigentes); 
    } else setHistorialIntercambios([]);
  });

  // EVENTOS Y NOTICIAS
  unsubEventos = onValue(ref(db, 'eventos'), s => {
    const d = s.val();
    setEventos(d ? Object.keys(d).map(k => ({ id: k, ...d[k] })) : []);
  });

  unsubNoticias = onValue(ref(db, 'noticias'), s => {
    const data = s.val();
    setNoticias(data ? Object.entries(data).map(([id, val]) => ({ id, ...val })).reverse() : []);
  });

  // 4. LIMPIEZA TOTAL (Al desmontar la App)
  return () => {
    unsubscribeAuth();
    if (unsubUser) unsubUser();
    if (unsubAdmin) unsubAdmin();
    if (unsubTurnos) unsubTurnos();
    if (unsubIntercambios) unsubIntercambios();
    if (unsubEventos) unsubEventos();
    if (unsubNoticias) unsubNoticias();
  };
}, []);

useEffect(() => {
  // Este evento detecta cuando el usuario vuelve a la pestaña de la app
  const handleFocus = () => {
    if (auth.currentUser) {
      // Forzamos a Firebase a que refresque el token
      auth.currentUser.getIdToken(true)
        .then(() => console.log("Sesión renovada automáticamente"))
        .catch(() => {
          // Si el token ya es irrecuperable, recargamos la web
          window.location.reload();
        });
    }
  };

  window.addEventListener('focus', handleFocus);
  return () => window.removeEventListener('focus', handleFocus);
}, []);

useEffect(() => {
  const feriadosRef = ref(db, 'config/feriados');
  const unsubscribe = onValue(feriadosRef, (snapshot) => {
    setFeriados(snapshot.val() || {});
  });
  return () => unsubscribe();
}, []);

useEffect(() => {
  const compRef = ref(db, 'competencias/encuentros');
  const unsubscribe = onValue(compRef, (snapshot) => {
    const data = snapshot.val();
    if (data) {
      const lista = Object.entries(data).map(([id, val]) => ({ id, ...val }));
      setEncuentros(lista);
    } else {
      setEncuentros([]);
    }
  });
  return () => unsubscribe();
}, []);

// =========================================================================
// SOLICITUD AUTOMÁTICA DE FECHA DE NACIMIENTO AL REFRESCAR / LOGUEARSE
// =========================================================================
useEffect(() => {
  // Verificamos que el usuario esté logueado, que hayan cargado sus datos en `userData`
  // y que NO tenga aún la fecha de nacimiento registrada en la base de datos
  if (user && userData && !userData.fechaNacimiento) {
    Swal.fire({
      title: '🎂 ¡Hola ' + (userData.nombre || 'Socio') + '!',
      html: `
        <p style="font-size: 0.85rem; color: #94a3b8; margin-bottom: 15px;">
          Para completar tu ficha de socio en el club, por favor ingresá tu <b>fecha de nacimiento</b>:
        </p>
      `,
      input: 'date',
      inputAttributes: {
        max: new Date().toISOString().split("T")[0], // No permite seleccionar fechas futuras
        required: 'required',
        style: 'background-color: #0f172a; color: #f8fafc; border: 1px solid #334155; border-radius: 12px; padding: 10px; color-scheme: dark;'
      },
      allowOutsideClick: false, // Impide que cierren el modal tocando afuera
      allowEscapeKey: false,    // Impide cerrar con la tecla Esc
      confirmButtonText: '💾 Guardar Fecha',
      confirmButtonColor: '#0891b2', // Color cyan de tu app
      customClass: {
        popup: 'rounded-3xl border border-cyan-500/30 bg-slate-900/95 text-slate-200 backdrop-blur-xl'
      },
      inputValidator: (value) => {
        if (!value) {
          return '⚠️ Debes seleccionar una fecha de nacimiento válida.';
        }
      }
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        // Guardamos directamente en la base de datos
        update(ref(db, `usuarios/${user.uid}`), {
          fechaNacimiento: result.value
        }).then(() => {
          Toast.fire({
            icon: 'success',
            title: '¡Fecha de nacimiento guardada correctamente!'
          });
        }).catch((err) => {
          console.error("Error al guardar fecha de nacimiento:", err);
        });
      }
    });
  }
}, [user, userData]);

// Escuchamos el nodo exacto: 'config/modoVacaciones'
useEffect(() => {
  const vacacionesRef = ref(db, 'config/modoVacaciones');
  const unsubscribe = onValue(vacacionesRef, (snapshot) => {
    setModoVacaciones(snapshot.val() === true);
  });
  return () => unsubscribe();
}, []);

// Constantes de verificación de Admin / Staff
const esAdminOStaff = user?.email === ADMIN_EMAIL || user?.email === STAFF_EMAIL;

const validarSesionActiva = async () => {
    // 1. Verificación básica: ¿Hay un objeto user en el motor de Firebase?
    if (!auth.currentUser) {
      alert("⚠️ Tu sesión ha expirado o se ha desconectado. Por favor, vuelve a ingresar.");
      window.location.reload();
      return false;
    }
    try {
      // 2. Verificación profunda: ¿Sigue siendo válida la llave (token)?
      await auth.currentUser.getIdToken(true);
      return true;
    } catch (e) {
      // Si el token falló (ej: el usuario cambió de contraseña o expiró hace mucho)
      alert("⚠️ Error de conexión con tu cuenta. Refrescando...");
      window.location.reload();
      return false;
    }
  };
  
  const provider = new GoogleAuthProvider();

const login = async () => {
  try {
    await signInWithPopup(auth, provider);
  } catch (error) {
    if (
      error.code === 'auth/popup-blocked' || 
      error.code === 'auth/popup-closed-by-user'
    ) {
      console.warn("Popup bloqueado o cerrado. Reintentando con redirección...");
      await signInWithRedirect(auth, provider);
    } else {
      console.error("Error al iniciar sesión:", error);
    }
  }
};

  const formatearFechaPizarron = (fStr) => {
    const f = new Date(fStr + "T00:00:00");
    return `${diasSemana[f.getDay()]} ${f.getDate()}`;
  };

  const getFechaArgentina = () => {
  // Forzamos el idioma en-US y la zona horaria de Bs As
  const str = new Date().toLocaleString("en-US", { timeZone: "America/Argentina/Buenos_Aires" });
  return new Date(str);
};

  const puedeTomarNivel = (n) => (nivelUser === "Negro") || (nivelUser === "Violeta" && (n === "Violeta" || n === "Azul")) || (nivelUser === "Azul" && n === "Azul");


// Configuración de un Toast reutilizable de SweetAlert2
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  }
});

const soltarTurno = async (e) => {
  e.preventDefault();

  // --- MANTENEMOS TODAS TUS RESTRICCIONES ORIGINALES ---
  const keyFeriado = fechaSel.replace(/-/g, "");
  if (feriados && feriados[keyFeriado]) {
    Swal.fire({
      icon: 'warning',
      title: 'Es feriado',
      text: 'No se puede liberar, fijarse si hay actividad programada.',
      confirmButtonColor: '#3085d6'
    });
    return;
  }
  const sesionOk = await validarSesionActiva();
  if (!sesionOk) return;

  if (!user || !turnoElegido || !fechaSel) return;

  if (!userData?.aprobado && user?.email !== ADMIN_EMAIL) {
    Swal.fire({
      icon: 'info',
      title: '¡Hola!',
      text: 'Tu cuenta está en proceso de aprobación.',
      confirmButtonColor: '#3085d6'
    });
    return;
  }

  if (userData?.bloqueado) {
    Swal.fire({
      icon: 'error',
      title: 'Cuenta suspendida',
      text: `Motivo: ${userData.motivoBloqueo}`,
      confirmButtonColor: '#d33'
    });
    return;
  }

  if (user?.email !== ADMIN_EMAIL && !esFechaValida(fechaSel)) {
    Toast.fire({
      icon: 'warning',
      title: 'Solo puedes liberar turnos que pertenezcan al mes en curso.'
    });
    return;
  }

  const diaTexto = diasSemana[new Date(fechaSel + "T00:00:00").getDay()];
  const turnosDelUser = userData?.turnosAsignados || [];
  const tienePermiso = turnosDelUser.some(t => t.dia === diaTexto && t.h === turnoElegido.h && t.s === turnoElegido.s);
  
  if (!tienePermiso && user.email !== ADMIN_EMAIL) {
    Swal.fire({
      icon: 'warning',
      title: 'Sin permiso',
      text: 'No puedes liberar este turno. No está en tu lista de turnos asignados.',
      confirmButtonColor: '#3085d6'
    });
    return;
  }

  if (user?.email !== ADMIN_EMAIL && user?.email !== STAFF_EMAIL) {
    const yaEstaPublicado = pizarron.some(t => 
      t.dia === fechaSel && 
      t.h === turnoElegido.h && 
      t.s === turnoElegido.s &&
      t.uidOriginal === user.uid
    );

    if (yaEstaPublicado) {
      Toast.fire({
        icon: 'info',
        title: 'Ya tienes este turno publicado en el Pizarrón.'
      });
      return;
    }
  }

  if (user?.email !== ADMIN_EMAIL && user?.email !== STAFF_EMAIL) {
    const yaEnHistorial = historialIntercambios.some(i => 
      i.dia === fechaSel && 
      i.h === turnoElegido.h && 
      i.s === turnoElegido.s &&
      i.uidOriginal === user.uid
    );

    if (yaEnHistorial) {
      Toast.fire({
        icon: 'info',
        title: 'Ya liberaste este turno y fue intercambiado anteriormente.'
      });
      return;
    }
  }

  const ahora = getFechaArgentina();
  const [h, m] = turnoElegido.h.split(':');

  // Creamos la fecha del turno
  const fT = new Date(fechaSel + "T00:00:00"); 
  fT.setHours(parseInt(h), parseInt(m), 0, 0); 

  // Calculamos la diferencia real en minutos
  const diferenciaMinutos = (fT.getTime() - ahora.getTime()) / (1000 * 60);

  // 1. Validación de tiempo pasado
  if (fT < ahora) {
    Toast.fire({
      icon: 'warning',
      title: 'No puedes soltar un turno que ya pasó.'
    });
    return;
  }

  // 2. Determinamos si se libera fuera de término (menos de 60 min)
  const fueraDeTermino = diferenciaMinutos < 60 && user?.email !== ADMIN_EMAIL && user?.email !== STAFF_EMAIL;

  // Reemplazo de window.confirm
  const result = await Swal.fire({
    title: fueraDeTermino ? '⚠️ ATENCIÓN' : '¿Liberar turno?',
    text: fueraDeTermino
      ? `Faltan menos de 60 minutos para el turno (${Math.round(diferenciaMinutos)} min). Se publicará en el Pizarrón pero NO recibirás crédito ni se saldará deuda. ¿Deseas liberarlo de todas formas?`
      : `¿Estás seguro de liberar el turno del ${fechaSel} a las ${turnoElegido.h}?`,
    icon: fueraDeTermino ? 'warning' : 'question',
    showCancelButton: true,
    confirmButtonColor: fueraDeTermino ? '#d33' : '#3085d6',
    cancelButtonColor: '#6e7881',
    confirmButtonText: 'Sí, liberar',
    cancelButtonText: 'Cancelar'
  });

  // --- COMIENZA LA OPERACIÓN DE BASE DE DATOS MEJORADA ---
  if (result.isConfirmed) {
    const ahoraTimestamp = ahora.getTime();
    const userRef = ref(db, `usuarios/${user.uid}`);
    const nuevoTurnoRef = push(ref(db, 'turnos'));

    try {
      // 1. Transacción de Créditos/Deudas
      await runTransaction(userRef, (currentData) => {
        if (!currentData) return currentData;

        if (!currentData.historial_movimientos) currentData.historial_movimientos = {};

        if (fueraDeTermino) {
          // LIBERACIÓN FUERA DE TÉRMINO: No suma crédito ni borra deuda, solo registra la acción en el historial
          currentData.historial_movimientos[`mov_${ahoraTimestamp}`] = {
            fecha: ahoraTimestamp,
            tipo: 'Aviso',
            cantidad: 0,
            motivo: `Liberó fuera de término: ${fechaSel} ${turnoElegido.h} (Sin crédito)`
          };
        } else {
          // LIBERACIÓN EN REGLA (CON MÁS DE 60 MIN)
          if ((currentData.realDeuda || 0) > 0) {
            // Si tiene deuda, eliminamos la primera entrada de la lista
            if (currentData.deudas) {
              const deudasKeys = Object.keys(currentData.deudas);
              const primerId = deudasKeys[0];
              delete currentData.deudas[primerId];
            }
            // Bajamos el contador de deuda (mínimo 0)
            currentData.realDeuda = Math.max(0, (currentData.realDeuda || 1) - 1);
            
            // Registro en Historial
            currentData.historial_movimientos[`mov_${ahoraTimestamp}`] = {
              fecha: ahoraTimestamp,
              tipo: 'CARGA',
              cantidad: 1,
              motivo: `Liberó: ${fechaSel} ${turnoElegido.h} (Saldó deuda)`
            };
          } else {
            // Si no tiene deuda, le damos un crédito
            if (!currentData.detalles_creditos) currentData.detalles_creditos = {};
            currentData.detalles_creditos[`cred_${ahoraTimestamp}`] = { 
              otorgado: ahoraTimestamp, 
              vence: ahoraTimestamp + (10 * 24 * 60 * 60 * 1000) 
            };

            // Registro en Historial
            currentData.historial_movimientos[`mov_${ahoraTimestamp}`] = {
              fecha: ahoraTimestamp,
              tipo: 'CARGA',
              cantidad: 1,
              motivo: `Liberó: ${fechaSel} ${turnoElegido.h} (Crédito +1)`
            };
          }
        }
        return currentData;
      });

      // 2. Publicamos el turno en el Pizarrón
      await set(nuevoTurnoRef, { 
        ...turnoElegido, 
        dia: fechaSel, 
        nombre: userData?.nombre || user.displayName, 
        uidOriginal: user.uid 
      });

      if (fueraDeTermino) {
        Swal.fire({
          icon: 'info',
          title: 'Turno liberado',
          text: 'Se publicó en el Pizarrón, pero no sumó crédito por liberarse con menos de 60 min de anticipación.',
          confirmButtonColor: '#3085d6'
        });
      } else {
        Toast.fire({
          icon: 'success',
          title: 'Turno liberado con éxito'
        });
      }
    } catch (error) {
      console.error("Error en liberación atómica:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error de conexión',
        text: 'Hubo un problema de conexión. El turno NO se liberó.',
        confirmButtonColor: '#d33'
      });
    }
  }
};

   const tomarTurno = async (t) => {
  const sesionOk = await validarSesionActiva();
  if (!sesionOk) return;

  // 1. Traducimos la fecha "2026-02-27" a día de la semana
  const dias = ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"];
  const fechaObjeto = new Date(t.dia.replace(/-/g, '\/')); 
  const nombreDiaPizarron = dias[fechaObjeto.getDay()]; // Esto dará "Viernes"

  // 2. Vemos si el socio que quiere comprar ya tiene un turno fijo los Viernes 20:00hs
  const tieneEseHorarioFijo = userData?.turnosAsignados?.some(
    fijo => fijo.dia === nombreDiaPizarron && fijo.h === t.h
  );

  // 3. El Parche Antirulo:
  // Si tiene el horario fijo (Viernes 20:00) 
  // Y el que soltó el turno NO es él mismo (comparamos contra "clJk0P...")
  if (tieneEseHorarioFijo && t.uidOriginal !== user.uid) {
    Swal.fire({
      icon: 'warning',
      title: 'Turno no disponible',
      text: `Ya tienes un turno fijo los ${nombreDiaPizarron} a las ${t.h}hs.`,
      confirmButtonColor: '#3085d6'
    });
    return;
  }
  
  if (!userData?.aprobado && user?.email !== ADMIN_EMAIL) {
    Swal.fire({
      icon: 'info',
      title: '¡Hola!',
      text: 'Tu cuenta está en proceso de aprobación.',
      confirmButtonColor: '#3085d6'
    });
    return;
  }

  if (userData?.bloqueado) {
    Swal.fire({
      icon: 'error',
      title: 'Cuenta suspendida',
      text: 'Tu cuenta está suspendida.',
      confirmButtonColor: '#d33'
    });
    return;
  }

  const ahora = new Date().getTime();
  const creditosVigentes = userData?.detalles_creditos 
    ? Object.entries(userData.detalles_creditos).filter(([id, c]) => c.vence > ahora)
    : [];

  if (!user) return login();

  if (!puedeTomarNivel(t.n)) {
    Toast.fire({
      icon: 'warning',
      title: 'Turno de mayor nivel, tomar otro color'
    });
    return;
  }
  
  const esMio = t.uidOriginal === user.uid;
  const tieneCredito = creditosVigentes.length > 0;

// =========================================================================
  // VALORES DINÁMICOS DESDE EL ESTADO `preciosCuotas`
  // =========================================================================
  const valInvitado = (preciosCuotas?.invitado ?? 12000).toLocaleString('es-AR');
  const valSocio = (preciosCuotas?.socio ?? 9000).toLocaleString('es-AR');
  const aliasProfe = preciosCuotas?.alias || 'alejomartin';

  // Configuración dinámica del modal de confirmación
  const tituloModal = esMio 
    ? '¿Recuperar tu turno?' 
    : (tieneCredito ? '¿Usar crédito?' : '¿Tomar este turno?');

  const mensajeModal = esMio 
    ? 'Se usará 1 crédito disponible para recuperar tu turno.' 
    : (tieneCredito 
        ? 'Se descontará 1 crédito de tu cuenta.' 
        : `Costo $${valInvitado} / $${valSocio} abonados (transferir al profe alias ${aliasProfe} y enviar comprobante para reconfirmar)`);

  // Reemplazo de window.confirm por Swal.fire
  const result = await Swal.fire({
    title: tituloModal,
    text: mensajeModal,
    icon: tieneCredito || esMio ? 'question' : 'info',
    showCancelButton: true,
    confirmButtonColor: '#28a745',
    cancelButtonColor: '#6e7881',
    confirmButtonText: 'Sí, tomar turno',
    cancelButtonText: 'Cancelar'
  });

  if (result.isConfirmed) {
    const turnoRef = ref(db, `turnos/${t.id}`);

    try {
      const resultTx = await runTransaction(turnoRef, (currentData) => {
        if (currentData === null) return; // Si alguien ya lo borró, abortamos
        return null; // Reservamos el turno borrándolo del pizarrón
      });

      if (resultTx.committed) {
        // 2. EL TURNO YA ES NUESTRO. Ahora aplicamos todos los cambios financieros atómicamente
        const actualizaciones = {};
        const fechaTexto = new Date().toLocaleString();

        // A. Preparamos el registro del intercambio
        const nuevoIntercambioKey = push(ref(db, 'intercambios_completados')).key;
        actualizaciones[`intercambios_completados/${nuevoIntercambioKey}`] = { 
          ...t, 
          quienTomo: userData?.nombre || user.displayName, 
          uidTomo: user.uid, 
          fechaAccion: fechaTexto 
        };

        // B. Lógica de Cobro (Crédito o Deuda)
        if (tieneCredito) {
          const idCreditoABorrar = creditosVigentes[0][0];
          // Borramos el ítem del crédito
          actualizaciones[`usuarios/${user.uid}/detalles_creditos/${idCreditoABorrar}`] = null;
          
          // Historial de Movimientos
          actualizaciones[`usuarios/${user.uid}/historial_movimientos/mov_${ahora}`] = {
            fecha: ahora,
            tipo: 'CONSUMO',
            cantidad: 1,
            motivo: `Tomó turno: ${t.dia} ${t.h}hs`
          };
        } else {
          // Generamos la Deuda
          const nuevaDeudaKey = push(ref(db, `usuarios/${user.uid}/deudas`)).key;
          actualizaciones[`usuarios/${user.uid}/deudas/${nuevaDeudaKey}`] = { f: fechaTexto, t: t.h };
          
          // Actualizamos el contador realDeuda (Sincronización total)
          actualizaciones[`usuarios/${user.uid}/realDeuda`] = (userData.realDeuda || 0) + 1;
          
          // Historial de Movimientos
          actualizaciones[`usuarios/${user.uid}/historial_movimientos/mov_${ahora}`] = {
            fecha: ahora,
            tipo: 'CONSUMO',
            cantidad: 1,
            motivo: `Tomó turno (Deuda): ${t.dia} ${t.h}hs`
          };
        }

  // 3. Ejecutamos todas las actualizaciones en un solo viaje al servidor
await update(ref(db), actualizaciones);

// Modal de éxito con mensaje interno y botones
Swal.fire({
  icon: 'success',
  title: '¡Turno confirmado!',
  width: '85%',
  showConfirmButton: false, // Ocultamos el botón por defecto para usar nuestro grupo
  html: `
    <!-- TEXTO DE DETALLE DE LA RESERVA -->
    <p style="font-size: 0.95rem; color: #475569; margin-bottom: 15px;">
      Reservaste para el <b>${t.dia}</b> a las <b>${t.h}hs</b> en <b>${t.s}</b>.
    </p>

    <div style="display: flex; flex-direction: column; gap: 10px;">
      
      <!-- BOTÓN GOOGLE -->
      <button 
        id="btn-google-cal" 
        style="width: 100%; padding: 12px; background-color: #4285F4; color: white; border: none; border-radius: 10px; font-weight: bold; font-size: 0.9rem; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px;"
      >
        <span>📅</span> Agregar a Google Calendar
      </button>

      <!-- BOTÓN APPLE -->
      <button 
        id="btn-apple-cal" 
        style="width: 100%; padding: 12px; background-color: #000000; color: white; border: none; border-radius: 10px; font-weight: bold; font-size: 0.9rem; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px;"
      >
        <span>🍏</span> Agregar a Apple Calendar
      </button>

      <!-- BOTÓN CERRAR VENTANA -->
      <button 
        id="btn-cerrar-modal" 
        style="width: 100%; padding: 12px; background-color: #6e7881; color: white; border: none; border-radius: 10px; font-weight: bold; font-size: 0.9rem; cursor: pointer; margin-top: 5px;"
      >
        Cerrar ventana
      </button>

    </div>
  `,
  didOpen: () => {
    document.getElementById('btn-google-cal').addEventListener('click', () => {
      abrirCalendario('google', t);
    });

    document.getElementById('btn-apple-cal').addEventListener('click', () => {
      abrirCalendario('apple', t);
    });

    document.getElementById('btn-cerrar-modal').addEventListener('click', () => {
      Swal.close();
    });
  }
});
      } else {
        Swal.fire({
          icon: 'error',
          title: '¡Lo sentimos!',
          text: 'Otro socio acaba de tomar este turno.',
          confirmButtonColor: '#3085d6'
        });
      }
    } catch (error) {
      console.error("Error crítico en tomarTurno:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error de conexión',
        text: 'Hubo un error de conexión. El turno no pudo ser procesado.',
        confirmButtonColor: '#d33'
      });
    }
  }
};

    const agrupados = historialIntercambios
    .filter(h => {
      if (filtroHistorial === "Todos") return true;
      
      const hoy = new Date(); hoy.setHours(0,0,0,0);
      const manana = new Date(hoy); manana.setDate(manana.getDate() + 1);
      const fechaTurno = new Date(h.dia + "T00:00:00");

      if (filtroHistorial === "Hoy") return fechaTurno.getTime() === hoy.getTime();
      if (filtroHistorial === "Mañana") return fechaTurno.getTime() === manana.getTime();
      return true;
    })
    .reduce((g, h) => {
      if (!g[h.dia]) g[h.dia] = [];
      g[h.dia].push(h);
      return g;
    }, {});


  const totalSocios = usuariosAdmin.length;
  const totalNegro = usuariosAdmin.filter(u => u.nivel === "Negro").length;
  const totalVioleta = usuariosAdmin.filter(u => u.nivel === "Violeta").length;
  const totalAzul = usuariosAdmin.filter(u => u.nivel === "Azul").length;
const misIntercambios = historialIntercambios.filter(h => h.uidTomo === user?.uid);
const crearEvento = () => {
  const titulo = window.prompt("Nombre del evento:");
  const cupo = window.prompt("Cupo máximo (número):");
  const precio = window.prompt("Costo de inscripción (ej: 5000 o Gratis):"); // Nuevo campo
  
  if (titulo && cupo && precio) {
    push(ref(db, 'eventos'), { 
      titulo, 
      cupo: parseInt(cupo), 
      precio: precio, // Se guarda como texto por si ponés "Gratis" o "$5000"
      inscriptos: {} 
    });
  }
};


const inscribirseAEvento = async (evento) => {
  const sesionOk = await validarSesionActiva();
  if (!sesionOk) return;

  if (!userData?.aprobado && user?.email !== ADMIN_EMAIL) {
    Swal.fire({
      icon: 'info',
      title: '¡Hola!',
      text: 'Tu cuenta está en proceso de aprobación.',
      confirmButtonColor: '#3085d6'
    });
    return;
  }
  
  if (userData?.bloqueado) {
    Swal.fire({
      icon: 'error',
      title: 'Cuenta suspendida',
      text: `Motivo: ${userData.motivoBloqueo}`,
      confirmButtonColor: '#d33'
    });
    return;
  }

  // --- NUEVA VALIDACIÓN: EVENTO CERRADO ---
  if (evento.cerrado) {
    Swal.fire({
      icon: 'warning',
      title: 'Inscripción cerrada',
      text: 'La inscripción para este evento ha sido cerrada por el administrador.',
      confirmButtonColor: '#3085d6'
    });
    return;
  }

  const inscriptosArray = evento.inscriptos ? Object.values(evento.inscriptos) : [];
  
  const yaInscripto = inscriptosArray.some(i => i.uid === user.uid);
  if (yaInscripto) {
    Toast.fire({
      icon: 'info',
      title: 'Ya estás inscripto en este evento.'
    });
    return;
  }

  if (inscriptosArray.length >= evento.cupo) {
    Toast.fire({
      icon: 'warning',
      title: 'Cupo lleno.'
    });
    return;
  }

  // --- MENSAJE DE COMPROMISO CON SWEETALERT2 ---
  const result = await Swal.fire({
    title: '⚠️ COMPROMISO DE ASISTENCIA',
    text: `Al anotarte, asumes el compromiso de asistir. ¿Confirmas tu inscripción para "${evento.ev_titulo || evento.titulo}"?`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#28a745',
    cancelButtonColor: '#6e7881',
    confirmButtonText: 'Sí, confirmar inscripción',
    cancelButtonText: 'Cancelar'
  });

  if (result.isConfirmed) {
    const nuevoInscripto = {
      uid: user.uid,
      nombre: userData?.nombre || user.displayName,
      fecha: new Date().toLocaleString()
    };

    try {
      await push(ref(db, `eventos/${evento.id}/inscriptos`), nuevoInscripto);
      
      Toast.fire({
        icon: 'success',
        title: '¡Inscripción exitosa! Te esperamos.'
      });
    } catch (error) {
      console.error("Error al inscribir en evento:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error de conexión',
        text: 'Error al inscribirse. Inténtalo nuevamente.',
        confirmButtonColor: '#d33'
      });
    }
  }
};

const agregarInvitadoManual = (eventoId) => {
  const nombreInvitado = window.prompt("Nombre y Apellido del invitado:");
  if (!nombreInvitado || nombreInvitado.trim() === "") return;

  const nuevoInvitado = {
    uid: "manual_" + new Date().getTime(),
    nombre: nombreInvitado + " (Invitado)",
    tipo: "manual",
    fecha: new Date().toLocaleString()
  };

  push(ref(db, `eventos/${eventoId}/inscriptos`), nuevoInvitado)
    .then(() => alert("Invitado agregado correctamente."))
    .catch(() => alert("Error al cargar invitado."));
};

const toggleCerrarEvento = (evento) => {
  const nuevoEstado = !evento.cerrado;
  const msg = nuevoEstado 
    ? "¿Cerrar inscripciones? Nadie más podrá anotarse aunque haya cupo." 
    : "¿Reabrir inscripciones?";

  if (window.confirm(msg)) {
    update(ref(db, `eventos/${evento.id}`), { cerrado: nuevoEstado });
  }
};

const toggleBloqueo = (u) => {
  if (u.bloqueado) {
    if (window.confirm(`¿Desbloquear a ${u.nombre}?`)) {
      update(ref(db, `usuarios/${u.uid}`), { bloqueado: false, motivoBloqueo: null });
    }
  } else {
    const razon = window.prompt(`¿Razón del bloqueo para ${u.nombre}?`);
    if (razon) {
      update(ref(db, `usuarios/${u.uid}`), { bloqueado: true, motivoBloqueo: razon });
    }
  }
};

const esFechaValida = (fechaTurno) => {
  if (!fechaTurno) return false;
  
  const hoy = new Date();
  // Forzamos el parseo de la fecha (YYYY-MM-DD)
  const [anio, mes, dia] = fechaTurno.split('-').map(Number);
  const fechaT = new Date(anio, mes - 1, dia);

  // Verificamos que el mes y el año coincidan con los actuales
  return fechaT.getMonth() === hoy.getMonth() && 
         fechaT.getFullYear() === hoy.getFullYear();
};

const manualLimpiezaVencidos = () => {
  // Verificamos que 'usuariosAdmin' (tu variable de estado) tenga datos
  if (!usuariosAdmin || !db) {
    alert("No hay datos cargados para limpiar.");
    return;
  }

  const ahora = new Date().getTime();
  const updates = {};
  let contadorBorrados = 0;

  // Recorremos la variable 'usuariosAdmin' que contiene la lista de socios
  usuariosAdmin.forEach(u => {
    if (u.detalles_creditos) {
      Object.keys(u.detalles_creditos).forEach(key => {
        const credito = u.detalles_creditos[key];
        
        // Si el crédito venció, lo marcamos para borrar en la carpeta 'usuarios'
        if (credito.vence && credito.vence < ahora) {
          // IMPORTANTE: Aquí usamos la ruta de la carpeta de Firebase
          updates[`usuarios/${u.uid}/detalles_creditos/${key}`] = null;
          contadorBorrados++;
        }
      });
    }
  });

  if (contadorBorrados > 0) {
    if (window.confirm(`Se encontraron ${contadorBorrados} créditos vencidos. ¿Deseas eliminarlos de la base de datos?`)) {
      // Aplicamos los cambios en el nodo raíz para que afecte a la carpeta 'usuarios'
      update(ref(db), updates)
        .then(() => alert(`✅ Limpieza exitosa: se eliminaron ${contadorBorrados} créditos de la carpeta usuarios.`))
        .catch(err => {
          console.error("Error en limpieza:", err);
          alert("Hubo un error al intentar borrar los datos.");
        });
    }
  } else {
    alert("✨ No hay créditos vencidos. La carpeta usuarios está al día.");
  }
};

const publicarNoticia = () => {
    if (!nuevaNoticia.titulo || !nuevaNoticia.contenido) {
      alert("Por favor completa título y contenido");
      return;
    }
    const noticiaRef = ref(db, 'noticias');
    push(noticiaRef, {
      titulo: nuevaNoticia.titulo,
      contenido: nuevaNoticia.contenido,
      fecha: new Date().toLocaleDateString()
    }).then(() => {
      setNuevaNoticia({ titulo: '', contenido: '' });
      alert("¡Noticia publicada con éxito!");
    });
  };

  const borrarNoticia = (id) => {
    if (window.confirm("¿Estás seguro de que querés eliminar esta noticia?")) {
      remove(ref(db, `noticias/${id}`))
        .then(() => alert("Noticia eliminada"))
        .catch((error) => console.error("Error al borrar:", error));
    }
  };

  const sumarPodio = (uid, liga, puesto, cantidad) => {
    // liga: 'tmt', 'fetemba' o 'fatm' | puesto: 'p1', 'p2' o 'p3'
    const podioRef = ref(db, `usuarios/${uid}/podios/${liga}/${puesto}`);
    
    runTransaction(podioRef, (valorActual) => {
        const nuevoValor = (valorActual || 0) + cantidad;
        return nuevoValor < 0 ? 0 : nuevoValor;
    });
};

const usuariosProcesados = useMemo(() => {
  // 1. Primero procesamos la lista para calcular el saldo de cada uno
  const listaConSaldos = (usuariosAdmin || []).map(u => {
    const movimientos = u.cuenta_corriente ? Object.values(u.cuenta_corriente) : [];
    const saldoCalculado = movimientos.reduce((acc, curr) => acc + (curr.monto || 0), 0);
    
    return {
      ...u,
      saldoCC: saldoCalculado 
    };
  });

  // 2. Luego filtramos y ordenamos sobre esa lista ya procesada
  return listaConSaldos
    .filter(u => (u.nombre || "").toLowerCase().includes(busquedaPlanilla.toLowerCase()))
    .sort((a, b) => {
      if (ordenPlanilla === "mayor_credito") {
        return (b.realCreditos || 0) - (a.realCreditos || 0);
      }
      if (ordenPlanilla === "mayor_deuda") {
        return (b.realDeuda || 0) - (a.realDeuda || 0);
      }
      return (a.nombre || "").localeCompare(b.nombre || "");
    });
}, [usuariosAdmin, busquedaPlanilla, ordenPlanilla]); // <--- ESTE CIERRE ES CLAVE

  // --- FUNCIONES DE ADMINISTRACIÓN FINANCIERA ---

// 1. Crear socio manual (Ficha de Excel)
const crearSocioManual = () => {
  const nombre = window.prompt("Nombre del socio (como figura en tu Excel):");
  if (!nombre || nombre.trim() === "") return;
  const manualId = `manual_${Date.now()}`;
  const nuevoSocio = {
    uid: manualId,
    nombre: nombre.trim(),
    isManual: true,
    realDeuda: 0,
    nivel: "Azul",
    fechaAlta: new Date().getTime(),
    cuenta_corriente: {}
  };
  set(ref(db, `usuarios/${manualId}`), nuevoSocio)
    .then(() => alert("✅ Ficha manual creada exitosamente."));
};

// 2. Vincular Ficha de Excel con Cuenta Real de Google
const vincularCuentas = (manualId, realUid) => {
  if (window.confirm("¿Confirmas la vinculación? Los datos del Excel pasarán a la cuenta de Google y la ficha manual se borrará.")) {
    const manualRef = ref(db, `usuarios/${manualId}`);
    onValue(manualRef, (snapshot) => {
      const datos = snapshot.val();
      if (!datos) return;
      
      const actualizaciones = {
        cuenta_corriente: datos.cuenta_corriente || {},
        realDeuda: datos.realDeuda || 0,
        nivel: datos.nivel || "Azul"
      };

      update(ref(db, `usuarios/${realUid}`), actualizaciones)
        .then(() => {
          remove(manualRef);
          alert("¡Cuentas vinculadas con éxito!");
        });
   }, { onlyOnce: true });
  }
};

// 3. Generar cobros mensuales masivos - VERSIÓN CORREGIDA (F-09)
const generarCuotasDelMes = async () => {
  const mesActual = new Date().toLocaleString('es-AR', { month: 'long', year: 'numeric' });
  
  if (!window.confirm(`¿Generar deudas de ${mesActual} para todos los socios activos?`)) return;

  const ahora = new Date().getTime();
  const promesas = [];
  let contadorGeneradas = 0;

  // Usamos usuariosAdmin que ya es tu array filtrado de usuarios
  usuariosAdmin.forEach(u => {
    const cantTurnos = u.turnosAsignados?.length || 0;
    
    if (cantTurnos > 0) {
      const montoCuota = preciosCuotas[`p${cantTurnos}`] || 0;
      
      if (montoCuota > 0) {
        // --- PREVENCIÓN DE DUPLICADOS (Crucial) ---
        // Revisamos si en la cuenta_corriente ya existe el concepto de este mes
        const movimientos = u.cuenta_corriente ? Object.values(u.cuenta_corriente) : [];
        const yaTieneCuota = movimientos.some(m => m.concepto === `Cuota Mensual - ${mesActual}`);

        if (!yaTieneCuota) {
          const nuevaCuotaRef = push(ref(db, `usuarios/${u.uid}/cuenta_corriente`));
          
          // Creamos una actualización atómica para el usuario
          // Esto asegura que la cuota se cargue correctamente
          const promesa = set(nuevaCuotaRef, {
            fecha: ahora,
            concepto: `Cuota Mensual - ${mesActual}`,
            monto: -montoCuota,
            tipo: 'CUOTA'
          });
          
          promesas.push(promesa);
          contadorGeneradas++;
        }
      }
    }
  });

  if (promesas.length === 0) {
    alert("ℹ️ No se generaron cuotas nuevas (ya estaban cargadas o no hay socios con turnos).");
    return;
  }

  try {
    // Esperamos a que todas las escrituras terminen
    await Promise.all(promesas);
    alert(`💰 Proceso finalizado. Se cargaron ${contadorGeneradas} cuotas con éxito.`);
  } catch (error) {
    console.error("Error en generarCuotasDelMes:", error);
    alert("❌ Error crítico: Algunas cuotas podrían no haberse cargado. Revisar consola.");
  }
};

async function borrarNodos60Dias() {
  const confirmacion = confirm("¿Seguro de eliminar los turnos e intercambios con más de 60 días?");
  if (!confirmacion) return;

  const db = getDatabase();

  // Calcular fecha de hace 60 días en formato YYYY-MM-DD
  const fechaLimite = new Date();
  fechaLimite.setDate(fechaLimite.getDate() - 60);
  const limiteFormateado = fechaLimite.toISOString().split('T')[0];

  const nodos = ["turnos", "intercambios_completados"];
  let eliminadosTotales = 0;

  try {
    for (const nodo of nodos) {
      const consulta = query(ref(db, nodo), orderByChild("dia"), endAt(limiteFormateado));
      const snapshot = await get(consulta);

      if (snapshot.exists()) {
        const promesasDeBorrado = [];
        snapshot.forEach((childSnapshot) => {
          promesasDeBorrado.push(remove(childSnapshot.ref));
          eliminadosTotales++;
        });

        await Promise.all(promesasDeBorrado);
      }
    }

    alert(`Limpieza exitosa. Se borraron ${eliminadosTotales} registros con más de 60 días.`);
  } catch (error) {
    console.error("Error al eliminar los datos:", error);
    alert("Ocurrió un error al ejecutar la limpieza.");
  }
}

const resetearCuentaIndividual = (uid, nombre) => {
  if (window.confirm(`⚠️ ¿Borrar todo el historial de dinero de ${nombre}?`)) {
    // Esto borra la carpeta de movimientos de ese UID específico
    set(ref(db, `usuarios/${uid}/cuenta_corriente`), {}) 
      .then(() => alert("✅ Cuenta reseteada."));
  }
};

// 2. Resetear TODAS las cuentas de la App (¡Cuidado!)
const resetearTodasLasCuentas = () => {
  const confirm1 = window.confirm("🚨 PELIGRO: Vas a borrar las cuentas corrientes de TODOS los socios (manuales y reales).");
  if (confirm1) {
    const confirm2 = window.prompt("Para confirmar esta acción destructiva, escribí 'BORRAR TODO' (en mayúsculas):");
    if (confirm2 === "BORRAR TODO") {
      usuariosAdmin.forEach(u => {
        set(ref(db, `usuarios/${u.uid}/cuenta_corriente`), {});
      });
      alert("💥 Todas las cuentas han sido reseteadas a $0.");
    }
  }
};

const cargarCargoManual = (uid, nombre) => {
  const monto = parseFloat(window.prompt(`Monto del CARGO para ${nombre} (sin signo menos):`));
  if (isNaN(monto) || monto <= 0) return;

  const motivo = window.prompt("Motivo del cargo (Ej: Inscripción Torneo, Buffet, etc.):");
  if (!motivo || motivo.trim() === "") return;

  if (window.confirm(`¿Confirmas cargar $${monto} por "${motivo}" a la cuenta de ${nombre}?`)) {
    push(ref(db, `usuarios/${uid}/cuenta_corriente`), {
      fecha: Date.now(),
      concepto: motivo.trim(),
      monto: -monto, // Se guarda como negativo porque es una deuda
      tipo: 'CARGO_MANUAL'
    }).then(() => alert("✅ Cargo efectuado."));
  }
};

const abrirCalendario = (tipo, turno) => {
  const [hh, mm] = turno.h.split(':');
  
  // Fecha y hora local
  const fechaInicio = new Date(`${turno.dia}T${hh}:${mm}:00`);
  const fechaFin = new Date(fechaInicio.getTime() + 60 * 60 * 1000);

  const formatoFecha = (date) => date.toISOString().replace(/-|:|\.\d\d\d/g, "");

  const titulo = encodeURIComponent(`Entrenamiento Tenis de mesa - Astros (${turno.s})`);
  const descripcion = encodeURIComponent(`Turno reservado en Club Astros.`);
  const ubicacion = encodeURIComponent(`Club Astros - Sede ${turno.s}`);

  if (tipo === 'google') {
    const url = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${titulo}&dates=${formatoFecha(fechaInicio)}/${formatoFecha(fechaFin)}&details=${descripcion}&location=${ubicacion}`;
    window.open(url, '_blank');
  } 
  
  if (tipo === 'apple') {
    // Generamos el archivo .ics en formato Data URI para que Safari de iOS lo reconozca como un evento nativo
    const icsData = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Astros Club//NONSGML v1.0//EN',
      'BEGIN:VEVENT',
      `SUMMARY:${decodeURIComponent(titulo)}`,
      `DESCRIPTION:${decodeURIComponent(descripcion)}`,
      `LOCATION:${decodeURIComponent(ubicacion)}`,
      `DTSTART:${formatoFecha(fechaInicio)}`,
      `DTEND:${formatoFecha(fechaFin)}`,
      'END:VEVENT',
      'END:VCALENDAR'
    ].join('\n');

    // Convertimos a base64 o data URI para iOS Safari
    const blob = new Blob([icsData], { type: 'text/calendar;charset=utf-8;' });
    const blobUrl = window.URL.createObjectURL(blob);
    
    // En iOS redirigimos la ventana actual o abrimos una nueva con el blob
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = `turno-astros-${turno.dia}.ics`;
    a.target = '_blank';
    
    // Evento sintáctico para evitar bloqueo de popups en Safari
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => window.URL.revokeObjectURL(blobUrl), 200);
  }
};

const mostrarReglas = () => {
  const htmlReglas = `
  <style>
      /* Estilos para forzar que el scroll sea super visible */
      .contenedor-reglas-scroll::-webkit-scrollbar {
        width: 8px;
      }
      .contenedor-reglas-scroll::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 4px;
      }
      .contenedor-reglas-scroll::-webkit-scrollbar-thumb {
        background: #06b6d4; /* Color Cyan brillante */
        border-radius: 4px;
      }
    </style>
    <div class="contenedor-reglas-scroll" style="text-align: left; font-size: 0.85rem; line-height: 1.5; color: #333; max-height: 48vh; overflow-y: auto; padding-right: 8px;">
      
      <h4 style="color: #0056b3; margin-top: 0; margin-bottom: 6px;">1. Liberación de Turnos (Soltar Turno)</h4>
      <ul style="padding-left: 18px; margin-bottom: 12px;">
        <li><b>¿Cuándo puedo liberar?</b> Podés liberar únicamente los turnos asignados a tu cuenta dentro del mes en curso.</li>
        <li><b>Liberación con más de 60 minutos de anticipación:</b> El turno se publicará en el Pizarrón. Si tenías una deuda pendiente, se saldará automáticamente. De lo contrario, se te otorgará 1 crédito (con validez de 10 días corridos para tomar un turno del pizarrón).</li>
        <li><b>Liberación fuera de término (menos de 60 minutos antes):</b> El turno igualmente se publicará en el Pizarrón para que otro socio pueda aprovecharlo, pero NO generará crédito ni cancelará deudas.</li>
        <li><b>Excepciones:</b> No se pueden liberar turnos en días feriados (fijarse programación especial) ni turnos que ya hayan transcurrido.</li>
      </ul>

      <h4 style="color: #0056b3; margin-bottom: 6px;">2. Categorías por Colores y Nivel de Juego</h4>
      <ul style="padding-left: 18px; margin-bottom: 12px;">
        <li><b>Restricción de Nivel:</b> Solo podés tomar turnos del Pizarrón que coincidan con tu color asignado o con niveles permitidos para tu categoría.</li>
        <li><b>Significado de los Colores:</b>
          <ul style="padding-left: 15px; margin-top: 4px;">
            <li><span style="color: #007bff; font-weight: bold;">🔵 AZUL:</span> 8va/7ma TMT. O según ranking interno. A criterio de profes.</li>
            <li><span style="color: #8a2be2; font-weight: bold;">🟣 VIOLETA:</span> 6ta/5ta TMT. O según ranking interno. A criterio de profes.</li>
            <li><span style="color: #212529; font-weight: bold;">⚫ NEGRO:</span> 4ta TMT o superior. O según ranking interno. A criterio de profes.</li>
          </ul>
        </li>
      </ul>

      <h4 style="color: #0056b3; margin-bottom: 6px;">3. Adquisición de Turnos (Tomar Turno)</h4>
      <ul style="padding-left: 18px; margin-bottom: 12px;">
        <li><b>Uso de Créditos:</b> Si tenés créditos vigentes en tu cuenta, se consumirá 1 crédito al tomar el turno.</li>
        <li><b>Sin Crédito (Abono directo / Deuda):</b> Si no disponés de créditos, podés tomar el turno pagando la tarifa vigente mediante transferencia al alias del profe y enviando el comprobante. En el sistema quedará registrada la deuda temporal hasta su acreditación.</li>
        <li><b>Un Solo intercambio por Crédito:</b> Una vez que un jugador tomó un turno, es compromiso de asistencia; un turno tomado no puede volver a liberarse.</li>
        <li><b>Recupero Propio:</b> Podés volver a tomar un turno que vos mismo liberaste (si aún no fue tomado) utilizando 1 crédito disponible.</li>
      </ul>

      <h4 style="color: #0056b3; margin-bottom: 6px;">4. Inscripción a Eventos y Torneos</h4>
      <ul style="padding-left: 18px; margin-bottom: 12px;">
        <li><b>Compromiso de Asistencia:</b> Al inscribirte a cualquier evento o torneo activo, asumís el compromiso de asistir.</li>
        <li><b>Torneos en Modalidad Dobles:</b> Es requisito indicar el nombre y apellido de tu pareja al momento de la inscripción.</li>
        <li><b>Cupos y Cierre:</b> Las inscripciones están sujetas a disponibilidad de cupo o al cierre determinado por los profes.</li>
      </ul>

      <h4 style="color: #0056b3; margin-bottom: 6px;">5. Cuentas y Estado de Socio</h4>
      <ul style="padding-left: 18px; margin-bottom: 0;">
        <li><b>Aprobación de Cuentas:</b> Los usuarios nuevos o pendientes de aprobación deben esperar la habilitación de los profes para poder operar en la app.</li>
        <li><b>Cuentas Suspendidas:</b> Las cuentas bloqueadas por motivo x no podrán liberar ni tomar turnos hasta resolver su situación.</li>
      </ul>

    </div>
  `;

  Swal.fire({
    title: '📋 Reglas de uso APP Astros',
    html: htmlReglas,
    width: '85%', // <-- Limita el ancho al 85% de la pantalla (deja margen alrededor)
    padding: '1.25rem',
    confirmButtonText: 'Entendido',
    confirmButtonColor: '#28a745',
    customClass: {
      popup: 'rounded-2xl'
    }
  });
};

const obtenerGrillaReal = () => {
  const sedes = ["Fulgor", "Chacarita"];
  const diasSemanales = ["Martes", "Miercoles", "Jueves", "Viernes", "Sabado"];
  const estructura = {};

  // Inicializamos la estructura basada en tu constante ESQUEMA
  sedes.forEach(s => {
    estructura[s] = {};
    diasSemanales.forEach(d => {
      estructura[s][d] = {};
    });
  });

  // Mapeamos los socios a sus respectivos turnos fijos
  usuariosAdmin.forEach(u => {
    u.turnosAsignados?.forEach(t => {
      // t.s es la sede ("Fulgor" o "Chacarita") y t.dia es el día
      if (estructura[t.s] && estructura[t.s][t.dia]) {
        if (!estructura[t.s][t.dia][t.h]) estructura[t.s][t.dia][t.h] = [];
        estructura[t.s][t.dia][t.h].push({
          nombre: u.nombre,
          nivel: u.nivel || "Azul"
        });
      }
    });
  });
  return { sedes, diasSemanales, estructura };
};

// --- 1. Generamos la lista filtrada y ORDENADA para la Planilla ---
const planillaFiltrada = (usuariosProcesados || [])
  .filter(u => u.nombre?.toLowerCase().includes(busquedaPlanilla?.toLowerCase() || ""))
  .sort((a, b) => {
    // Lógica de ordenamiento según el select 'ordenPlanilla'
    if (ordenPlanilla === 'nombre') {
      return (a.nombre || "").localeCompare(b.nombre || "");
    }
    if (ordenPlanilla === 'mayor_deuda') {
      // Ordena de mayor a menor deuda de turnos (rojos)
      return (b.realDeuda || 0) - (a.realDeuda || 0);
    }
    if (ordenPlanilla === 'mayor_credito') {
      // Ordena de mayor a menor crédito de turnos (verdes)
      return (b.realCreditos || 0) - (a.realCreditos || 0);
    }
    if (ordenPlanilla === 'mayor_deuda_dinero') {
      // OPCIONAL: Por si querés ordenar por quién debe más plata $
      return (a.saldoCC || 0) - (b.saldoCC || 0);
    }
    return 0;
  });

// --- 2. Calculamos las Stats basadas en esa lista ---
const statsPlanilla = {
  totales: planillaFiltrada.length,
  activos: planillaFiltrada.filter(u => u.turnosAsignados?.length > 0).length,
  invitados: planillaFiltrada.filter(u => !u.turnosAsignados || u.turnosAsignados.length === 0).length,
  deudoresTurnos: planillaFiltrada.filter(u => (u.realDeuda || 0) > 0).length,
  totalDeudaCreditos: planillaFiltrada.reduce((acc, u) => acc + (u.realDeuda || 0), 0),
  deudoresDinero: planillaFiltrada.filter(u => (u.saldoCC || 0) < 0).length,
  totalCaja: planillaFiltrada.reduce((acc, u) => acc + (u.saldoCC || 0), 0),
  negros: planillaFiltrada.filter(u => u.nivel === 'Negro').length,
  violetas: planillaFiltrada.filter(u => u.nivel === 'Violeta').length,
  azules: planillaFiltrada.filter(u => u.nivel === 'Azul').length,
};

const SeccionAdminComp = () => {
    const [fasePersonalizada, setFasePersonalizada] = useState(false);
    const [form, setForm] = useState({
      tipo: "Liga de Equipos", categoria: "Copa de Clubes", equipo: "Astros A", rival: "", 
      fecha: "", condicion: "Local", semestre: "2026-2", estado: "proximo",
      resAstros: 0, resRival: 0, plantel: "", ubicacion: "",
      fase: "Zonal", mesa: "" 
    });

    const guardar = () => {
      if(!form.rival || !form.fecha) return alert("Falta rival o fecha");
      const id = Date.now();
      const plantelArray = form.plantel ? form.plantel.split(",").map(s => s.trim()) : [];
      set(ref(db, `competencias/encuentros/${id}`), { ...form, plantel: plantelArray })
        .then(() => alert("✅ Partido publicado"));
    };
    
    return (
      <div className="space-y-4 text-slate-200">
        <h4 className="text-center text-cyan-400 font-black text-xs uppercase tracking-widest mb-6">
          🚀 Cargar Nuevo Encuentro
        </h4>
        
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1">
            <label className="text-[9px] font-bold text-slate-500 uppercase ml-1">Tipo de Competencia</label>
            <select 
              onChange={e => setForm({...form, tipo: e.target.value})} 
              className="w-full bg-slate-900/80 border border-slate-700 text-slate-200 p-3.5 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:outline-none [color-scheme:dark] font-bold text-sm"
            >
              <option value="Liga de Equipos">Liga de Equipos</option>
              <option value="Copa de Clubes">Copa de Clubes</option>
            </select>
          </div>
          <div className="space-y-1">
            <label className="text-[9px] font-bold text-slate-500 uppercase ml-1">Categoría</label>
            <select 
              onChange={e => setForm({...form, categoria: e.target.value})} 
              className="w-full bg-slate-900/80 border border-slate-700 text-slate-200 p-3.5 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:outline-none [color-scheme:dark] font-bold text-sm"
            >
              {categoriasPosibles.filter(c => c !== 'TODAS').map(c => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <input 
            placeholder="Equipo (Astros A)" 
            onChange={e => setForm({...form, equipo: e.target.value})} 
            className="bg-slate-900/60 border border-slate-700 text-white p-3.5 rounded-xl focus:ring-2 focus:ring-cyan-500 outline-none placeholder:text-slate-600 font-medium" 
          />
          <input 
            placeholder="Rival" 
            onChange={e => setForm({...form, rival: e.target.value})} 
            className="bg-slate-900/60 border border-slate-700 text-white p-3.5 rounded-xl focus:ring-2 focus:ring-cyan-500 outline-none placeholder:text-slate-600 font-medium" 
          />
        </div>

        <div className="space-y-1">
          <label className="text-[9px] font-bold text-slate-500 uppercase ml-1">Fase del Torneo</label>
          {!fasePersonalizada ? (
            <select 
              onChange={e => e.target.value === "OTRO" ? setFasePersonalizada(true) : setForm({...form, fase: e.target.value})}
              className="w-full bg-slate-900/80 border border-slate-700 text-slate-200 p-3.5 rounded-xl focus:ring-2 focus:ring-cyan-500 outline-none font-bold text-sm"
            >
              <option value="Zonal">Zonal</option>
              <option value="Zona División">Zona División</option>
              <option value="Zona Clasificación">Zona Clasificación</option>
              <option value="Zona Campeonato">Zona Campeonato</option>
              <option value="16avos de final">16avos de final</option>
              <option value="8avos de final">8avos de final</option>
              <option value="4tos de final">4tos de final</option>
              <option value="Semifinal">Semifinal</option>
              <option value="Final">Final</option>
              <option value="OTRO">✍️ Escribir fase personalizada...</option>
            </select>
          ) : (
            <div className="flex gap-2">
              <input 
                autoFocus
                placeholder="Ej: Repechaje, Final Ida..." 
                onChange={e => setForm({...form, fase: e.target.value})}
                className="flex-1 bg-slate-900/60 border border-cyan-500/50 text-white p-3.5 rounded-xl outline-none font-medium" 
              />
              <button onClick={() => setFasePersonalizada(false)} className="bg-slate-800 px-4 rounded-xl text-xs font-bold text-slate-400">Volver</button>
            </div>
          )}
        </div>

        <div className="grid grid-cols-3 gap-3">
          <input 
            placeholder="📍 Lugar / Dirección" 
            className="col-span-2 bg-slate-900/60 border border-slate-700 text-white p-3.5 rounded-xl outline-none placeholder:text-slate-600 font-medium" 
            onChange={e => setForm({...form, ubicacion: e.target.value})} 
          />
          <input 
            placeholder="🏓 Mesa" 
            type="text"
            className="bg-slate-900/60 border border-slate-700 text-white p-3.5 rounded-xl outline-none placeholder:text-slate-600 font-black text-center" 
            onChange={e => setForm({...form, mesa: e.target.value})} 
          />
        </div>

        <div className="flex flex-col gap-1.5">
          <label className="text-[9px] font-black text-slate-500 uppercase tracking-widest ml-1">FECHA Y HORA (24hs)</label>
          <input 
            type="datetime-local" 
            onChange={e => setForm({...form, fecha: e.target.value})} 
            className="w-full bg-slate-900/80 border border-slate-700 text-white p-3.5 rounded-xl focus:ring-2 focus:ring-cyan-500 transition-all [color-scheme:dark] font-bold" 
          />
        </div>

        <div className="grid grid-cols-2 gap-3">
          <select onChange={e => setForm({...form, semestre: e.target.value})} className="bg-slate-900/80 border border-slate-700 text-slate-200 p-3.5 rounded-xl font-bold [color-scheme:dark]">
            <option value="2026-2">2026-2</option>
            <option value="2026-1">2026-1</option>
          </select>
          <select onChange={e => setForm({...form, estado: e.target.value})} className="bg-slate-900/80 border border-slate-700 text-slate-200 p-3.5 rounded-xl font-bold [color-scheme:dark]">
            <option value="proximo">Próximo</option>
            <option value="finalizado">Finalizado</option>
          </select>
        </div>

        <textarea 
          placeholder="Plantel Opcional (Nacho, Alejo, Juan...)" 
          onChange={e => setForm({...form, plantel: e.target.value})} 
          className="w-full bg-slate-900/60 border border-slate-700 text-white p-3.5 rounded-xl outline-none h-20 resize-none pt-3" 
        />

        <button onClick={guardar} className="w-full mt-4 bg-gradient-to-r from-cyan-600 to-blue-600 hover:from-cyan-500 hover:to-blue-500 text-white font-black py-4 rounded-xl shadow-lg shadow-cyan-500/20 hover:scale-[1.02] active:scale-95 transition-all uppercase tracking-widest text-xs flex items-center justify-center gap-2">
          <span>🚀</span> PUBLICAR ENCUENTRO
        </button>
      </div>
    );
};

  // FUERA de SeccionAdminComp, en el cuerpo de la App
const finalizarEncuentro = (id, resA, resR) => {
  if (resA === "" || resR === "") return alert("Poné ambos resultados");
  
  // IMPORTANTE: Asegurate de tener 'update' importado de firebase/database
  update(ref(db, `competencias/encuentros/${id}`), {
    resAstros: resA,
    resRival: resR,
    estado: "finalizado"
  }).then(() => alert("🏆 Resultado cargado y movido a Finalizados"));
};

const encuentrosAgrupados = useMemo(() => {
  let proximos = encuentros
    .filter(e => e.estado === "proximo")
    // NUEVO: Filtro por categoría
    .filter(e => filtroCat === 'TODAS' || e.categoria.includes(filtroCat))
    .sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

  const grupos = {};
  proximos.forEach(e => {
    const fechaObj = new Date(e.fecha);
    const dia = fechaObj.toLocaleDateString('es-AR', { weekday: 'long', day: '2-digit', month: '2-digit' });
    const hora = fechaObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }) + 'hs';

    if (!grupos[dia]) grupos[dia] = {};
    if (!grupos[dia][hora]) grupos[dia][hora] = [];
    grupos[dia][hora].push(e);
  });
  return grupos;
}, [encuentros, filtroCat]); // Se actualiza cuando cambia el filtro

const resultadosAgrupados = useMemo(() => {
  let finalizados = encuentros
    .filter(e => e.estado === "finalizado" && e.semestre === filtroSemestre)
    // Aplicamos el mismo filtro de categoría que en próximos
    .filter(e => filtroCat === 'TODAS' || e.categoria.includes(filtroCat))
    // Ordenamos por fecha descendente (lo más nuevo primero)
    .sort((a, b) => new Date(b.fecha) - new Date(a.fecha));

  const grupos = {};
  finalizados.forEach(e => {
    const fechaObj = new Date(e.fecha);
    const dia = fechaObj.toLocaleDateString('es-AR', { weekday: 'long', day: '2-digit', month: '2-digit' });
    const hora = fechaObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }) + 'hs';

    if (!grupos[dia]) grupos[dia] = {};
    if (!grupos[dia][hora]) grupos[dia][hora] = [];
    grupos[dia][hora].push(e);
  });
  return grupos;
}, [encuentros, filtroSemestre, filtroCat]);

const obtenerProximoVencimiento = () => {
  if (!userData?.detalles_creditos) return null;
  
  const ahora = getFechaArgentina().getTime();
  const creditosVigentes = Object.values(userData.detalles_creditos)
    .filter(c => c.vence > Math.max(ahora, c.otorgado || 0)) // Filtra los que no vencieron
    .sort((a, b) => a.vence - b.vence); // Ordena: el más próximo primero

  if (creditosVigentes.length === 0) return null;

  const proximoVence = creditosVigentes[0].vence;
  const diferenciaMs = proximoVence - ahora;
  const diasRestantes = Math.floor(diferenciaMs / (1000 * 60 * 60 * 24));
  
  if (diasRestantes === 0) {
    const horasRestantes = Math.floor(diferenciaMs / (1000 * 60 * 60));
    return horasRestantes <= 0 ? "uno vence" : `uno vence (en ${horasRestantes}hs)`;
  }
  
  return `uno vence ${diasRestantes} ${diasRestantes === 1 ? 'día' : 'días'}`;
};

// Tabla de Elo según la imagen adjunta[cite: 1]
const OBTENER_PUNTOS_BASE = (diferencia, ganoMayorPuntaje) => {
  if (diferencia >= 750) return ganoMayorPuntaje ? 1 : 28;
  if (diferencia >= 500) return ganoMayorPuntaje ? 2 : 26;
  if (diferencia >= 400) return ganoMayorPuntaje ? 3 : 24;
  if (diferencia >= 300) return ganoMayorPuntaje ? 4 : 22;
  if (diferencia >= 200) return ganoMayorPuntaje ? 5 : 20;
  if (diferencia >= 150) return ganoMayorPuntaje ? 6 : 18;
  if (diferencia >= 100) return ganoMayorPuntaje ? 7 : 16;
  if (diferencia >= 50)  return ganoMayorPuntaje ? 8 : 14;
  if (diferencia >= 25)  return ganoMayorPuntaje ? 9 : 12;
  return 10; // De 0 a 24 la ganancia/pérdida es 10 para ambos
};

// Función auxiliar para calcular el nuevo color según los rangos
const CALCULAR_COLOR_SEGUN_RATING = (rating) => {
  if (rating >= 800) return "Negro";
  if (rating >= 500) return "Violeta";
  return "Azul"; // 0 a 499
};
const inicializarRatingsUsuarios = async () => {
  if (!usuariosAdmin || usuariosAdmin.length === 0) return;

  // 1. Filtramos ÚNICAMENTE a los usuarios que NO tienen el nodo rating creado
  const usuariosSinRating = usuariosAdmin.filter(u => u.rating === undefined || u.rating === null);

  if (usuariosSinRating.length === 0) {
    alert("✨ Todos los usuarios ya tienen un Rating asignado. No se modificó a nadie.");
    return;
  }

  const confirmacion = window.confirm(
    `Se encontraron ${usuariosSinRating.length} usuario(s) NUEVO(S) sin rating.\n\n` +
    `¿Deseas asignarles su rating inicial según su color actual?\n` +
    `(Los usuarios que ya tienen rating acumulado NO serán modificados).`
  );

  if (!confirmacion) return;

  const updates = {};

  usuariosSinRating.forEach(u => {
    let ratingBase = 300; // Azul por defecto
    if (u.nivel === "Violeta") ratingBase = 600;
    if (u.nivel === "Negro") ratingBase = 1000;

    // Solo tocamos la ruta de los usuarios que no tenían el campo
    updates[`usuarios/${u.uid}/rating`] = ratingBase;
    
    // Asignamos su nivel inicial coincidente
    updates[`usuarios/${u.uid}/nivel`] = CALCULAR_COLOR_SEGUN_RATING(ratingBase);
  });

  try {
    await update(ref(db), updates);
    alert(`✅ Rating inicial asignado con éxito a ${usuariosSinRating.length} usuario(s) nuevo(s).`);
  } catch (error) {
    console.error("Error al inicializar ratings:", error);
    alert("❌ Hubo un error al intentar actualizar la base de datos.");
  }
};
const procesarPartidoRanking = async ({ torneoId, torneoNombre, modo, esFinals, fase, equipo1, equipo2, ganador, sets }) => {
  // modo: 'singles' o 'dobles'
  // equipo1: array de UIDs [uidA1] o [uidA1, uidA2]
  // equipo2: array de UIDs [uidB1] o [uidB1, uidB2]
  // ganador: 1 o 2
  // sets: array de objetos [{ p1: '11', p2: '5' }, ...]

  // Multiplicadores
  let factor = modo === 'dobles' ? 0.5 : 1.0;
  if (esFinals) factor *= 2.0;

  // Calculamos promedios de rating si es dobles
  const getRating = (uid) => {
    const usr = usuariosAdmin.find(u => u.uid === uid);
    return usr?.rating ?? (usr?.nivel === 'Negro' ? 1000 : usr?.nivel === 'Violeta' ? 600 : 300);
  };

  const ratingE1 = equipo1.reduce((acc, uid) => acc + getRating(uid), 0) / equipo1.length;
  const ratingE2 = equipo2.reduce((acc, uid) => acc + getRating(uid), 0) / equipo2.length;

  const diferencia = Math.abs(ratingE1 - ratingE2);
  const e1Gano = ganador === 1;
  const e1EsMayor = ratingE1 >= ratingE2;

  let puntosBase = 0;
  if (e1EsMayor) {
    puntosBase = OBTENER_PUNTOS_BASE(diferencia, e1Gano);
  } else {
    puntosBase = OBTENER_PUNTOS_BASE(diferencia, !e1Gano);
  }

  const puntosFinales = Math.round(puntosBase * factor);

  const updates = {};
  const ahora = Date.now();

  // Aplicar a Equipo 1
  equipo1.forEach(uid => {
    const rActual = getRating(uid);
    const nuevoR = Math.max(0, rActual + (e1Gano ? puntosFinales : -puntosFinales));
    updates[`usuarios/${uid}/rating`] = nuevoR;
    updates[`usuarios/${uid}/nivel`] = CALCULAR_COLOR_SEGUN_RATING(nuevoR);
  });

  // Aplicar a Equipo 2
  equipo2.forEach(uid => {
    const rActual = getRating(uid);
    const nuevoR = Math.max(0, rActual + (!e1Gano ? puntosFinales : -puntosFinales));
    updates[`usuarios/${uid}/rating`] = nuevoR;
    updates[`usuarios/${uid}/nivel`] = CALCULAR_COLOR_SEGUN_RATING(nuevoR);
  });

  // Filtramos solo los sets que tienen datos cargados para no guardar objetos vacíos
  const setsValidos = (sets || []).filter(s => s.p1 !== '' || s.p2 !== '');

  // Guardar el resultado en la subpestaña Resultados
  const nuevoResultadoRef = push(ref(db, 'torneos_resultados'));
  updates[`torneos_resultados/${nuevoResultadoRef.key}`] = {
    torneoId,
    torneoNombre,
    modo,
    esFinals,
    fase: fase || 'Zona', // <--- Guardamos la instancia/fase
    equipo1,
    equipo2,
    ganador,
    sets: setsValidos,
    puntosEnJuego: puntosFinales,
    fecha: ahora
  };

  await update(ref(db), updates);
  alert(`✅ Partido guardado. Variación de Rating: ±${puntosFinales} pts.`);
};

const toggleRankingUsuario = async (uid, estadoActual) => {
  try {
    await update(ref(db, `usuarios/${uid}`), {
      enRanking: !estadoActual
    });
  } catch (err) {
    console.error("Error al actualizar visibilidad en ranking:", err);
    alert("❌ Error al guardar el cambio.");
  }
};

const inscribirseATorneo = async (torneo) => {
  const sesionOk = await validarSesionActiva();
  if (!sesionOk) return;

  if (!userData?.aprobado && user?.email !== ADMIN_EMAIL) {
    Swal.fire({
      icon: 'info',
      title: '¡Hola!',
      text: 'Tu cuenta está en proceso de aprobación.',
      confirmButtonColor: '#3085d6'
    });
    return;
  }
  
  if (userData?.bloqueado) {
    Swal.fire({
      icon: 'error',
      title: 'Cuenta suspendida',
      text: `Motivo: ${userData.motivoBloqueo}`,
      confirmButtonColor: '#d33'
    });
    return;
  }

  const inscriptosArray = torneo.inscriptos ? Object.values(torneo.inscriptos) : [];
  
  // 1. Verificamos si ya está inscripto
  const yaInscripto = inscriptosArray.some(i => i.uid === user.uid || i.compañeroUid === user.uid);
  if (yaInscripto) {
    Toast.fire({
      icon: 'info',
      title: 'Ya estás inscripto en este torneo.'
    });
    return;
  }

  // 2. Verificamos cupo
  if (inscriptosArray.length >= torneo.cupo) {
    Toast.fire({
      icon: 'warning',
      title: 'El cupo para este torneo está lleno.'
    });
    return;
  }

  let compañeroDatos = null;

  // 3. Si el torneo es dobles, pedimos seleccionar/ingresar compañero usando SweetAlert Input
  if (torneo.modo === 'dobles') {
    const { value: nombreCompañero } = await Swal.fire({
      title: 'Torneo Modalidad DOBLES',
      text: 'Ingresá el nombre y apellido de tu compañero/a:',
      input: 'text',
      inputPlaceholder: 'Ej: Juan Pérez',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#6e7881',
      confirmButtonText: 'Continuar',
      cancelButtonText: 'Cancelar',
      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return 'Para anotarte en dobles debes indicar tu pareja.';
        }
      }
    });

    // Si tocó cancelar o cerró la ventana, abortamos
    if (!nombreCompañero) return;

    compañeroDatos = nombreCompañero.trim();
  }

  // 4. Mensaje de confirmación en HTML maquetado
  const htmlConfirmacion = `
    <div style="text-align: left; font-size: 0.95rem; line-height: 1.5;">
      <p>Al anotarte, asumes el compromiso de asistir.</p>
      <hr style="margin: 10px 0; border: 0; border-top: 1px solid #eee;" />
      <p><b>Torneo:</b> ${torneo.nombre}</p>
      <p><b>Modalidad:</b> ${torneo.modo.toUpperCase()}</p>
      ${compañeroDatos ? `<p><b>Pareja:</b> ${compañeroDatos}</p>` : ''}
      <p><b>Costo:</b> ${torneo.precio || 'A definir'}</p>
    </div>
  `;

  const result = await Swal.fire({
    title: '⚠️ COMPROMISO DE ASISTENCIA',
    html: htmlConfirmacion,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#28a745',
    cancelButtonColor: '#6e7881',
    confirmButtonText: 'Sí, confirmar inscripción',
    cancelButtonText: 'Cancelar'
  });

  if (result.isConfirmed) {
    const nuevoInscripto = {
      uid: user.uid,
      nombre: userData?.nombre || user.displayName,
      compañero: compañeroDatos || null,
      fecha: new Date().toLocaleString()
    };

    try {
      await push(ref(db, `torneos_activos/${torneo.id}/inscriptos`), nuevoInscripto);

      Toast.fire({
        icon: 'success',
        title: '¡Inscripción exitosa al torneo! Te esperamos.'
      });
    } catch (err) {
      console.error("Error al inscribirse al torneo:", err);
      Swal.fire({
        icon: 'error',
        title: 'Error de conexión',
        text: 'Hubo un error al procesar tu inscripción.',
        confirmButtonColor: '#d33'
      });
    }
  }
};

const revertirUltimoResultado = async (partido) => {
  if (!window.confirm("⚠️ ¿Deseas eliminar este resultado y revertir los puntos sumados/restados a los jugadores?")) return;

  try {
    const e1Gano = partido.ganador === 1;
    const pts = partido.puntosEnJuego || 0;
    const updates = {};

    // Helper local para consultar el rating actual del jugador
    const getRating = (uid) => {
      const usr = usuariosAdmin.find(u => u.uid === uid);
      return usr?.rating ?? (usr?.nivel === 'Negro' ? 1000 : usr?.nivel === 'Violeta' ? 600 : 300);
    };

    // Revertimos Equipo 1: Si ganó le restamos los puntos, si perdió se los devolvemos
    partido.equipo1.forEach(uid => {
      const rActual = getRating(uid);
      const nuevoR = Math.max(0, rActual + (e1Gano ? -pts : pts));
      updates[`usuarios/${uid}/rating`] = nuevoR;
      updates[`usuarios/${uid}/nivel`] = CALCULAR_COLOR_SEGUN_RATING(nuevoR);
    });

    // Revertimos Equipo 2: Si ganó le restamos los puntos, si perdió se los devolvemos
    partido.equipo2.forEach(uid => {
      const rActual = getRating(uid);
      const nuevoR = Math.max(0, rActual + (!e1Gano ? -pts : pts));
      updates[`usuarios/${uid}/rating`] = nuevoR;
      updates[`usuarios/${uid}/nivel`] = CALCULAR_COLOR_SEGUN_RATING(nuevoR);
    });

    // Borramos el partido del nodo 'torneos_resultados'
    updates[`torneos_resultados/${partido.id}`] = null;

    await update(ref(db), updates);
    alert("✅ Partido eliminado y puntos revertidos con éxito.");

  } catch (err) {
    console.error("Error al revertir partido:", err);
    alert("❌ Hubo un error al intentar eliminar el resultado.");
  }
};

const obtenerHistorialH2H = (uid1, uid2) => {
  if (!uid1 || !uid2 || uid1 === uid2) return null;

  // Filtramos los partidos cruzados entre ambos jugadores
  const enfrentamientos = (torneosResultados || []).filter(partido => {
    const e1 = partido.equipo1 || [];
    const e2 = partido.equipo2 || [];
    
    const enE1_j1 = e1.includes(uid1);
    const enE2_j1 = e2.includes(uid1);
    const enE1_j2 = e1.includes(uid2);
    const enE2_j2 = e2.includes(uid2);

    return (enE1_j1 && enE2_j2) || (enE2_j1 && enE1_j2);
  });

  let victoriasJ1 = 0;
  let victoriasJ2 = 0;

  enfrentamientos.forEach(p => {
    const e1 = p.equipo1 || [];
    const j1EnE1 = e1.includes(uid1);
    const ganoE1 = p.ganador === 1;

    const ganoJ1 = (j1EnE1 && ganoE1) || (!j1EnE1 && !ganoE1);

    if (ganoJ1) victoriasJ1++;
    else victoriasJ2++;
  });

  const j1Obj = usuariosAdmin.find(u => u.uid === uid1);
  const j2Obj = usuariosAdmin.find(u => u.uid === uid2);

  return {
    j1: j1Obj || { nombre: "Jugador 1", nivel: "Azul" },
    j2: j2Obj || { nombre: "Jugador 2", nivel: "Azul" },
    totalPartidos: enfrentamientos.length,
    victoriasJ1,
    victoriasJ2,
    enfrentamientos
  };
};

// =========================================================================
// OBTENER CUMPLEAÑEROS DEL DÍA
// =========================================================================
const obtenerCumpleañerosHoy = () => {
  if (!usuariosAdmin || usuariosAdmin.length === 0) return [];

  // Obtenemos día y mes actual en zona horaria de Argentina (formato "DD/MM")
  const hoy = getFechaArgentina();
  const mesHoy = (hoy.getMonth() + 1).toString().padStart(2, '0');
  const diaHoy = hoy.getDate().toString().padStart(2, '0');

  return usuariosAdmin.filter(u => {
    if (!u.fechaNacimiento) return false;
    
    // Asumiendo formato YYYY-MM-DD del input type="date"
    const [anio, mes, dia] = u.fechaNacimiento.split('-');
    return mes === mesHoy && dia === diaHoy;
  });
};


return (
    <div className="max-w-[480px] mx-auto min-h-screen bg-slate-900 text-slate-200 p-3 sm:p-5 pb-28 font-sans relative shadow-[0_0_40px_rgba(0,0,0,0.3)] border-x border-slate-800/50">
     
   {/* HEADER UNIFICADO STICKY CON RENGLÓN 1 COMPACTO Y DESPLEGABLE GENERAL */}
<header className="sticky top-0 z-40 w-[calc(100%+1.5rem)] sm:w-[calc(100%+2.5rem)] -mt-3 sm:-mt-5 -mx-3 sm:-mx-5 bg-slate-800/95 backdrop-blur-2xl border-b border-white/10 shadow-[0_12px_35px_rgba(0,0,0,0.7)] mb-4">
  
  {/* 1. ZÓCALO DEL LOGO - BLANCO PURO */}
  <div className="bg-white border-b border-cyan-400/30 shadow-sm">
    <div className="w-full max-w-[480px] mx-auto h-12 flex items-center justify-center px-4 overflow-hidden">
      <img 
        src="/logo-astros.webp" 
        alt="App Astros Tenis de Mesa" 
        className="h-[140%] max-h-none w-auto object-contain block mx-auto -my-2" 
      />
    </div>
  </div>

  {!user ? (
    /* LOGIN CARD PARA USUARIOS DESLOGUEADOS */
    <div className="w-full max-w-[480px] mx-auto p-6 text-center">
      <button 
        onClick={login} 
        className="w-full py-4 rounded-2xl bg-blue-600 hover:bg-blue-500 text-white font-black tracking-widest uppercase text-xs shadow-[0_0_20px_rgba(37,99,235,0.4)] active:scale-95 transition-all"
      >
        INGRESAR CON GOOGLE
      </button>
    </div>
  ) : (
    <>
      {/* 2. RENGLÓN 1 FIJO Y SIEMPRE VISIBLE - MÁS ALTO Y TIPOGRAFÍA DE 15PX */}
<div className="w-full max-w-[480px] mx-auto px-4 py-3.5">
  <div className="flex items-center justify-between gap-2">
    
    {/* Nombre (15px) + Status (10px) */}
    <div className="flex items-baseline gap-1.5 min-w-0">
      <span className="font-black text-white text-[16px] leading-none uppercase italic truncate max-w-[150px] sm:max-w-[190px]">
        {(userData?.nombre || user.displayName || 'Socio').split(' ')[0]}
      </span>
      
      <span className={`text-[10px] font-black uppercase tracking-wider shrink-0 ${
        (userData?.turnosAsignados?.length > 0) ? 'text-emerald-400' : 'text-amber-400'
      }`}>
        {(userData?.turnosAsignados?.length > 0) ? '● Activo' : '○ Invitado'}
      </span>
    </div>

    {/* Créditos y Cantidad (15px) + Vencimiento (10px) */}
    <div className="flex items-baseline gap-1.5 shrink-0">
      <div className="flex items-baseline gap-1">
        <svg className="w-4 h-4 text-cyan-400 self-center" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
        </svg>
        <span className="text-slate-400 font-bold uppercase text-[11px]">Créditos:</span>
        <span className={`font-black text-[16px] leading-none tabular-nums ${
          userData?.realDeuda > 0 ? 'text-rose-400' : 'text-cyan-400'
        }`}>
          {userData?.realDeuda > 0 ? `-${userData.realDeuda}` : (userData?.realCreditos || 0)}
        </span>
      </div>

      {!userData?.realDeuda && obtenerProximoVencimiento() && (
        <>
          <span className="text-slate-600 text-[10px]">|</span>
          <span className="text-[10px] font-extrabold text-sky-400 uppercase tracking-tighter">
            {obtenerProximoVencimiento()}
          </span>
        </>
      )}
    </div>

  </div>
</div>

      {/* 3. BOTÓN FLOTANTE COLAPSADOR GENERAL */}
      <div className="relative border-t border-white/10 bg-slate-900/40">
        <button
          type="button"
          onClick={() => setVerMenuHeader(!verMenuHeader)}
          className="w-full py-1.5 px-4 flex items-center justify-center gap-2 text-[12px] font-black text-cyan-400 uppercase tracking-widest hover:bg-white/5 transition-all"
        >
          <svg className="w-3.5 h-3.5 text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {verMenuHeader ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
          <span>{verMenuHeader ? 'Ocultar Perfil y Opciones' : 'Ver Perfil y Opciones'}</span>
        </button>
      </div>

      {/* 4. BLOQUE DESPLEGABLE COMPLETO */}
      {verMenuHeader && (
        <div className="animate-in slide-in-from-top-2 duration-200 divide-y divide-white/10 border-t border-white/10 bg-slate-900/95">
          
          {/* RENGLÓN 2: ABONO + ESTADO DE CUENTA + NIVEL + RATING */}
          <div className="w-full max-w-[480px] mx-auto px-4 py-2.5 flex items-center justify-between gap-2 text-xs">
            {/* Abono + Estado de Cuenta */}
            <div className="flex items-center gap-2 min-w-0">
              <span className="text-xs font-bold text-slate-400 uppercase tracking-tight shrink-0">
                Plan: <strong className="text-cyan-400 font-black text-xs">{userData?.turnosAsignados?.length || 0}D</strong>
              </span>

              <span className="text-slate-600">|</span>

              {(() => {
                const movimientos = userData?.cuenta_corriente ? Object.values(userData.cuenta_corriente) : [];
                const saldoActual = movimientos.reduce((acc, m) => acc + (m.monto || 0), 0);
                const esDeudor = saldoActual < 0;
                return (
                  <span className={`text-xs font-black uppercase tracking-tight truncate ${
                    esDeudor ? 'text-rose-400' : 'text-emerald-400'
                  }`}>
                    {esDeudor ? 'Pago Pendiente' : 'Al día'}
                  </span>
                );
              })()}
            </div>

            {/* Nivel + Rating */}
            <div className="flex items-center gap-2 shrink-0">
              <div className="flex items-center gap-1">
                <span className="text-slate-400 font-bold uppercase text-[11px]">Nivel:</span>
                <span className={`font-black uppercase text-xs ${
                  nivelUser === 'Negro' ? 'text-white' : (nivelUser === 'Violeta' ? 'text-purple-400' : 'text-sky-400')
                }`}>
                  {nivelUser}
                </span>
              </div>

              <span className="text-slate-600">|</span>

              <div className="flex items-center gap-1">
                <span className="text-slate-400 font-bold uppercase text-[11px]">Rating:</span>
                <span className="font-black text-amber-400 text-xs tabular-nums">
                  {userData?.rating ?? (userData?.nivel === 'Negro' ? 1000 : userData?.nivel === 'Violeta' ? 600 : 300)}
                </span>
              </div>
            </div>
          </div>

          {/* RENGLÓN 3: MEDALLERO COMPACTO */}
          <div className="w-full max-w-[480px] mx-auto px-4 py-2.5 flex items-center justify-between gap-1 text-xs">
            {['tmt', 'fetemba', 'fatm'].map((liga, idx) => {
              const p1 = userData?.podios?.[liga]?.p1 || 0;
              const p2 = userData?.podios?.[liga]?.p2 || 0;
              const p3 = userData?.podios?.[liga]?.p3 || 0;

              return (
                <React.Fragment key={liga}>
                  {idx > 0 && <span className="text-slate-700 font-light">|</span>}
                  <div className="flex items-center gap-1">
                    <span className="font-black text-slate-400 uppercase italic text-[11px] tracking-tight">
                      {liga}:
                    </span>
                    <div className="flex items-center gap-1 font-black text-xs tabular-nums">
                      <span title="Primeros puestos">🥇<span className="text-yellow-400">{p1}</span></span>
                      <span title="Segundos puestos">🥈<span className="text-slate-300">{p2}</span></span>
                      <span title="Terceros puestos">🥉<span className="text-amber-600">{p3}</span></span>
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
          </div>

          {/* LOS 4 DESPLEGABLES */}
          <div className="divide-y divide-white/5 bg-slate-900/90">
            
            {/* 1. MIS TURNOS FIJOS */}
            {userData?.turnosAsignados && (
              <div>
                <button 
                  type="button"
                  onClick={() => setVerFijos(!verFijos)}
                  className="w-full max-w-[480px] mx-auto py-2.5 px-4 flex justify-between items-center text-xs font-black text-cyan-400 uppercase tracking-wider hover:bg-white/5 transition-all"
                >
                  <div className="flex items-center gap-2">
                    <svg className="w-4 h-4 text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <span>Mis Turnos Fijos</span>
                  </div>
                  <span className="text-slate-500 text-xs">{verFijos ? '▲' : '▼'}</span>
                </button>

                {verFijos && (
                  <div className="bg-slate-950/80 border-t border-white/5 py-3 px-4 text-xs">
                    <div className="max-w-[480px] mx-auto space-y-2">
                      {userData.turnosAsignados.map((ta, i) => (
                        <div key={i} className="flex items-center justify-between text-xs font-bold text-white uppercase">
                          <span className="flex items-center gap-2">
                            <div className="w-2 h-2 rounded-full bg-cyan-400 shadow-[0_0_8px_rgba(34,211,238,0.6)]"></div>
                            {ta.dia} {ta.h}
                          </span>
                          <span className="text-xs text-slate-400 font-black italic">{ta.s}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* 2. TURNOS TOMADOS */}
            {misIntercambios && misIntercambios.length > 0 && (
              <div>
                <button 
                  type="button"
                  onClick={() => setVerTomados(!verTomados)}
                  className="w-full max-w-[480px] mx-auto py-2.5 px-4 flex justify-between items-center text-xs font-black text-emerald-400 uppercase tracking-wider hover:bg-white/5 transition-all"
                >
                  <div className="flex items-center gap-2">
                    <svg className="w-4 h-4 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                    <span>Turnos Tomados</span>
                  </div>
                  <span className="text-slate-500 text-xs">{verTomados ? '▲' : '▼'}</span>
                </button>

                {verTomados && (
                  <div className="bg-slate-950/80 border-t border-white/5 py-3 px-4 text-xs">
                    <div className="max-w-[480px] mx-auto space-y-2">
                      {misIntercambios.map((h, i) => (
                        <div key={i} className="flex items-center justify-between text-xs font-bold text-white uppercase">
                          <span className="flex items-center gap-2">
                            <div className="w-2 h-2 rounded-full bg-emerald-400 shadow-[0_0_8px_rgba(52,211,153,0.6)]"></div>
                            {formatearFechaPizarron(h.dia)} {h.h}hs
                          </span>
                          <span className="text-xs text-slate-400 font-black italic">{h.s}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* 3. MI ACTIVIDAD RECIENTE */}
            <div>
              <button 
                type="button"
                onClick={() => setVerHistorial(!verHistorial)}
                className="w-full max-w-[480px] mx-auto py-2.5 px-4 flex justify-between items-center text-xs font-black text-purple-400 uppercase tracking-wider hover:bg-white/5 transition-all"
              >
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <span>Mi Actividad Reciente</span>
                </div>
                <span className="text-slate-500 text-xs">{verHistorial ? '▲' : '▼'}</span>
              </button>

              {verHistorial && (
                <div className="bg-slate-950/80 border-t border-white/5 py-3 px-4 text-xs max-h-[50vh] overflow-y-auto overscroll-contain">
                  <div className="max-w-[480px] mx-auto divide-y divide-white/5">
                    {(() => {
                      if (!userData?.historial_movimientos) return <div className="text-xs text-slate-500 italic text-center py-1 uppercase tracking-widest">Sin actividad registrada</div>;

                      const listaMovs = Array.isArray(userData.historial_movimientos)
                        ? userData.historial_movimientos.filter(Boolean)
                        : Object.values(userData.historial_movimientos);

                      if (listaMovs.length === 0) return <div className="text-xs text-slate-500 italic text-center py-1 uppercase tracking-widest">Sin actividad registrada</div>;

                      return listaMovs
                        .sort((a, b) => (Number(b?.fecha) || 0) - (Number(a?.fecha) || 0))
                        .slice(0, 15)
                        .map((h, i) => {
                          const textoMotivo = h?.motivo || h?.concepto || (h?.tipo === 'CARGA' ? 'Carga de Créditos' : 'Consumo / Turno');
                          const esReset = h?.tipo === 'RESET' || textoMotivo.toLowerCase().includes('reset');
                          const esCarga = !esReset && (h?.tipo === 'CARGA' || (h?.cantidad && Number(h.cantidad) > 0 && h?.tipo !== 'CONSUMO'));

                          let icono = '▼';
                          let colorTexto = 'text-rose-400';
                          if (esReset) { icono = '🔄'; colorTexto = 'text-slate-400'; }
                          else if (esCarga) { icono = '▲'; colorTexto = 'text-emerald-400'; }

                          return (
                            <div key={i} className="flex justify-between py-2 items-center gap-2">
                              <span className={`text-xs font-bold ${colorTexto} truncate max-w-[240px]`}>
                                {icono} {textoMotivo}
                              </span>
                              <span className="text-[11px] font-black text-slate-500 uppercase italic tabular-nums whitespace-nowrap">
                                {h?.fecha ? new Date(Number(h.fecha)).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit' }) : '--/--'}
                              </span>
                            </div>
                          );
                        });
                    })()}
                  </div>
                </div>
              )}
            </div>

            {/* 4. MI CUENTA CORRIENTE */}
            <div>
              <button 
                type="button"
                onClick={() => setVerCuentaCorriente(!verCuentaCorriente)}
                className="w-full max-w-[480px] mx-auto py-2.5 px-4 flex justify-between items-center text-xs font-black text-sky-400 uppercase tracking-wider hover:bg-white/5 transition-all"
              >
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4 text-sky-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <span>Mi Cuenta Corriente</span>
                </div>
                <span className="text-slate-500 text-xs">{verCuentaCorriente ? '▲' : '▼'}</span>
              </button>

              {verCuentaCorriente && (
                <div className="bg-slate-950/80 border-t border-white/5 py-3 px-4 text-xs max-h-[50vh] overflow-y-auto overscroll-contain">
                  <div className="max-w-[480px] mx-auto divide-y divide-white/5">
                    {(() => {
                      const movs = userData?.cuenta_corriente ? Object.values(userData.cuenta_corriente) : [];
                      if (movs.length === 0) return <div className="text-xs text-slate-500 italic text-center py-1 uppercase tracking-widest">Sin movimientos de cuenta</div>;
                      
                      return movs.sort((a,b) => (b.fecha || 0) - (a.fecha || 0)).map((m, i) => (
                        <div key={i} className="flex justify-between py-2 items-center">
                          <span className="text-slate-300 font-bold truncate max-w-[220px]">{m.concepto || 'Movimiento'}</span>
                          <span className={`font-black tabular-nums ${m.monto >= 0 ? 'text-emerald-400' : 'text-rose-400'}`}>
                            {m.monto >= 0 ? `+$${m.monto}` : `-$${Math.abs(m.monto)}`}
                          </span>
                        </div>
                      ));
                    })()}
                  </div>
                </div>
              )}
            </div>

          </div>

          {/* BOTONES DE CÓMO FUNCIONA Y CERRAR SESIÓN */}
          <div className="w-full max-w-[480px] mx-auto px-4 py-3 flex items-center justify-between gap-2 text-xs border-t border-white/10 bg-slate-950/60">
            <button
              type="button"
              onClick={mostrarReglas}
              className="text-purple-400 hover:text-purple-300 font-black text-xs uppercase tracking-wider transition-colors flex items-center gap-1"
            >
              <span>Cómo funciona la APP?</span>
            </button>

            <button 
              type="button"
              onClick={() => signOut(auth)}
              className="text-rose-400 hover:text-rose-300 font-black text-xs uppercase tracking-wider transition-colors flex items-center gap-1"
            >
              <span>Cerrar Sesión</span>
            </button>
          </div>

        </div>
      )}
    </>
  )}
</header>


{/* MENÚ FLOTANTE CLARO - AJUSTE PRECISO: LETRA +2PX (14PX) E ICONOS +1PX (20PX) */}
<nav className="fixed bottom-3 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-1.5rem)] max-w-[460px] 
                bg-slate-100/90 backdrop-blur-2xl border border-white/60 
                py-2.5 px-2 rounded-2xl shadow-[0_15px_35px_rgba(0,0,0,0.6)]
                flex items-center gap-1.5 overflow-x-auto 
                [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]
                mb-[env(safe-area-inset-bottom)]">
    
  {/* 🏓 Turnos */}
  <button 
    onClick={() => setPestañaActiva("pizarron")}
    className={`flex-1 min-w-[68px] flex flex-col items-center gap-1 transition-all ${
      pestañaActiva === "pizarron" ? "text-cyan-600 scale-105" : "text-slate-600 hover:text-slate-900"
    }`}
  >
    <svg className="w-[20px] h-[20px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
    <span className="text-[14px] font-black tracking-tight leading-none">Turnos</span>
  </button>

  {/* 🎟️ Eventos (Ticket) */}
  <button 
    onClick={() => setPestañaActiva("eventos")}
    className={`flex-1 min-w-[68px] flex flex-col items-center gap-1 transition-all ${
      pestañaActiva === "eventos" ? "text-purple-600 scale-105" : "text-slate-600 hover:text-slate-900"
    }`}
  >
    <svg className="w-[20px] h-[20px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
    </svg>
    <span className="text-[14px] font-black tracking-tight leading-none">Eventos</span>
  </button>

  {/* 🥇 Ligas */}
  <button 
    onClick={() => setPestañaActiva("competencias")} 
    className={`flex-1 min-w-[68px] flex flex-col items-center gap-1 transition-all ${
      pestañaActiva === "competencias" ? "text-amber-600 scale-105" : "text-slate-600 hover:text-slate-900"
    }`}
  >
    <svg className="w-[20px] h-[20px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
    </svg>
    <span className="text-[14px] font-black tracking-tight leading-none">Ligas</span>
  </button>

  {/* 🛍️ Tienda */}
  <button 
    onClick={() => window.open(URL_TIENDA, '_blank')}
    className="flex-1 min-w-[68px] flex flex-col items-center gap-1 text-slate-600 hover:text-purple-700 transition-all"
  >
    <svg className="w-[20px] h-[20px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
    </svg>
    <span className="text-[14px] font-black tracking-tight leading-none">Tienda</span>
  </button>

  {/* SEPARADOR Y HERRAMIENTAS ADMIN / STAFF */}
  {(user?.email === ADMIN_EMAIL || user?.email === STAFF_EMAIL) && (
    <>
      <div className="w-[1px] h-6 bg-slate-300 mx-0.5 shrink-0" />

      {/* 📊 Planilla */}
      <button 
        onClick={() => setPestañaActiva("planilla")} 
        className={`flex-1 min-w-[68px] flex flex-col items-center gap-1 transition-all ${
          pestañaActiva === "planilla" ? "text-emerald-600 scale-105" : "text-slate-500 hover:text-slate-800"
        }`}
      >
        <svg className="w-[20px] h-[20px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        <span className="text-[14px] font-black tracking-tight leading-none">Planilla</span>
      </button>

      {/* 📅 Grilla */}
      <button 
        onClick={() => setPestañaActiva("grilla")} 
        className={`flex-1 min-w-[68px] flex flex-col items-center gap-1 transition-all ${
          pestañaActiva === "grilla" ? "text-blue-600 scale-105" : "text-slate-500 hover:text-slate-800"
        }`}
      >
        <svg className="w-[20px] h-[20px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
        </svg>
        <span className="text-[14px] font-black tracking-tight leading-none">Grilla</span>
      </button>

      {/* ⚙️ Admin */}
      {user?.email === ADMIN_EMAIL && (
        <button 
          onClick={() => setPestañaActiva("admin")} 
          className={`flex-1 min-w-[68px] flex flex-col items-center gap-1 transition-all ${
            pestañaActiva === "admin" ? "text-rose-600 scale-105" : "text-slate-500 hover:text-slate-800"
          }`}
        >
          <svg className="w-[20px] h-[20px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <span className="text-[14px] font-black tracking-tight leading-none">Admin</span>
        </button>
      )}
    </>
  )}
</nav>

{/* --- PESTAÑA PRINCIPAL TURNOS --- */}
{pestañaActiva === "pizarron" && (
  <div className="flex flex-col">
  {podioData?.activo && (
  <div className="mx-2 mb-3 p-5 rounded-[32px] bg-slate-900/60 border border-yellow-500/30 text-center shadow-2xl">
    {/* Título y Subtítulo con menos margen inferior */}
    <h4 className="text-[10px] font-black tracking-[0.3em] text-yellow-500 uppercase mb-1 italic">
      🏆 Podio de {new Intl.DateTimeFormat('es-ES', { month: 'long' }).format(new Date())}
    </h4>
    <p className="text-[8px] font-bold tracking-[0.2em] text-slate-500 uppercase mb-4">
      Ranking TMT Mensual
    </p>

    {/* Altura total de la grilla reducida aproximadamente un 20% */}
    <div className="flex items-end justify-center gap-2 h-[110px]">
      
      {/* PUESTO 2: PLATA (+1) */}
      <div className="flex-1 flex flex-col items-center">
        <span className="text-[9px] font-black text-cyan-400 mb-1">+1 🏓</span>
        <div className="w-full bg-slate-800/80 border-x border-t border-white/10 rounded-t-xl h-[70px] flex items-center justify-center p-2">
          <b className="text-[10px] text-slate-200 uppercase italic leading-tight">{podioData.p2}</b>
        </div>
      </div>

      {/* PUESTO 1: ORO (+2) */}
      <div className="flex-1 flex flex-col items-center">
        <span className="text-[10px] font-black text-cyan-400 mb-1">+2 🏓</span>
        <div className="w-full bg-gradient-to-t from-yellow-900/40 via-yellow-700/20 to-yellow-500/40 border-x border-t border-yellow-500/50 rounded-t-2xl h-[95px] flex items-center justify-center p-2 shadow-[0_0_20px_rgba(234,179,8,0.2)]">
          <b className="text-[11px] text-yellow-400 font-black uppercase italic leading-tight drop-shadow-sm">{podioData.p1}</b>
        </div>
      </div>

      {/* PUESTO 3: BRONCE (+1) */}
      <div className="flex-1 flex flex-col items-center">
        <span className="text-[9px] font-black text-cyan-400 mb-1">+1 🏓</span>
        <div className="w-full bg-slate-800/80 border-x border-t border-white/10 rounded-t-xl h-[55px] flex items-center justify-center p-2">
          <b className="text-[10px] text-orange-200 uppercase italic leading-tight">{podioData.p3}</b>
        </div>
      </div>
    </div>
  </div>
)}
{podiosSemanales && Object.values(podiosSemanales).length > 0 && (
  <div className="mx-2 mb-6 p-5 rounded-[32px] bg-slate-900/60 border border-cyan-500/20 shadow-2xl relative overflow-hidden">
    
    <div className="text-center mb-5">
      <h4 className="text-[10px] font-black tracking-[0.3em] text-cyan-400 uppercase italic">
        🛰️ Podios Semanales
      </h4>
      <p className="text-[8px] font-bold tracking-[0.2em] text-slate-500 uppercase mt-1">
        Cosecha de Astros del fin de semana
      </p>
    </div>

    {/* LISTA DE LOGROS */}
    <div className="space-y-3">
      {Object.values(podiosSemanales).reverse().map((podio, index) => (
        <div key={index} className="relative group bg-white/5 border border-white/5 rounded-2xl p-3 transition-all hover:bg-white/10">
          <div className="flex items-center gap-4">
            {/* Medalla Gigante */}
            <div className="text-2xl drop-shadow-[0_0_8px_rgba(255,255,255,0.2)]">
              {podio.puesto}
            </div>

            {/* Datos del Logro */}
            <div className="flex-1 min-w-0">
              <h3 className="text-[13px] font-black text-white uppercase italic leading-none mb-1 truncate">
                {podio.nombre}
              </h3>
              <div className="flex flex-wrap gap-x-3 gap-y-1">
                <span className="text-[9px] font-bold text-cyan-400/80 uppercase">
                  {podio.circuito} • {podio.categoria}
                </span>
                <span className="text-[9px] font-bold text-slate-500 uppercase">
                  📍 {podio.lugar}
                </span>
              </div>
            </div>
          </div>
          
          {/* Decoración lateral sutil */}
          <div className="absolute right-3 top-1/2 -translate-y-1/2 text-[10px] text-white/5 font-black uppercase italic rotate-12">
            Astros
          </div>
        </div>
      ))}
    </div>
  </div>
)}

{/* BANNER MODO VACACIONES */}
{modoVacaciones && (
  <div className="relative mb-5 p-4 rounded-2xl bg-amber-500/15 backdrop-blur-2xl border border-amber-500/30 shadow-[0_8px_25px_rgba(245,158,11,0.15)] flex items-center gap-3 text-amber-300 animate-in fade-in duration-300">
    <span className="text-2xl shrink-0">🏖️</span>
    <div className="flex flex-col min-w-0">
      <span className="text-xs font-black uppercase tracking-wider text-amber-200">
        De vacaciones, pronto volvemos 🏓
      </span>
      <span className="text-[11px] font-bold uppercase text-amber-400/80 tracking-tight">
        El club permanece cerrado durante enero. ¡Nos vemos en febrero!
      </span>
    </div>
  </div>
)}

{/* ========================================================================= */}
  {/* BANNER CELEBRACIÓN DE CUMPLEAÑOS (SOLO APARECE SI HAY CUMPLEAÑEROS HOY) */}
  {/* ========================================================================= */}
  {(() => {
    const cumpleañeros = obtenerCumpleañerosHoy();
    if (cumpleañeros.length === 0) return null; // Si no hay cumpleaños hoy, no renderiza nada

    return (
      <div className="mx-2 mb-4 p-5 rounded-[32px] bg-gradient-to-r from-pink-900/40 via-purple-900/50 to-indigo-900/40 border border-pink-500/30 shadow-2xl relative overflow-hidden animate-in fade-in slide-in-from-top-4 duration-500">
        
        {/* Resplandor y efectos festivos de fondo */}
        <div className="absolute -top-10 -right-10 w-32 h-32 bg-pink-500/20 blur-3xl pointer-events-none"></div>
        <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-purple-500/20 blur-3xl pointer-events-none"></div>

        <div className="relative z-10 text-center">
          <div className="flex justify-center items-center gap-2 mb-1">
            <span className="text-xl animate-bounce">🎂</span>
            <h4 className="text-[11px] font-black tracking-[0.25em] bg-gradient-to-r from-pink-400 via-purple-300 to-cyan-300 bg-clip-text text-transparent uppercase italic">
              ¡Hoy es un día especial en Astros!
            </h4>
            <span className="text-xl animate-bounce">🥳</span>
          </div>

          <p className="text-[9px] font-bold text-slate-400 uppercase tracking-widest mb-3">
            Le deseamos un muy feliz cumpleaños a:
          </p>

          {/* LISTA DE CUMPLEAÑEROS */}
          <div className="flex flex-wrap justify-center gap-2">
            {cumpleañeros.map((c) => (
              <div 
                key={c.uid}
                className="bg-slate-900/80 backdrop-blur-md px-4 py-2 rounded-2xl border border-pink-500/40 shadow-lg flex items-center gap-2"
              >
                <span className="text-sm">🎈</span>
                <span className="text-sm font-black text-white uppercase italic">
                  {c.nombre || "Socio"}
                </span>
              </div>
            ))}
          </div>

          <p className="text-[8px] font-bold text-pink-300/70 uppercase tracking-widest mt-3 italic">
            ¡Dejá tu saludo si te los cruzás en las mesas hoy! 🏓✨
          </p>
        </div>
      </div>
    );
  })()}

   {/* --- MURO NOTICIAS - ESTÉTICA CLEAN FROSTED GLASS CON SVG --- */}
{noticias.length > 0 && (
  <section className="relative mb-5 p-4 rounded-2xl bg-slate-800/80 backdrop-blur-2xl border border-white/10 border-l-[4px] border-l-cyan-400 shadow-[0_10px_30px_rgba(0,0,0,0.4)] overflow-hidden">
    
    {/* Resplandor sutil de fondo */}
    <div className="absolute top-0 left-0 w-16 h-full bg-cyan-500/10 blur-2xl pointer-events-none"></div>

    {/* Encabezado con Icono SVG Megáfono */}
    <h4 className="relative text-sm font-black text-white mb-3.5 flex items-center gap-2 uppercase tracking-wider">
      <svg className="w-5 h-5 text-cyan-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
      </svg>
      <span>Novedades Astros</span>
    </h4>

    {/* Carrusel Horizontal de Noticias */}
    <div className="relative flex overflow-x-auto gap-3 pb-1 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] snap-x">
      {noticias.map((n) => (
        <div key={n.id} className="snap-start shrink-0 flex-1 min-w-[280px] sm:min-w-[300px] bg-slate-900/80 p-4 rounded-xl border border-white/10 shadow-lg flex flex-col justify-between transition-all">
          <div>
            <h5 className="text-cyan-400 font-black text-[14px] mb-1.5 leading-snug uppercase tracking-tight">
              {n.titulo}
            </h5>
            <p className="text-slate-300 text-[13px] leading-relaxed mb-3 font-medium">
              {n.contenido}
            </p>
          </div>
          
          <div className="text-slate-400 text-[10px] text-right font-black uppercase italic tracking-widest mt-auto pt-2 border-t border-white/10 tabular-nums">
            {n.fecha}
          </div>
        </div>
      ))}
    </div>
  </section>
)}

   {/* --- SECCIÓN: LIBERAR LUGAR (ASTROS CLEAN + MODO ADMIN/STAFF) --- */}
<section className="relative p-4 sm:p-6 rounded-2xl bg-slate-800/80 backdrop-blur-2xl border border-white/10 border-l-[4px] border-l-orange-500 shadow-[0_10px_30px_rgba(0,0,0,0.5)] mb-6 w-full max-w-full overflow-hidden">
  
  {/* Resplandor sutil de fondo */}
  <div className="absolute top-0 right-0 w-24 h-full bg-orange-500/10 blur-2xl pointer-events-none"></div>

  {/* Encabezado con Icono SVG Candado Abierto */}
  <div className="relative flex items-center justify-between mb-4">
    <h4 className="text-sm font-black text-orange-400 flex items-center gap-2 uppercase tracking-wider">
      <svg className="w-5 h-5 text-orange-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z" />
      </svg>
      <span>Liberar mi lugar</span>
    </h4>

    {/* Indicator modo Admin si aplica */}
    {(user?.email === ADMIN_EMAIL || user?.email === STAFF_EMAIL) && (
      <span className="text-[9px] font-black uppercase px-2 py-0.5 rounded bg-amber-500/20 text-amber-300 border border-amber-500/30 tracking-widest">
        Modo Admin
      </span>
    )}
  </div>
  
  <div className="relative z-10 flex flex-col gap-3 w-full">
    
    {/* 1. SELECTOR DE FECHA */}
    <div className="relative w-full h-[54px]"> 
      <input 
  type="date" 
  value={fechaSel} 
  onChange={(e) => { 
    const val = e.target.value;
    setFechaSel(val); 
    
    if (!val) {
      setOpcionesDia([]);
      setTurnoElegido(null);
      return;
    }

    const diasMap = ["DOMINGO", "LUNES", "MARTES", "MIERCOLES", "JUEVES", "VIERNES", "SABADO"];
    const diaIndex = new Date(val + "T00:00:00").getDay();
    const nombreDiaSel = diasMap[diaIndex]; // Sin tilde para matchear estándar

    const esquemaGeneral = ESQUEMA[diasSemana[diaIndex]] || [];
    const esAdminOStaff = user?.email === ADMIN_EMAIL || user?.email === STAFF_EMAIL;

    if (esAdminOStaff) {
      setOpcionesDia(esquemaGeneral);
      setTurnoElegido(null);
    } else {
      // Helper interno para limpiar tildes y espacios
      const limpiar = (s) => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toUpperCase();

      const misTurnosDelDia = esquemaGeneral.filter((opt) => {
        return (userData?.turnosAsignados || []).some((ta) => {
          const diaCoincide = limpiar(ta.dia) === limpiar(nombreDiaSel);
          const horaCoincide = limpiar(ta.h) === limpiar(opt.h);
          
          // Si hay sede, también la comparamos de forma limpia
          const sedeCoincide = !ta.s || !opt.s || limpiar(ta.s) === limpiar(opt.s);
          
          return diaCoincide && horaCoincide && sedeCoincide;
        });
      });

      setOpcionesDia(misTurnosDelDia);
      
      if (misTurnosDelDia.length === 1) {
        setTurnoElegido(misTurnosDelDia[0]);
      } else {
        setTurnoElegido(null);
      }
    }
  }} 
  min={new Date().toISOString().split("T")[0]}
  className="absolute inset-0 w-full h-full bg-slate-900/80 border border-white/10 text-slate-100 px-4 rounded-xl focus:outline-none focus:border-orange-500/50 transition-all [color-scheme:dark] text-sm font-bold"
/>
    </div>
    
    {/* 2. SELECT DE HORARIOS */}
    {fechaSel && opcionesDia.length > 0 && (
      <div className="flex flex-col gap-3 w-full animate-in fade-in slide-in-from-top-1 duration-200">
        
        <div className="relative w-full h-[54px]">
          <select 
            value={turnoElegido ? opcionesDia.indexOf(turnoElegido) : ""}
            onChange={(e) => setTurnoElegido(opcionesDia[e.target.value])}
            className="absolute inset-0 w-full h-full bg-slate-900/80 border border-white/10 text-slate-100 px-4 rounded-xl focus:outline-none focus:border-orange-500/50 transition-all cursor-pointer [color-scheme:dark] text-sm font-bold"
          >
            <option value="" className="text-slate-500">
              {(user?.email === ADMIN_EMAIL || user?.email === STAFF_EMAIL) 
                ? "Selecciona horario a liberar..." 
                : "Seleccioná tu turno fijo a soltar..."}
            </option>
            {opcionesDia.map((opt, i) => (
              <option key={i} value={i} className="bg-slate-900 text-slate-100">
                {opt.h}hs | {opt.s} ({opt.n})
              </option>
            ))}
          </select>
        </div>

        {/* BOTÓN SOLTAR TURNO (CON MODO VACACIONES INTEGRADO) */}
<button 
  onClick={async (e) => {
    if (cargando || !online || (modoVacaciones && !esAdminOStaff)) return; 
    setCargando(true); 
    try { await soltarTurno(e); } catch (err) { console.error(err); } finally { setCargando(false); }
  }} 
  disabled={!turnoElegido || cargando || !online || (modoVacaciones && !esAdminOStaff)} 
  className={`w-full font-black py-3.5 rounded-xl transition-all transform active:scale-95 disabled:active:scale-100 text-xs uppercase tracking-widest flex items-center justify-center gap-2 ${
    !online 
      ? "bg-slate-800 text-slate-500 border border-slate-700 cursor-not-allowed"
      : (modoVacaciones && !esAdminOStaff)
      ? "bg-amber-500/10 text-amber-400 border border-amber-500/30 cursor-not-allowed"
      : !turnoElegido
      ? "bg-slate-800/60 text-slate-500 border border-white/5 cursor-not-allowed"
      : "bg-gradient-to-r from-orange-600 to-amber-600 hover:from-orange-500 hover:to-amber-500 text-white shadow-[0_0_20px_rgba(234,88,12,0.4)]"
  }`}
>
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z" />
  </svg>
  <span>
    {!online 
      ? "📡 SIN CONEXIÓN" 
      : (modoVacaciones && !esAdminOStaff)
      ? "🏖️ CLUB DE VACACIONES"
      : cargando 
      ? "PROCESANDO..." 
      : "SOLTAR TURNO"}
  </span>
</button>
      </div>
    )}

    {/* MENSAJE CUANDO NO HAY TURNOS ESE DÍA */}
    {fechaSel && opcionesDia.length === 0 && (
      <div className="p-3.5 bg-slate-900/60 rounded-xl border border-dashed border-white/10 text-center animate-in fade-in duration-200">
        <p className="text-slate-400 text-xs font-bold uppercase tracking-tight">
          🗓️ No tenes turnos fijos para esta fecha.
        </p>
      </div>
    )}
  </div>
</section>

    {/* --- TURNOS DISPONIBLES (ESTÉTICA CLEAN FROSTED GLASS CON SVGs) --- */}
<div className="mt-4 mb-4">
  {/* Encabezado con SVG Portapapeles/Lista */}
  <h3 className="text-sm font-black text-white mb-3.5 flex items-center gap-2 uppercase tracking-wider">
    <svg className="w-5 h-5 text-cyan-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
    </svg>
    <span>Turnos Disponibles</span>
  </h3>

  {/* Selector de Filtro (Todos / Hoy / Mañana) con Cristal Clean */}
  <div className="flex bg-slate-800/80 backdrop-blur-2xl p-1.5 rounded-xl border border-white/10 mb-6 shadow-[0_8px_25px_rgba(0,0,0,0.4)]">
    {["Todos", "Hoy", "Mañana"].map(opc => (
      <button 
        key={opc} 
        onClick={() => setFiltroDisponibles(opc)}
        className={`flex-1 py-2 rounded-lg text-xs font-black uppercase tracking-wider transition-all ${
          filtroDisponibles === opc 
            ? 'bg-cyan-500 text-slate-950 shadow-[0_0_15px_rgba(34,211,238,0.4)]' 
            : 'text-slate-400 hover:text-slate-200'
        }`}
      >
        {opc}
      </button>
    ))}
  </div>
</div>

{(() => {
  // 1. Filtrar los turnos
  const turnosFiltrados = pizarron.filter(t => {
    if (filtroDisponibles === "Todos") return true;
    const hoy = new Date(); hoy.setHours(0,0,0,0);
    const manana = new Date(hoy); manana.setDate(manana.getDate() + 1);
    const fechaTurno = new Date(t.dia + "T00:00:00");
    if (filtroDisponibles === "Hoy") return fechaTurno.getTime() === hoy.getTime();
    if (filtroDisponibles === "Mañana") return fechaTurno.getTime() === manana.getTime();
    return true;
  });

  if (turnosFiltrados.length === 0) {
    return (
      <div className="text-center py-10 px-4 bg-slate-800/40 backdrop-blur-xl rounded-2xl border border-dashed border-white/10 text-slate-400 text-xs font-bold uppercase tracking-wider mb-8">
        Cosmo no encontró turnos liberados.
      </div>
    );
  }

  // 2. Agrupar turnos por fecha (dia)
  const agrupadosDisponibles = turnosFiltrados.reduce((acc, t) => {
    if (!acc[t.dia]) acc[t.dia] = [];
    acc[t.dia].push(t);
    return acc;
  }, {});

  return (
    <div className="flex flex-col gap-6 mb-8">
      {Object.keys(agrupadosDisponibles).map(fecha => (
        <div key={fecha} className="relative">
          
          {/* ETIQUETA DE FECHA ESTILO NEÓN CON SVG CALENDARIO */}
          <div className="inline-flex items-center gap-2 bg-cyan-950/60 text-cyan-300 px-3.5 py-1.5 rounded-xl text-xs font-black tracking-wider border border-cyan-500/40 mb-3.5 shadow-[0_0_15px_rgba(34,211,238,0.2)] uppercase">
            <svg className="w-3.5 h-3.5 text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <span>{formatearFechaPizarron(fecha)}</span>
          </div>

          <div className="flex flex-col gap-2.5">
            {agrupadosDisponibles[fecha].map(t => {
              const ahora = new Date();
              const [hh, mm] = t.h.split(':');
              const fTurno = new Date(`${t.dia}T${hh}:${mm}:00`);
              const difMinutos = (fTurno - ahora) / (1000 * 60);
              
              const esPasado = difMinutos < 0;
              const esInminente = difMinutos > 0 && difMinutos <= 30;

              const colorMesaHex = t.n === 'Negro' ? '#94a3b8' : t.n === 'Violeta' ? '#a855f7' : '#06b6d4'; 

              return (
                <div 
                  key={t.id} 
                  className={`relative bg-slate-800/80 backdrop-blur-2xl p-3.5 sm:p-4 rounded-xl flex items-center justify-between border border-white/10 shadow-[0_8px_25px_rgba(0,0,0,0.5)] transition-all ${
                    esPasado ? 'opacity-75 grayscale-[20%]' : ''
                  }`} 
                  style={{ borderLeft: `5px solid ${colorMesaHex}` }}
                >
                  <div className="flex-1 pr-3">
                    {/* Mesa / Nivel */}
                    <div className="flex items-center gap-2 mb-0.5">
                      <b className="text-xs uppercase tracking-wider font-black" style={{ color: colorMesaHex }}>
                        Nivel {t.n}
                      </b>
                    </div>
                    
                    {/* SEDE Y HORA MÁS GRANDES */}
                    <div className="text-base font-black text-white flex items-center gap-2">
                      <span>{t.s}</span> 
                      <span className="text-slate-600">|</span> 
                      <span className="text-lg font-black text-cyan-400 tabular-nums">{t.h}hs</span>
                    </div>
                    
                    <div className="text-[11px] text-slate-400 mt-1 font-bold uppercase tracking-tight">
                      Cede: <span className="text-slate-200 font-black">{t.nombre}</span>
                    </div>
                    
                    {/* ALERTAS DE TIEMPO CON SVGS */}
                    {esPasado && (
                      <div className="inline-flex items-center gap-1 mt-2 px-2 py-0.5 bg-rose-500/15 border border-rose-500/30 rounded text-[9px] text-rose-400 font-black uppercase tracking-wider">
                        <svg className="w-3 h-3 text-rose-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span>EN CURSO (Últimos minutos)</span>
                      </div>
                    )}
                    
                    {esInminente && (
                      <div className="inline-flex items-center gap-1 mt-2 px-2 py-0.5 bg-amber-500/15 border border-amber-500/30 rounded text-[9px] text-amber-400 font-black uppercase tracking-wider animate-pulse">
                        <svg className="w-3 h-3 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span>¡EMPIEZA EN {Math.round(difMinutos)} MIN!</span>
                      </div>
                    )}
                  </div>
                  
                  {/* Botón Tomar / Pescar */}
                  <button 
                    onClick={() => tomarTurno(t)} 
                    className={`shrink-0 px-4 py-3 rounded-xl font-black text-xs uppercase tracking-widest transition-all active:scale-95 shadow-md ${
                      esPasado 
                        ? 'bg-slate-700 hover:bg-slate-600 text-slate-200 border border-slate-500' 
                        : 'bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-slate-950 font-black shadow-[0_0_20px_rgba(34,211,238,0.4)]'
                    }`}
                  >
                    {esPasado ? "PESCAR" : "TOMAR"}
                  </button>
                </div>
              );
            })}
          </div>

        </div>
      ))}
    </div>
  );
})()}

    {/* --- LIBRO DE INTERCAMBIOS (ESTÉTICA CLEAN FROSTED GLASS CON SVGs) --- */}
<div className="mt-10 mb-4 flex justify-between items-center">
  {/* Encabezado con Icono SVG Check / Verificación */}
  <h3 className="text-sm font-black text-white flex items-center gap-2 uppercase tracking-wider">
    <svg className="w-5 h-5 text-emerald-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
    <span>Libro de Intercambios</span>
  </h3>

  {user?.email === ADMIN_EMAIL && (
    <button 
      onClick={() => { 
        if(window.confirm("¿Estás seguro de que querés vaciar todo el libro de intercambios completados?")) {
          remove(ref(db, 'intercambios_completados')); 
        }
      }} 
      className="bg-rose-500/15 hover:bg-rose-500/25 border border-rose-500/30 text-rose-400 px-3 py-1.5 rounded-lg text-[10px] font-black uppercase tracking-wider transition-all active:scale-95"
    >
      VACIAR
    </button>
  )}
</div>

{/* Selector de Filtro (Todos / Hoy / Mañana) con Cristal Clean */}
<div className="flex bg-slate-800/80 backdrop-blur-2xl p-1.5 rounded-xl border border-white/10 mb-6 shadow-[0_8px_25px_rgba(0,0,0,0.4)]">
  {["Todos", "Hoy", "Mañana"].map(opc => (
    <button 
      key={opc} 
      onClick={() => setFiltroHistorial(opc)} 
      className={`flex-1 py-2 rounded-lg text-xs font-black uppercase tracking-wider transition-all ${
        filtroHistorial === opc 
          ? 'bg-cyan-500 text-slate-950 shadow-[0_0_15px_rgba(34,211,238,0.4)]' 
          : 'text-slate-400 hover:text-slate-200'
      }`}
    >
      {opc}
    </button>
  ))}
</div>

<div className="mb-20 flex flex-col gap-6">
  {Object.keys(agrupados).map(fecha => (
    <div key={fecha} className="relative">
      
      {/* Etiqueta de Fecha Estilo Neón con SVG Calendario */}
      <div className="inline-flex items-center gap-2 bg-cyan-950/60 text-cyan-300 px-3.5 py-1.5 rounded-xl text-xs font-black tracking-wider border border-cyan-500/40 mb-3.5 shadow-[0_0_15px_rgba(34,211,238,0.2)] uppercase">
        <svg className="w-3.5 h-3.5 text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
        <span>{formatearFechaPizarron(fecha)}</span>
      </div>

      <div className="flex flex-col gap-2.5">
        {agrupados[fecha].map(h => (
          <div 
            key={h.idFirebase} 
            className="bg-slate-800/80 backdrop-blur-2xl p-3.5 sm:p-4 rounded-xl border border-white/10 border-l-[4px] border-l-emerald-500 flex justify-between items-center group transition-all hover:bg-slate-800 shadow-[0_8px_25px_rgba(0,0,0,0.5)]"
          >
            <div className="flex-1 min-w-0">
              
              {/* Encabezado del Turno */}
              <div className="font-black text-slate-100 text-[13px] mb-2.5 group-hover:text-emerald-400 transition-colors flex items-center gap-2 uppercase tracking-wide">
                <span className="bg-emerald-500/20 text-emerald-400 px-1.5 py-0.5 rounded text-[9px] font-black tracking-wider flex items-center gap-1 border border-emerald-500/30">
                  <svg className="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                  </svg>
                  OK
                </span>
                <span>{h.h} hs | {h.s} ({h.n})</span>
              </div>
              
              {/* CONTENEDOR DE NOMBRES CON ALTO CONTRASTE Y SVGs */}
              <div className="flex flex-wrap items-center gap-2">
                
                {/* Quién Cedió */}
                <div className="flex items-center bg-amber-500/10 px-2 py-1 rounded-lg border border-amber-500/20">
                  <span className="text-amber-400 font-bold text-[9px] uppercase mr-1.5 tracking-wider">Cede:</span>
                  <b className="text-amber-100 text-[10px] font-black truncate max-w-[90px] sm:max-w-none uppercase">
                    {h.nombre}
                  </b>
                </div>
                
                {/* Flecha SVG de Intercambio */}
                <svg className="w-3.5 h-3.5 text-slate-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>

                {/* Quién Tomó */}
                <div className="flex items-center bg-cyan-500/10 px-2 py-1 rounded-lg border border-cyan-500/20 shadow-[0_0_10px_rgba(6,182,212,0.1)]">
                  <span className="text-cyan-400 font-bold text-[9px] uppercase mr-1.5 tracking-wider">Toma:</span>
                  <b className="text-cyan-300 text-[10px] font-black truncate max-w-[90px] sm:max-w-none uppercase">
                    {h.quienTomo}
                  </b>
                </div>
              </div>

            </div>

            {/* BOTÓN ELIMINAR REGISTRO INDIVIDUAL (CON CONFIRMACIÓN ADMIN) */}
            {user?.email === ADMIN_EMAIL && (
              <button 
                onClick={() => {
                  if (window.confirm(`¿Eliminar este registro de intercambio de ${h.nombre}?`)) {
                    remove(ref(db, `intercambios_completados/${h.idFirebase}`));
                  }
                }} 
                className="ml-3 p-2 text-slate-500 hover:text-rose-400 hover:bg-rose-500/15 rounded-lg border border-transparent hover:border-rose-500/30 transition-all shrink-0 active:scale-95"
                title="Eliminar registro"
              >
                <svg className="w-4 h-4 text-slate-400 hover:text-rose-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  ))}
</div>
  </div>
)}


{pestañaActiva === "eventos" && (
  <div className="animate-in fade-in duration-300 pb-16">
    
    {/* SUB-NAVEGACIÓN DE TORNEOS Y EVENTOS (ESTÉTICA CLEAN FROSTED GLASS CON SVGs) */}
<div className="flex bg-slate-800/80 backdrop-blur-2xl p-1.5 rounded-xl border border-white/10 mb-6 gap-1.5 overflow-x-auto [&::-webkit-scrollbar]:hidden shadow-[0_8px_25px_rgba(0,0,0,0.4)]">
  
  {/* 1. TORNEOS */}
  <button 
    onClick={() => setSubPestañaTorneos("torneos")} 
    className={`flex-1 py-2 px-3 rounded-lg text-[10px] font-black uppercase tracking-wider whitespace-nowrap transition-all flex items-center justify-center gap-1.5 ${
      subPestañaTorneos === "torneos" 
        ? 'bg-cyan-500 text-slate-950 shadow-[0_0_15px_rgba(34,211,238,0.4)]' 
        : 'text-slate-400 hover:text-slate-200'
    }`}
  >
    <svg className="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
    </svg>
    <span>Torneos</span>
  </button>

  {/* 2. EVENTOS */}
  <button 
    onClick={() => setSubPestañaTorneos("eventos")} 
    className={`flex-1 py-2 px-3 rounded-lg text-[10px] font-black uppercase tracking-wider whitespace-nowrap transition-all flex items-center justify-center gap-1.5 ${
      subPestañaTorneos === "eventos" 
        ? 'bg-purple-500 text-white shadow-[0_0_15px_rgba(168,85,247,0.4)]' 
        : 'text-slate-400 hover:text-slate-200'
    }`}
  >
    <svg className="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
    </svg>
    <span>Eventos</span>
  </button>

  {/* 3. RANKING */}
  <button 
    onClick={() => setSubPestañaTorneos("ranking")} 
    className={`flex-1 py-2 px-3 rounded-lg text-[10px] font-black uppercase tracking-wider whitespace-nowrap transition-all flex items-center justify-center gap-1.5 ${
      subPestañaTorneos === "ranking" 
        ? 'bg-amber-400 text-slate-950 shadow-[0_0_15px_rgba(251,191,36,0.4)]' 
        : 'text-slate-400 hover:text-slate-200'
    }`}
  >
    <svg className="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h4a2 2 0 002-2zm0 0V9a2 2 0 012-2h4a2 2 0 012 2v10m-6 0a2 2 0 002 2h4a2 2 0 002-2m0 0V5a2 2 0 012-2h4a2 2 0 012 2v14a2 2 0 01-2 2h-4a2 2 0 01-2-2z" />
    </svg>
    <span>Ranking</span>
  </button>

  {/* 4. RESULTADOS */}
  <button 
    onClick={() => setSubPestañaTorneos("resultados")} 
    className={`flex-1 py-2 px-3 rounded-lg text-[10px] font-black uppercase tracking-wider whitespace-nowrap transition-all flex items-center justify-center gap-1.5 ${
      subPestañaTorneos === "resultados" 
        ? 'bg-emerald-500 text-slate-950 shadow-[0_0_15px_rgba(16,185,129,0.4)]' 
        : 'text-slate-400 hover:text-slate-200'
    }`}
  >
    <svg className="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
    <span>Resultados</span>
  </button>

  {/* 5. ADMIN (SÓLO ADMIN / STAFF) */}
  {(user?.email === ADMIN_EMAIL || user?.email === STAFF_EMAIL) && (
    <button 
      onClick={() => setSubPestañaTorneos("admin")} 
      className={`flex-1 py-2 px-3 rounded-lg text-[10px] font-black uppercase tracking-wider whitespace-nowrap transition-all flex items-center justify-center gap-1.5 ${
        subPestañaTorneos === "admin" 
          ? 'bg-rose-600 text-white shadow-[0_0_15px_rgba(225,29,72,0.4)]' 
          : 'text-slate-400 hover:text-slate-200'
      }`}
    >
      <svg className="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
      <span>Admin</span>
    </button>
  )}

</div>

    {/* --- SUBPESTAÑA 1: TORNEOS (Inscripciones) --- */}
{subPestañaTorneos === "torneos" && (
  <div className="space-y-4 animate-in fade-in duration-300">
    <h4 className="text-center text-xs font-black text-cyan-400 uppercase tracking-widest mb-4">
      🏓 Torneos Abiertos
    </h4>

    {/* Filtramos para ignorar los torneos marcados como 'finalizado' */}
    {torneosActivos?.filter((t) => t.estado !== "finalizado").length === 0 ? (
      <div className="text-center py-10 bg-slate-800/20 rounded-3xl border border-white/5 border-dashed italic text-slate-500 text-xs">
        No hay torneos abiertos actualmente.
      </div>
    ) : (
      torneosActivos
        ?.filter((t) => t.estado !== "finalizado")
        .map((t) => {
          const inscriptos = t.inscriptos ? Object.entries(t.inscriptos) : [];
          const inscriptosLista = inscriptos.map(([k, v]) => v);

          const yaInscripto = inscriptosLista.some(
            (i) => i.uid === user?.uid || i.compañeroUid === user?.uid
          );
          const estaLleno = inscriptosLista.length >= t.cupo;

          return (
            <div
              key={t.id}
              className="bg-slate-900/60 backdrop-blur-xl p-5 rounded-3xl border border-white/10 shadow-xl relative overflow-hidden"
            >
              {/* Indicador de modalidad */}
              <div className="flex justify-between items-start mb-2">
                <div>
                  <h5 className="font-black text-white text-base uppercase leading-tight">
                    {t.nombre}
                  </h5>

                  {/* MUESTRA DE FECHA Y HORA DE INICIO */}
                  {t.fechaInicio && (
                    <span className="inline-flex items-center gap-1 mt-1 text-[10px] font-black text-cyan-400 bg-cyan-950/60 border border-cyan-500/30 px-2 py-0.5 rounded-md">
                      🕒{" "}
                      {new Date(t.fechaInicio).toLocaleDateString("es-AR", {
                        weekday: "short",
                        day: "2-digit",
                        month: "2-digit",
                      })}{" "}
                      •{" "}
                      {new Date(t.fechaInicio).toLocaleTimeString("es-AR", {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                      hs
                    </span>
                  )}
                </div>

                <span className="text-[9px] font-black px-2.5 py-1 bg-cyan-500/20 text-cyan-400 border border-cyan-500/30 rounded-lg uppercase">
                  {t.modo} ({t.formato})
                </span>
              </div>

              {/* Ficha técnica */}
              <div className="grid grid-cols-3 gap-2 mb-4 text-center">
                <div className="bg-white/5 p-2 rounded-xl border border-white/5">
                  <span className="block text-[8px] uppercase font-bold text-slate-500">
                    Cupo
                  </span>
                  <b
                    className={`text-xs ${
                      estaLleno ? "text-amber-400" : "text-slate-200"
                    }`}
                  >
                    {inscriptosLista.length} / {t.cupo}
                  </b>
                </div>
                <div className="bg-white/5 p-2 rounded-xl border border-white/5">
                  <span className="block text-[8px] uppercase font-bold text-slate-500">
                    Factor Rating
                  </span>
                  <b className="text-xs text-amber-400">
                    {t.esFinals
                      ? "2x (Finals)"
                      : t.modo === "dobles"
                      ? "0.5x"
                      : "1x"}
                  </b>
                </div>
                <div className="bg-white/5 p-2 rounded-xl border border-white/5">
                  <span className="block text-[8px] uppercase font-bold text-slate-500">
                    Inscripción
                  </span>
                  <b className="text-xs text-emerald-400">
                    {t.precio || "Gratis"}
                  </b>
                </div>
              </div>

              {/* LISTADO DE INSCRIPTOS */}
              <div className="bg-slate-950/40 p-3 rounded-2xl border border-white/5 mb-4 flex flex-wrap gap-2 min-h-[40px] items-center shadow-inner">
                {inscriptos.length > 0 ? (
                  inscriptos.map(([idKey, data]) => (
                    <span
                      key={idKey}
                      className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-bold bg-slate-800 border border-white/10 text-slate-200"
                    >
                      👤 {data.nombre}{" "}
                      {data.compañero ? `+ ${data.compañero}` : ""}
                      {(user?.email === ADMIN_EMAIL ||
                        user?.email === STAFF_EMAIL) && (
                        <button
                          onClick={() =>
                            remove(
                              ref(db, `torneos_activos/${t.id}/inscriptos/${idKey}`)
                            )
                          }
                          className="ml-1 text-rose-400 hover:text-rose-600 transition-colors text-sm font-black leading-none"
                        >
                          ×
                        </button>
                      )}
                    </span>
                  ))
                ) : (
                  <span className="text-slate-600 italic text-[10px] w-full text-center">
                    Aún no hay inscriptos. ¡Sé el primero!
                  </span>
                )}
              </div>

              {/* BOTÓN DE ACCIÓN */}
              <button
                onClick={() => inscribirseATorneo(t)}
                disabled={yaInscripto || estaLleno}
                className={`w-full py-3.5 rounded-xl font-black text-xs uppercase tracking-widest transition-all shadow-lg active:scale-95 ${
                  yaInscripto
                    ? "bg-emerald-600 text-white shadow-emerald-500/20"
                    : estaLleno
                    ? "bg-slate-800 text-slate-500 border border-white/5 cursor-not-allowed"
                    : "bg-gradient-to-r from-cyan-600 to-blue-600 text-white shadow-cyan-500/30 hover:scale-[1.01]"
                }`}
              >
                {yaInscripto
                  ? "✅ Ya estás inscripto"
                  : estaLleno
                  ? "⚠️ Cupo Completo"
                  : "Inscribirme al Torneo"}
              </button>

              {/* OPCIONES DE ADMINISTRACIÓN */}
              {(user?.email === ADMIN_EMAIL || user?.email === STAFF_EMAIL) && (
                <div className="mt-4 pt-3 border-t border-white/5 flex justify-between items-center">
                  <button
                    onClick={() => {
                      if (
                        window.confirm(
                          `¿Cerrar y dar por finalizado el torneo "${t.nombre}"?\n\nDejará de aparecer en la lista de inscripciones abiertas.`
                        )
                      ) {
                        update(ref(db, `torneos_activos/${t.id}`), {
                          estado: "finalizado",
                        });
                      }
                    }}
                    className="text-[9px] font-bold text-emerald-400/80 hover:text-emerald-300 uppercase tracking-widest transition-colors"
                  >
                    🏁 Finalizar Torneo
                  </button>

                  <button
                    onClick={() => {
                      if (window.confirm(`¿Eliminar torneo "${t.nombre}"?`)) {
                        remove(ref(db, `torneos_activos/${t.id}`));
                      }
                    }}
                    className="text-[9px] font-bold text-rose-500/60 hover:text-rose-400 uppercase tracking-widest transition-colors"
                  >
                    🗑️ Eliminar
                  </button>
                </div>
              )}
            </div>
          );
        })
    )}
  </div>
)}

    {/* --- SUBPESTAÑA 2: EVENTOS (Conservado Intacto) --- */}
    {subPestañaTorneos === "eventos" && (
      <div className="space-y-4">
        {/* Aquí va exactamente tu bloque original del Mapeo de 'eventos' */}
        <section className="animate-in fade-in duration-500">
  <h3 className="text-center text-xl font-black text-white mb-6 tracking-widest uppercase flex justify-center items-center gap-2">
    <span className="text-2xl text-yellow-500 drop-shadow-[0_0_8px_rgba(234,179,8,0.4)]">🏆</span> 
    Eventos del Club
  </h3>
  
  {eventos.length === 0 ? (
    <div className="text-center py-10 bg-slate-800/30 rounded-3xl border border-white/5 border-dashed">
      <p className="text-slate-500 italic text-sm font-medium">No hay eventos programados por ahora.</p>
    </div>
  ) : (
    eventos.map(ev => {
      const inscriptos = ev.inscriptos ? Object.values(ev.inscriptos) : [];
      const yaInscripto = inscriptos.some(i => i.uid === user?.uid);
      const cupoMaximo = ev.ev_cupo || ev.cupo;
      const estaLleno = inscriptos.length >= cupoMaximo;
      
      return (
        <div key={ev.id} className="relative bg-slate-900/60 backdrop-blur-xl p-5 rounded-3xl mb-5 border border-white/10 shadow-xl overflow-hidden group">
          
          {/* Indicador lateral de estado */}
          <div className={`absolute top-0 left-0 w-1.5 h-full ${ev.cerrado ? 'bg-red-500' : (estaLleno ? 'bg-orange-500' : 'bg-cyan-500')}`}></div>

          <h4 className="text-lg font-black text-white mb-3 group-hover:text-cyan-400 transition-colors uppercase leading-tight">
            {ev.ev_titulo || ev.titulo}
          </h4>
          
          <div className="grid grid-cols-2 gap-3 mb-4">
            <div className="bg-white/5 p-2 rounded-xl border border-white/5 text-center">
              <span className="block text-[9px] uppercase font-bold text-slate-500 tracking-tighter">Cupo</span>
              <b className={`text-sm ${estaLleno ? 'text-orange-400' : 'text-slate-200'}`}>{inscriptos.length} / {cupoMaximo}</b>
            </div>
            <div className="bg-white/5 p-2 rounded-xl border border-white/5 text-center">
              <span className="block text-[9px] uppercase font-bold text-slate-500 tracking-tighter">Precio</span>
              <b className="text-sm text-emerald-400">
  {ev.precio ? (ev.precio.startsWith('$') ? ev.precio : `$${ev.precio}`) : 'A definir'}
</b>
            </div>
          </div>

          {ev.cerrado && (
            <div className="mb-4 py-1.5 bg-red-500/10 border border-red-500/20 rounded-lg text-center text-[10px] font-black text-red-500 tracking-widest uppercase animate-pulse">
              🔒 Inscripción Cerrada por Admin
            </div>
          )}

          {/* LISTA DE INSCRIPTOS ESTILO CAPSULAS */}
          <div className="bg-slate-950/40 p-3 rounded-2xl border border-white/5 mb-5 flex flex-wrap gap-2 min-h-[45px] items-center shadow-inner">
            {ev.inscriptos && typeof ev.inscriptos === 'object' ? (
              Object.entries(ev.inscriptos).map(([idKey, data]) => (
                <span key={idKey} className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[11px] font-bold border ${data.tipo === 'manual' ? 'bg-yellow-500/10 border-yellow-500/30 text-yellow-200' : 'bg-slate-700/50 border-white/10 text-slate-200'}`}>
                  {data.nombre || data}
                  {user?.email === ADMIN_EMAIL && (
                    <button 
                      onClick={() => remove(ref(db, `eventos/${ev.id}/inscriptos/${idKey}`))} 
                      className="ml-1 text-red-400 hover:text-red-600 transition-colors text-lg leading-none"
                    >
                      ×
                    </button>
                  )}
                </span>
              ))
            ) : (
              <span className="text-slate-600 italic text-[11px] w-full text-center">Todavía no hay inscriptos</span>
            )}
          </div>

          {/* BOTÓN PRINCIPAL */}
          <button 
            onClick={() => inscribirseAEvento(ev)}
            disabled={yaInscripto || estaLleno || ev.cerrado}
            className={`w-full py-4 rounded-xl font-black text-xs uppercase tracking-widest transition-all shadow-lg active:scale-95 ${
              yaInscripto 
                ? 'bg-emerald-600 text-white shadow-emerald-500/20' 
                : (ev.cerrado || estaLleno 
                  ? 'bg-slate-800 text-slate-500 border border-white/5 cursor-not-allowed' 
                  : 'bg-gradient-to-r from-cyan-600 to-blue-600 text-white shadow-cyan-500/30 hover:scale-[1.02]')
            }`}
          >
            {yaInscripto ? "✅ Ya estás anotado" : (ev.cerrado ? "🚫 Inscripción Cerrada" : (estaLleno ? "⚠️ Cupo Lleno" : "Anotarme Ahora"))}
          </button>

          {/* PANEL ADMIN DENTRO DEL EVENTO */}
          {user?.email === ADMIN_EMAIL && (
            <div className="mt-5 pt-4 border-t border-white/10 grid grid-cols-2 gap-3">
              <button 
                onClick={() => toggleCerrarEvento(ev)}
                className={`py-2.5 rounded-xl text-[10px] font-black uppercase transition-all border ${ev.cerrado ? 'bg-emerald-500/10 border-emerald-500 text-emerald-400' : 'bg-orange-500/10 border-orange-500 text-orange-400'}`}
              >
                {ev.cerrado ? "🔓 Abrir" : "🔒 Cerrar"}
              </button>
              
              <button 
                onClick={() => agregarInvitadoManual(ev.id)}
                className="bg-slate-800 text-slate-200 py-2.5 rounded-xl text-[10px] font-black uppercase border border-white/10 hover:bg-slate-700 transition-all"
              >
                👤 + Invitado
              </button>

              <button 
                onClick={() => { if(window.confirm("¿Eliminar evento?")) remove(ref(db, `eventos/${ev.id}`)) }} 
                className="col-span-2 mt-2 text-red-500/60 hover:text-red-500 text-[10px] font-bold uppercase transition-colors"
              >
                Eliminar Evento Permanentemente
              </button>
            </div>
          )}
        </div>
      );
    })
  )}

  {/* BOTON CREAR EVENTO (ADMIN) */}
  {user?.email === ADMIN_EMAIL && (
    <button 
      onClick={crearEvento}
      className="w-full mt-6 py-5 rounded-3xl border-2 border-dashed border-slate-700 bg-slate-900/20 hover:bg-slate-800/40 hover:border-slate-500 text-slate-500 hover:text-slate-300 font-black transition-all group"
    >
      <span className="text-xl group-hover:scale-125 transition-transform inline-block mr-2">+</span> 
      CREAR NUEVO EVENTO
    </button>
  )}
</section>
      </div>
    )}

    {/* --- SUBPESTAÑA 3: RANKING GENERAL --- */}
{subPestañaTorneos === "ranking" && (
  <div className="space-y-4 animate-in fade-in duration-300">
    <h4 className="text-center text-xs font-black text-yellow-400 uppercase tracking-widest mb-4">
      👑 Ranking General Astros
    </h4>
    <div className="bg-slate-900/60 rounded-3xl p-4 border border-white/10 shadow-xl">
      {(() => {
        // 1. FILTRAMOS SOLO LOS USUARIOS CON VISIBILIDAD EN RANKING ACTIVADA
        const usuariosVisibles = (usuariosAdmin || []).filter(u => u.enRanking === true);

        if (usuariosVisibles.length === 0) {
          return (
            <div className="text-center py-8 italic text-slate-500 text-xs">
              Aún no hay jugadores activos visibles en el ranking.
            </div>
          );
        }

        return (
          <div className="divide-y divide-white/5">
            {usuariosVisibles
              .map(u => ({ 
                ...u, 
                ratingCalculado: u.rating ?? (u.nivel === 'Negro' ? 1000 : u.nivel === 'Violeta' ? 600 : 300) 
              }))
              .sort((a, b) => b.ratingCalculado - a.ratingCalculado)
              .map((u, idx) => (
                <div key={u.uid} className="flex justify-between items-center py-3">
                  <div className="flex items-center gap-3">
                    <span className="font-black text-xs text-slate-500 w-5">#{idx + 1}</span>
                    <div className={`w-2 h-2 rounded-full ${
                      u.nivel === 'Negro' ? 'bg-white' : u.nivel === 'Violeta' ? 'bg-purple-500' : 'bg-blue-500'
                    }`}></div>
                    <div>
                      <b className="text-white text-sm block leading-tight">{u.nombre}</b>
                      <span className="text-[9px] font-bold text-slate-500 uppercase">{u.nivel || 'Azul'}</span>
                    </div>
                  </div>
                  <div className="text-right">
                    <span className="text-sm font-black text-cyan-400 tabular-nums">{u.ratingCalculado}</span>
                    <span className="block text-[8px] font-bold text-slate-500 uppercase">Pts Rating</span>
                  </div>
                </div>
              ))}
          </div>
        );
      })()}
    </div>
  </div>
)}

    {/* --- SUBPESTAÑA 4: RESULTADOS --- */}
{subPestañaTorneos === "resultados" && (
  <div className="space-y-6 animate-in fade-in duration-300">
    <h4 className="text-center text-xs font-black text-emerald-400 uppercase tracking-widest mb-2">
      📜 Historial de Partidos Cargados
    </h4>
    
    {/* --- SECCIÓN HEAD TO HEAD (CARA A CARA) --- */}
    <div className="bg-slate-900/80 rounded-3xl p-5 border border-white/10 shadow-2xl space-y-5 mb-6">
      <h4 className="text-center text-xs font-black text-amber-400 uppercase tracking-widest flex items-center justify-center gap-2">
        <span>⚔️</span> Comparador Head to Head <span>⚔️</span>
      </h4>

      {/* Selectores de Jugadores */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div>
          <label className="block text-[10px] font-bold text-slate-400 uppercase mb-1">Jugador 1</label>
          <select
            value={h2hJugador1}
            onChange={(e) => setH2hJugador1(e.target.value)}
            className="w-full bg-slate-800 border border-white/10 rounded-xl px-3 py-2 text-xs font-bold text-white focus:outline-none focus:border-amber-400"
          >
            <option value="">-- Seleccionar Jugador --</option>
            {usuariosAdmin.map(u => (
              <option key={u.uid} value={u.uid} disabled={u.uid === h2hJugador2}>
                {u.nombre} ({u.nivel || 'Azul'})
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-[10px] font-bold text-slate-400 uppercase mb-1">Jugador 2</label>
          <select
            value={h2hJugador2}
            onChange={(e) => setH2hJugador2(e.target.value)}
            className="w-full bg-slate-800 border border-white/10 rounded-xl px-3 py-2 text-xs font-bold text-white focus:outline-none focus:border-amber-400"
          >
            <option value="">-- Seleccionar Jugador --</option>
            {usuariosAdmin.map(u => (
              <option key={u.uid} value={u.uid} disabled={u.uid === h2hJugador1}>
                {u.nombre} ({u.nivel || 'Azul'})
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Renderizado de Resultados H2H */}
      {(() => {
        if (!h2hJugador1 || !h2hJugador2) {
          return (
            <div className="text-center py-4 text-slate-500 text-xs italic">
              Seleccioná dos jugadores para ver su historial cara a cara.
            </div>
          );
        }

        if (h2hJugador1 === h2hJugador2) return null;

        const h2h = obtenerHistorialH2H(h2hJugador1, h2hJugador2);

        if (!h2h || h2h.totalPartidos === 0) {
          return (
            <div className="text-center py-6 bg-slate-950/40 rounded-2xl border border-white/5">
              <p className="text-xs text-slate-400 italic">
                Aún no hay enfrentamientos registrados entre <b className="text-white">{h2h.j1.nombre}</b> y <b className="text-white">{h2h.j2.nombre}</b>.
              </p>
            </div>
          );
        }

        return (
          <div className="space-y-4 animate-in fade-in duration-300">
            {/* Marcador Principal H2H */}
            <div className="bg-slate-950/60 rounded-2xl p-4 border border-white/10 flex justify-between items-center text-center">
              
              {/* Jugador 1 */}
              <div className="flex-1">
                <span className="text-[10px] font-black uppercase text-slate-500 block">{h2h.j1.nivel || 'Azul'}</span>
                <b className="text-sm text-white block leading-tight">{h2h.j1.nombre}</b>
                <span className="text-3xl font-black text-amber-400 mt-1 block">{h2h.victoriasJ1}</span>
                <span className="text-[9px] text-slate-500 font-bold uppercase block">Victorias</span>
              </div>

              {/* VS Divider */}
              <div className="px-3">
                <span className="text-xs font-black text-slate-500 bg-slate-800 px-2.5 py-1 rounded-full border border-white/5">
                  VS
                </span>
                <span className="text-[9px] font-bold text-slate-500 block mt-2">
                  {h2h.totalPartidos} {h2h.totalPartidos === 1 ? 'partido' : 'partidos'}
                </span>
              </div>

              {/* Jugador 2 */}
              <div className="flex-1">
                <span className="text-[10px] font-black uppercase text-slate-500 block">{h2h.j2.nivel || 'Azul'}</span>
                <b className="text-sm text-white block leading-tight">{h2h.j2.nombre}</b>
                <span className="text-3xl font-black text-amber-400 mt-1 block">{h2h.victoriasJ2}</span>
                <span className="text-[9px] text-slate-500 font-bold uppercase block">Victorias</span>
              </div>
            </div>

            {/* Historial Detallado de Encuentros H2H */}
            <div className="space-y-2">
              <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block">
                Historial de enfrentamientos
              </span>
              <div className="divide-y divide-white/5 bg-slate-950/30 rounded-2xl p-3 border border-white/5 max-h-56 overflow-y-auto">
                {h2h.enfrentamientos.map((p, idx) => {
                  const e1 = p.equipo1 || [];
                  const j1EnE1 = e1.includes(h2hJugador1);
                  const ganoE1 = p.ganador === 1;
                  const ganoJ1 = (j1EnE1 && ganoE1) || (!j1EnE1 && !ganoE1);

                  return (
                    <div key={p.id || idx} className="py-2.5 flex justify-between items-center text-xs">
                      <div>
                        <span className="text-[9px] font-bold text-amber-400 uppercase block">
                          {p.torneoNombre || 'Torneo'} • {p.fase || 'Zona'}
                        </span>
                        <span className="text-slate-400 text-[10px]">
                          {new Date(p.fecha).toLocaleDateString('es-AR')} ({p.modo || 'singles'})
                        </span>
                      </div>

                      <div className="text-right">
                        <span className={`font-black text-xs ${ganoJ1 ? 'text-emerald-400' : 'text-purple-400'}`}>
                          {ganoJ1 ? `Ganó ${h2h.j1.nombre.split(' ')[0]}` : `Ganó ${h2h.j2.nombre.split(' ')[0]}`}
                        </span>
                        {p.puntosEnJuego > 0 && (
                          <span className="block text-[9px] text-slate-500 font-bold">
                            ±{p.puntosEnJuego} pts Rating
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      })()}
    </div>

    {/* FILTROS: TORNEOS Y JUGADORES */}
    <div className="bg-slate-900/80 p-3.5 rounded-2xl border border-white/10 shadow-lg space-y-3">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {/* FILTRO SELECTOR DE TORNEOS */}
        <div>
          <label className="block text-[9px] font-black uppercase text-slate-500 tracking-wider mb-1 ml-1">
            🔍 Filtrar por Torneo:
          </label>
          <select
            value={filtroTorneoResultado}
            onChange={(e) => setFiltroTorneoResultado(e.target.value)}
            className="w-full bg-slate-800 border border-slate-700 text-slate-200 p-3 rounded-xl text-xs font-bold outline-none focus:ring-2 focus:ring-emerald-500 [color-scheme:dark]"
          >
            <option value="TODOS">-- Todos los Torneos --</option>
            {torneosActivos?.map((t) => (
              <option key={t.id} value={t.id}>
                {t.nombre} ({t.modo})
              </option>
            ))}
          </select>
        </div>

        {/* FILTRO SELECTOR DE JUGADORES */}
        <div>
          <label className="block text-[9px] font-black uppercase text-slate-500 tracking-wider mb-1 ml-1">
            👤 Filtrar por Jugador:
          </label>
          <select
            value={filtroJugadorResultado}
            onChange={(e) => setFiltroJugadorResultado(e.target.value)}
            className="w-full bg-slate-800 border border-slate-700 text-slate-200 p-3 rounded-xl text-xs font-bold outline-none focus:ring-2 focus:ring-emerald-500 [color-scheme:dark]"
          >
            <option value="">-- Todos los Jugadores --</option>
            {usuariosAdmin
              ?.slice()
              .sort((a, b) => (a.nombre || "").localeCompare(b.nombre || ""))
              .map((u) => (
                <option key={u.uid} value={u.uid}>
                  {u.nombre}
                </option>
              ))}
          </select>
        </div>
      </div>

      {/* BOTÓN LIMPIAR FILTROS */}
      {(filtroTorneoResultado !== "TODOS" || filtroJugadorResultado) && (
        <div className="flex justify-end pt-1">
          <button
            onClick={() => {
              setFiltroTorneoResultado("TODOS");
              setFiltroJugadorResultado("");
            }}
            className="px-3 py-1.5 bg-rose-500/20 hover:bg-rose-500/30 text-rose-400 border border-rose-500/30 rounded-xl text-[10px] font-bold transition-all"
          >
            ✕ Limpiar Filtros
          </button>
        </div>
      )}
    </div>

    {/* EXCLUSIVAMENTE MUESTRA VISUAL DE TORNEOS (SIN LISTADO DE TARJETAS ABAJO) */}
    {(() => {
      const partidosFiltrados = (torneosResultados || []).filter((r) => {
        const cumpleTorneo =
          filtroTorneoResultado === "TODOS" || r.torneoId === filtroTorneoResultado;

        const cumpleJugador =
          !filtroJugadorResultado ||
          r.equipo1?.includes(filtroJugadorResultado) ||
          r.equipo2?.includes(filtroJugadorResultado);

        return cumpleTorneo && cumpleJugador;
      });

      if (partidosFiltrados.length === 0) {
        return (
          <div className="text-center py-12 bg-slate-800/20 rounded-3xl border border-white/5 border-dashed italic text-slate-500 text-xs">
            No hay partidos ni resultados registrados para esta selección.
          </div>
        );
      }

      // Agrupar partidos por Torneo y vincular inscriptos
      const partidosPorTorneo = partidosFiltrados.reduce((acc, partido) => {
        const idT = partido.torneoId || "sin_torneo";
        if (!acc[idT]) {
          const infoTorneo = torneosActivos?.find((t) => t.id === idT);
          acc[idT] = {
            id: idT,
            nombre: partido.torneoNombre || infoTorneo?.nombre || "Torneo General",
            modo: partido.modo,
            formato: infoTorneo?.formato || "Round Robin",
            esFinals: partido.esFinals,
            fechaInicio: infoTorneo?.fechaInicio || null,
            inscriptos: infoTorneo?.inscriptos || {},
            partidos: [],
          };
        }
        acc[idT].partidos.push(partido);
        return acc;
      }, {});

      return Object.entries(partidosPorTorneo).map(([torneoId, grupo]) => (
        <div
          key={torneoId}
          className="bg-slate-900/60 backdrop-blur-xl rounded-3xl p-5 border border-white/10 shadow-xl space-y-4"
        >
          {/* CABECERA DEL TORNEO */}
          <div className="flex justify-between items-start pb-3 border-b border-white/10">
            <div>
              <h5 className="font-black text-white text-sm uppercase tracking-wide flex items-center gap-2">
                <span>🏆</span> {grupo.nombre}
              </h5>

              <div className="flex items-center gap-2 mt-1">
                <span className="text-[9px] text-slate-500 uppercase font-bold">
                  {grupo.modo} {grupo.esFinals && "• ⚡ FINALS (2x)"}
                </span>

                {grupo.fechaInicio && (
                  <span className="text-[9px] font-black text-cyan-400 bg-cyan-950/60 border border-cyan-500/30 px-2 py-0.5 rounded-md">
                    🕒{" "}
                    {new Date(grupo.fechaInicio).toLocaleDateString("es-AR", {
                      weekday: "short",
                      day: "2-digit",
                      month: "2-digit",
                    })}{" "}
                    {new Date(grupo.fechaInicio).toLocaleTimeString("es-AR", {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                    hs
                  </span>
                )}
              </div>
            </div>

            <span className="text-[9px] font-black bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 px-2.5 py-1 rounded-full uppercase">
              {grupo.partidos.length}{" "}
              {grupo.partidos.length === 1 ? "partido" : "partidos"}
            </span>
          </div>

          {/* COMPONENTE VISUAL ÚNICO (BRACKETS O TABLA) */}
          <BracketTorneo
            torneo={{
              id: torneoId,
              nombre: grupo.nombre,
              formato: grupo.formato,
              inscriptos: grupo.inscriptos
            }}
            resultados={torneosResultados}
            usuarios={usuariosAdmin}
            esAdmin={user?.email === ADMIN_EMAIL || user?.email === STAFF_EMAIL}
            onRevertir={revertirUltimoResultado}
          />
        </div>
      ));
    })()}
  </div>
)}

    {/* --- SUBPESTAÑA 5: ADMIN (Creación y Carga) --- */}
    {subPestañaTorneos === "admin" && (user?.email === ADMIN_EMAIL || user?.email === STAFF_EMAIL) && (
      <div className="space-y-6">
        
        {/* BOTÓN INICIALIZAR RATING SI HACE FALTA */}
        <button 
          onClick={inicializarRatingsUsuarios}
          className="w-full bg-slate-800 text-yellow-400 border border-yellow-500/30 py-3 rounded-2xl font-black text-xs uppercase tracking-widest"
        >
          ⚡ Inicializar Rating Base en Usuarios
        </button>

        {/* FORMULARIO CREAR TORNEO */}
<div className="bg-slate-900/80 p-5 rounded-3xl border border-white/10 space-y-3">
  <h5 className="font-black text-cyan-400 text-xs uppercase tracking-widest">
    Crear Nuevo Torneo
  </h5>
  
  {/* Nombre */}
  <input 
    placeholder="Nombre del Torneo" 
    value={nuevoTorneo.nombre} 
    onChange={e => setNuevoTorneo({...nuevoTorneo, nombre: e.target.value})}
    className="w-full bg-slate-800 p-3 rounded-xl text-xs text-white border border-slate-700 outline-none focus:border-cyan-500 font-bold"
  />

  {/* FECHA Y HORA DE INICIO (NUEVO) */}
  <div className="flex flex-col gap-1">
    <label className="text-[9px] font-black uppercase text-slate-500 ml-1">
      📅 Fecha y Hora de Inicio
    </label>
    <input 
      type="datetime-local" 
      value={nuevoTorneo.fechaInicio} 
      onChange={e => setNuevoTorneo({...nuevoTorneo, fechaInicio: e.target.value})} 
      className="w-full bg-slate-800 p-3 rounded-xl text-xs text-white border border-slate-700 outline-none focus:border-cyan-500 [color-scheme:dark] font-bold"
    />
  </div>

  {/* Formato y Modo */}
  <div className="grid grid-cols-2 gap-2">
    <select 
      value={nuevoTorneo.formato} 
      onChange={e => setNuevoTorneo({...nuevoTorneo, formato: e.target.value})} 
      className="bg-slate-800 p-3 rounded-xl text-xs text-white border border-slate-700 outline-none [color-scheme:dark]"
    >
      <option value="Round Robin">Round Robin</option>
      <option value="Round Robin + Llave">Round Robin + Llave</option>
    </select>
    
    <select 
      value={nuevoTorneo.modo} 
      onChange={e => setNuevoTorneo({...nuevoTorneo, modo: e.target.value})} 
      className="bg-slate-800 p-3 rounded-xl text-xs text-white border border-slate-700 outline-none [color-scheme:dark]"
    >
      <option value="singles">Singles (1x)</option>
      <option value="dobles">Dobles (0.5x)</option>
    </select>
  </div>

  {/* Cupo y Precio */}
  <div className="grid grid-cols-2 gap-2">
    <div className="flex flex-col gap-1">
      <label className="text-[9px] font-black uppercase text-slate-500 ml-1">
        Cupo Máximo
      </label>
      <input 
        type="number"
        placeholder="Ej: 16" 
        value={nuevoTorneo.cupo} 
        onChange={e => setNuevoTorneo({...nuevoTorneo, cupo: parseInt(e.target.value) || 0})}
        className="w-full bg-slate-800 p-3 rounded-xl text-xs text-white border border-slate-700 outline-none focus:border-cyan-500"
      />
    </div>

    <div className="flex flex-col gap-1">
      <label className="text-[9px] font-black uppercase text-slate-500 ml-1">
        Precio Inscripción
      </label>
      <input 
        type="text"
        placeholder="Ej: $5000 o Gratis" 
        value={nuevoTorneo.precio} 
        onChange={e => setNuevoTorneo({...nuevoTorneo, precio: e.target.value})}
        className="w-full bg-slate-800 p-3 rounded-xl text-xs text-white border border-slate-700 outline-none focus:border-cyan-500"
      />
    </div>
  </div>

  {/* Checkbox Finals */}
  <label className="flex items-center gap-2 text-xs text-slate-300 font-bold pt-1 cursor-pointer">
    <input 
      type="checkbox" 
      checked={nuevoTorneo.esFinals} 
      onChange={e => setNuevoTorneo({...nuevoTorneo, esFinals: e.target.checked})} 
      className="rounded bg-slate-800 border-slate-700 text-cyan-500 focus:ring-0"
    />
    ¿Es Torneo Finals? (Multiplicador 2x)
  </label>

  {/* Botón Publicar */}
  <button 
    onClick={() => {
      if(!nuevoTorneo.nombre) return alert("Por favor ingresá un nombre para el torneo");
      if(!nuevoTorneo.fechaInicio) return alert("Por favor seleccioná la fecha y hora de inicio");
      if(!nuevoTorneo.cupo || nuevoTorneo.cupo <= 0) return alert("Por favor ingresá un cupo válido");

      push(ref(db, 'torneos_activos'), { 
        ...nuevoTorneo, 
        inscriptos: {}, 
        estado: 'activo',
        fechaCreacion: Date.now() 
      }).then(() => {
        alert("✅ Torneo publicado con éxito!");
        setNuevoTorneo({
          nombre: '',
          formato: 'Round Robin',
          modo: 'singles',
          esFinals: false,
          cupo: 16,
          precio: '$5000',
          fechaInicio: ''
        });
      });
    }}
    className="w-full bg-emerald-600 hover:bg-emerald-500 text-white py-3.5 rounded-xl font-black text-xs uppercase tracking-widest shadow-lg shadow-emerald-900/20 active:scale-95 transition-all mt-2"
  >
    Publicar Torneo
  </button>
</div>

        {/* FORMULARIO CARGAR RESULTADO (DESPLEGABLES) */}
<div className="bg-slate-900/80 p-5 rounded-3xl border border-cyan-500/30 space-y-4">
  <h5 className="font-black text-cyan-400 text-xs uppercase tracking-widest">
    Cargar Resultado de Partido
  </h5>

  {/* Select de Torneo */}
  <select 
    value={cargaPartido.torneoId} 
    onChange={e => {
      const t = torneosActivos.find(x => x.id === e.target.value);
      setCargaPartido({ 
        ...cargaPartido, 
        torneoId: e.target.value, 
        modo: t?.modo || 'singles', 
        esFinals: t?.esFinals || false 
      });
    }}
    className="w-full bg-slate-800 p-3 rounded-xl text-xs text-white border border-slate-700 outline-none focus:border-cyan-500 [color-scheme:dark]"
  >
    <option value="">-- Seleccionar Torneo --</option>
    {torneosActivos?.map(t => (
      <option key={t.id} value={t.id}>{t.nombre} ({t.modo})</option>
    ))}
  </select>

  {/* Desplegables de Jugadores */}
  {cargaPartido.modo === 'singles' ? (
    <div className="grid grid-cols-2 gap-2">
      <select 
        value={cargaPartido.jugador1} 
        onChange={e => setCargaPartido({...cargaPartido, jugador1: e.target.value})} 
        className="bg-slate-800 p-3 rounded-xl text-xs text-white border border-slate-700 outline-none focus:border-cyan-500 [color-scheme:dark]"
      >
        <option value="">Jugador 1</option>
        {usuariosAdmin.map(u => <option key={u.uid} value={u.uid}>{u.nombre}</option>)}
      </select>
      <select 
        value={cargaPartido.jugador2} 
        onChange={e => setCargaPartido({...cargaPartido, jugador2: e.target.value})} 
        className="bg-slate-800 p-3 rounded-xl text-xs text-white border border-slate-700 outline-none focus:border-cyan-500 [color-scheme:dark]"
      >
        <option value="">Jugador 2</option>
        {usuariosAdmin.map(u => <option key={u.uid} value={u.uid}>{u.nombre}</option>)}
      </select>
    </div>
  ) : (
    <div className="space-y-2">
      <div className="grid grid-cols-2 gap-2">
        <select 
          value={cargaPartido.doblesA1} 
          onChange={e => setCargaPartido({...cargaPartido, doblesA1: e.target.value})} 
          className="bg-slate-800 p-2.5 rounded-xl text-xs text-white border border-slate-700 outline-none focus:border-cyan-500 [color-scheme:dark]"
        >
          <option value="">Pareja A - Jugador 1</option>
          {usuariosAdmin.map(u => <option key={u.uid} value={u.uid}>{u.nombre}</option>)}
        </select>
        <select 
          value={cargaPartido.doblesA2} 
          onChange={e => setCargaPartido({...cargaPartido, doblesA2: e.target.value})} 
          className="bg-slate-800 p-2.5 rounded-xl text-xs text-white border border-slate-700 outline-none focus:border-cyan-500 [color-scheme:dark]"
        >
          <option value="">Pareja A - Jugador 2</option>
          {usuariosAdmin.map(u => <option key={u.uid} value={u.uid}>{u.nombre}</option>)}
        </select>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <select 
          value={cargaPartido.doblesB1} 
          onChange={e => setCargaPartido({...cargaPartido, doblesB1: e.target.value})} 
          className="bg-slate-800 p-2.5 rounded-xl text-xs text-white border border-slate-700 outline-none focus:border-cyan-500 [color-scheme:dark]"
        >
          <option value="">Pareja B - Jugador 1</option>
          {usuariosAdmin.map(u => <option key={u.uid} value={u.uid}>{u.nombre}</option>)}
        </select>
        <select 
          value={cargaPartido.doblesB2} 
          onChange={e => setCargaPartido({...cargaPartido, doblesB2: e.target.value})} 
          className="bg-slate-800 p-2.5 rounded-xl text-xs text-white border border-slate-700 outline-none focus:border-cyan-500 [color-scheme:dark]"
        >
          <option value="">Pareja B - Jugador 2</option>
          {usuariosAdmin.map(u => <option key={u.uid} value={u.uid}>{u.nombre}</option>)}
        </select>
      </div>
    </div>
  )}

  {/* Selección de Ganador */}
  <div className="flex gap-2">
    <button 
      type="button"
      onClick={() => setCargaPartido({...cargaPartido, ganador: 1})} 
      className={`flex-1 py-3 rounded-xl font-black text-xs uppercase transition-all ${
        cargaPartido.ganador === 1 ? 'bg-emerald-600 text-white shadow-lg shadow-emerald-900/20' : 'bg-slate-800 text-slate-400'
      }`}
    >
      Gana Lado 1 / Pareja A
    </button>
    <button 
      type="button"
      onClick={() => setCargaPartido({...cargaPartido, ganador: 2})} 
      className={`flex-1 py-3 rounded-xl font-black text-xs uppercase transition-all ${
        cargaPartido.ganador === 2 ? 'bg-emerald-600 text-white shadow-lg shadow-emerald-900/20' : 'bg-slate-800 text-slate-400'
      }`}
    >
      Gana Lado 2 / Pareja B
    </button>
  </div>

  {/* INPUTS DE PARCIALES / SETS */}
  <div className="space-y-2 bg-slate-950/40 p-3 rounded-2xl border border-white/5">
    <span className="block text-[10px] font-black uppercase text-slate-400 tracking-wider text-center">
      📊 Parciales de Sets (Opcional - Hasta 5 Sets)
    </span>
    <div className="grid grid-cols-5 gap-1.5">
      {[0, 1, 2, 3, 4].map((idx) => (
        <div key={idx} className="flex flex-col gap-1 items-center bg-slate-900/80 p-1.5 rounded-xl border border-white/5">
          <span className="text-[9px] font-bold text-slate-500">Set {idx + 1}</span>
          <input
            type="number"
            placeholder="L1"
            value={cargaPartido.sets[idx].p1}
            onChange={(e) => {
              const nuevosSets = [...cargaPartido.sets];
              nuevosSets[idx].p1 = e.target.value;
              setCargaPartido({ ...cargaPartido, sets: nuevosSets });
            }}
            className="w-full bg-slate-800 text-center text-white text-xs py-1 rounded-lg outline-none font-bold focus:ring-1 focus:ring-cyan-500"
          />
          <span className="text-[9px] text-slate-600 font-bold">-</span>
          <input
            type="number"
            placeholder="L2"
            value={cargaPartido.sets[idx].p2}
            onChange={(e) => {
              const nuevosSets = [...cargaPartido.sets];
              nuevosSets[idx].p2 = e.target.value;
              setCargaPartido({ ...cargaPartido, sets: nuevosSets });
            }}
            className="w-full bg-slate-800 text-center text-white text-xs py-1 rounded-lg outline-none font-bold focus:ring-1 focus:ring-cyan-500"
          />
        </div>
      ))}
    </div>
  </div>

  {/* SELECTOR DE INSTANCIA / FASE */}
  <div className="space-y-1">
    <label className="text-[9px] font-black uppercase text-slate-400 ml-1">
      📍 Instancia / Fase del Partido
    </label>
    <select
      value={cargaPartido.fase}
      onChange={(e) => setCargaPartido({ ...cargaPartido, fase: e.target.value })}
      className="w-full bg-slate-800 p-3 rounded-xl text-xs text-white border border-slate-700 outline-none focus:border-cyan-500 [color-scheme:dark] font-bold"
    >
      <option value="Zona">Zona de Grupos</option>
      <option value="16avos de Final">16avos de Final</option>
      <option value="8avos de Final">8avos de Final</option>
      <option value="Cuartos de Final">Cuartos de Final</option>
      <option value="Semifinal">Semifinal</option>
      <option value="Final">Final</option>
      <option value="OTRA">✍️ Escribir instancia personalizada...</option>
    </select>

    {/* CAMPO A MANO SI SELECCIONA "OTRA" */}
    {cargaPartido.fase === "OTRA" && (
      <input
        type="text"
        placeholder="Ej: Triangular Final, Repechaje 3er Puesto..."
        value={cargaPartido.fasePersonalizada}
        onChange={(e) => setCargaPartido({ ...cargaPartido, fasePersonalizada: e.target.value })}
        className="w-full mt-2 bg-slate-800/90 border border-cyan-500/50 p-3 rounded-xl text-xs text-cyan-300 outline-none font-medium placeholder:text-slate-600"
      />
    )}
  </div>

  {/* BOTÓN IMPACTAR RESULTADO */}
  <button 
    type="button"
    onClick={async () => {
      if (!cargaPartido.torneoId) return alert("Por favor selecciona un torneo");

      const eq1 = cargaPartido.modo === 'singles' 
        ? [cargaPartido.jugador1] 
        : [cargaPartido.doblesA1, cargaPartido.doblesA2];

      const eq2 = cargaPartido.modo === 'singles' 
        ? [cargaPartido.jugador2] 
        : [cargaPartido.doblesB1, cargaPartido.doblesB2];
      
      if (eq1.includes('') || eq2.includes('')) {
        return alert("Por favor selecciona todos los jugadores/parejas.");
      }

      // Cálculo preventivo del nombre de la fase
      const faseFinal = cargaPartido.fase === "OTRA" 
        ? (cargaPartido.fasePersonalizada?.trim() || "Instancia Especial") 
        : (cargaPartido.fase || "Zona");

      const infoTorneo = torneosActivos?.find(t => t.id === cargaPartido.torneoId);

      await procesarPartidoRanking({
        torneoId: cargaPartido.torneoId,
        torneoNombre: infoTorneo?.nombre || "Torneo",
        modo: cargaPartido.modo,
        esFinals: cargaPartido.esFinals,
        fase: faseFinal,
        equipo1: eq1,
        equipo2: eq2,
        ganador: cargaPartido.ganador,
        sets: cargaPartido.sets
      });

      // Limpiamos la selección de jugadores y parciales para la siguiente carga
      setCargaPartido({
        ...cargaPartido,
        jugador1: '',
        jugador2: '',
        doblesA1: '', doblesA2: '',
        doblesB1: '', doblesB2: '',
        fasePersonalizada: '',
        sets: [
          { p1: '', p2: '' },
          { p1: '', p2: '' },
          { p1: '', p2: '' },
          { p1: '', p2: '' },
          { p1: '', p2: '' }
        ]
      });
    }}
    className="w-full bg-cyan-600 hover:bg-cyan-500 text-white py-4 rounded-xl font-black text-xs uppercase tracking-widest shadow-lg shadow-cyan-900/20 active:scale-95 transition-all mt-2"
  >
    Impactar Resultado y Rating
  </button>
</div>

      </div>
    )}

  </div>
)}


{/* --- PESTAÑA COMPETENCIAS EQUIPOS --- */}
{pestañaActiva === "competencias" && (
  <div className="animate-in fade-in duration-300 pb-16">
    
    {/* --- NAV INTERNO --- */}
    <div className="flex bg-slate-800/60 backdrop-blur-md p-1 rounded-2xl border border-white/5 mb-6 gap-1 shadow-inner overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
      <button onClick={() => setSubPestañaComp("vitrina")} className={`flex-1 py-2.5 rounded-xl text-[10px] font-black transition-all duration-300 uppercase tracking-widest whitespace-nowrap px-3 ${subPestañaComp === "vitrina" ? 'bg-slate-700 text-cyan-400 shadow-md border border-white/10' : 'text-slate-400'}`}>🏆 Vitrina</button>
      <button onClick={() => setSubPestañaComp("proximos")} className={`flex-1 py-2.5 rounded-xl text-[10px] font-black transition-all duration-300 uppercase tracking-widest whitespace-nowrap px-3 ${subPestañaComp === "proximos" ? 'bg-slate-700 text-cyan-400 shadow-md border border-white/10' : 'text-slate-400'}`}>Próximos</button>
      <button onClick={() => setSubPestañaComp("resultados")} className={`flex-1 py-2.5 rounded-xl text-[10px] font-black transition-all duration-300 uppercase tracking-widest whitespace-nowrap px-3 ${subPestañaComp === "resultados" ? 'bg-slate-700 text-cyan-400 shadow-md border border-white/10' : 'text-slate-400'}`}>Resultados</button>
      {(user?.email === ADMIN_EMAIL || user?.email === STAFF_EMAIL) && (
        <button onClick={() => setSubPestañaComp("admin")} className={`flex-1 py-2.5 rounded-xl text-[10px] font-black transition-all duration-300 uppercase tracking-widest whitespace-nowrap px-3 ${subPestañaComp === "admin" ? 'bg-cyan-600 text-white shadow-lg' : 'text-cyan-500/70 hover:text-cyan-400'}`}>➕ Cargar</button>
      )}
    </div>

    {/* --- VITRINA DE TROFEOS COLECTIVOS --- */}
    {subPestañaComp === "vitrina" && (
      <div className="mx-2 mb-10 relative animate-in fade-in duration-300">
        <div className="flex items-center gap-3 mb-6 px-2">
          <div className="h-[2px] flex-1 bg-gradient-to-r from-transparent to-purple-500/50"></div>
          <h3 className="text-[12px] font-black tracking-[0.4em] text-purple-400 uppercase italic">Vitrina • Club Astros</h3>
          <div className="h-[2px] flex-1 bg-gradient-to-l from-transparent to-purple-500/50"></div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {vitrinaColectiva && Object.values(vitrinaColectiva).reverse().map((t, i) => (
            <div key={i} className="relative group">
              <div className={`absolute inset-0 blur-xl opacity-10 transition-opacity group-hover:opacity-25 ${t.posicion === 'CAMPEÓN' ? 'bg-yellow-500' : 'bg-purple-500'}`}></div>
              <div className="relative bg-slate-900/60 backdrop-blur-md border border-white/10 rounded-[24px] p-5 overflow-hidden shadow-xl">
                <div className="absolute -right-2 -top-2 rotate-12 opacity-10 group-hover:rotate-0 transition-transform duration-500"><span className="text-6xl">🏆</span></div>
                <div className="flex flex-col gap-1">
                  <span className="text-[9px] font-black text-purple-400/80 tracking-widest uppercase italic">{t.periodo}</span>
                  <h4 className="text-lg font-black text-white leading-tight uppercase italic mb-2">{t.competencia}</h4>
                  <div className="flex items-center gap-2 mt-auto">
                    <span className={`px-2 py-1 rounded-md text-[9px] font-black uppercase tracking-tighter ${t.posicion === 'CAMPEÓN' ? 'bg-yellow-500 text-black' : 'bg-slate-800 text-slate-300'}`}>{t.posicion}</span>
                    <span className="text-[10px] font-bold text-slate-400">{t.circuito} • {t.categoria}</span>
                  </div>
                </div>
                <div className={`absolute left-0 top-0 bottom-0 w-[3px] ${t.posicion === 'CAMPEÓN' ? 'bg-yellow-500' : 'bg-purple-500'}`}></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    )}

    {/* --- VISTA PRÓXIMOS --- */}
    {subPestañaComp === "proximos" && (
      <div className="space-y-6">
        <div className="flex overflow-x-auto gap-2 pb-4 no-scrollbar px-1">
          {categoriasPosibles.map(cat => (
            <button key={cat} onClick={() => setFiltroCat(cat)} className={`px-4 py-2 rounded-full text-[10px] font-black uppercase tracking-widest transition-all whitespace-nowrap border ${filtroCat === cat ? 'bg-cyan-600 border-cyan-400 text-white shadow-[0_0_15px_rgba(6,182,212,0.4)] scale-105' : 'bg-slate-900/60 border-white/10 text-slate-500 hover:border-white/20'}`}>{cat}</button>
          ))}
        </div>

        {Object.keys(encuentrosAgrupados).length === 0 ? (
          <div className="text-center py-20 bg-slate-800/20 rounded-[32px] border border-white/5 border-dashed italic text-slate-500 text-sm">No hay partidos programados.</div>
        ) : (
          Object.entries(encuentrosAgrupados).map(([dia, horarios]) => (
            <div key={dia} className="relative mb-8">
              <div className="sticky top-0 z-20 py-2 mb-4 backdrop-blur-md bg-slate-950/20">
                <h3 className="text-[11px] font-black uppercase tracking-[0.3em] text-cyan-500 border-l-4 border-cyan-500 pl-3 italic">{dia}</h3>
              </div>
              <div className="space-y-8 ml-2 border-l border-white/5 pl-4">
                {Object.entries(horarios).map(([hora, listaPartidos]) => (
                  <div key={hora} className="relative">
                    <div className="flex items-center gap-3 mb-4">
                      <span className="text-[10px] font-black text-slate-100 bg-slate-800 px-3 py-1 rounded-full border border-white/10 shadow-lg">🕒 {hora}</span>
                      <div className="h-[1px] flex-1 bg-gradient-to-r from-white/10 to-transparent"></div>
                    </div>
                    <div className="grid grid-cols-1 gap-5">
                      {listaPartidos.map(e => {
                        const esCopa = e.tipo === 'Copa de Clubes' || e.categoria === 'Copa de Clubes';
                        const faseLower = e.fase?.toLowerCase() || "";
                        const esFinal = faseLower.includes('final') && !faseLower.includes('8avos') && !faseLower.includes('16avos') && !faseLower.includes('4tos');
                        const esSemi = faseLower.includes('semi');

                        return (
                          <div 
                            key={e.id} 
                            className={`relative bg-slate-900/60 backdrop-blur-xl p-5 rounded-[28px] border transition-all duration-500 overflow-hidden 
                              ${esCopa ? 'border-purple-500/40 shadow-[0_0_30px_rgba(168,85,247,0.15)] bg-gradient-to-br from-slate-900 via-purple-950/20 to-slate-900' : 'border-white/10 shadow-xl'}
                              ${esFinal ? 'ring-2 ring-orange-500 shadow-[0_0_40px_rgba(249,115,22,0.3)] scale-[1.02]' : ''}
                              ${esSemi ? 'ring-1 ring-cyan-500/50' : ''}`}
                            style={{ borderLeft: `6px solid ${esCopa ? '#a855f7' : (esFinal ? '#f97316' : '#06b6d4')}` }}
                          >
                            {esCopa && <div className="absolute -right-6 -top-6 text-7xl opacity-10 rotate-12 drop-shadow-2xl">🏆</div>}
                            <div className="absolute top-0 right-0">
                              <div className={`px-4 py-1.5 rounded-bl-2xl text-[10px] font-black uppercase tracking-tighter shadow-xl ${esCopa ? 'bg-purple-600 text-white' : (esFinal ? 'bg-orange-600 text-white' : 'bg-cyan-600 text-white')}`}>
                                {e.categoria}
                              </div>
                            </div>
                            <div className="flex items-center gap-2 mb-4 text-[9px] font-black uppercase tracking-wider">
                              <span style={{ color: esCopa ? '#a855f7' : (esFinal ? '#f97316' : '#22d3ee') }}>{esCopa ? '🏆 ' + e.tipo : e.tipo}</span>
                              {e.fase && (
                                <span className={`px-2 py-0.5 rounded-md ${esFinal ? 'bg-orange-500 text-white animate-pulse' : 'bg-slate-800 text-slate-400 border border-white/5'}`}>{e.fase}</span>
                              )}
                            </div>
                            <div className="flex items-center justify-between gap-2 mb-5">
                              <div className="flex-1 text-center font-black text-slate-100 text-[13px] leading-tight uppercase truncate">{e.equipo}</div>
                              <div className="px-2 py-1 bg-white/5 rounded-lg text-[9px] font-black text-slate-500 border border-white/5">VS</div>
                              <div className="flex-1 text-center font-black text-slate-100 text-[13px] leading-tight uppercase truncate">{e.rival}</div>
                            </div>
                            <div className="flex items-center justify-between pt-4 border-t border-white/5">
                              <div className="flex flex-col gap-0.5 max-w-[60%]">
                                <div className="text-[10px] text-slate-500 font-medium truncate">📍 {e.ubicacion}</div>
                                {e.mesa && <div className="text-[10px] text-cyan-400 font-black tracking-widest uppercase">🏓 Mesa {e.mesa}</div>}
                              </div>
                              {e.plantel && e.plantel.length > 0 && e.plantel[0] !== "" && (
                                <div className="flex -space-x-2">
                                  {e.plantel.map((p, i) => (
                                    <div key={i} className={`w-6 h-6 rounded-full border-2 flex items-center justify-center text-[8px] font-black shadow-sm ${esCopa ? 'bg-purple-900 border-purple-400 text-purple-100' : 'bg-slate-800 border-slate-900 text-cyan-400'}`} title={p}>{p.charAt(0)}</div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    )}

    {/* --- VISTA RESULTADOS --- */}
    {subPestañaComp === "resultados" && (
      <div className="space-y-6">
        <div className="space-y-4 mb-6">
          <select value={filtroSemestre} onChange={(e) => setFiltroSemestre(e.target.value)} className="w-full bg-slate-900/80 border border-white/10 text-slate-200 p-3 rounded-2xl font-bold focus:ring-2 focus:ring-cyan-500 focus:outline-none [color-scheme:dark] text-xs">
            <option value="2026-1">1er Semestre 2026</option>
            <option value="2026-2">2do Semestre 2026</option>
          </select>
          <div className="flex overflow-x-auto gap-2 pb-2 no-scrollbar px-1">
            {categoriasPosibles.map(cat => (
              <button key={cat} onClick={() => setFiltroCat(cat)} className={`px-4 py-2 rounded-full text-[9px] font-black uppercase tracking-widest transition-all whitespace-nowrap border ${filtroCat === cat ? 'bg-cyan-600 border-cyan-400 text-white shadow-[0_0_15px_rgba(6,182,212,0.3)]' : 'bg-slate-900/60 border-white/10 text-slate-500'}`}>{cat}</button>
            ))}
          </div>
        </div>

        {Object.keys(resultadosAgrupados).length === 0 ? (
          <div className="text-center py-20 bg-slate-800/20 rounded-[32px] border border-white/5 border-dashed italic text-slate-500 text-sm">Sin resultados para esta selección.</div>
        ) : (
          Object.entries(resultadosAgrupados).map(([dia, horarios]) => (
            <div key={dia} className="relative mb-8">
              <div className="sticky top-0 z-20 py-2 mb-4 backdrop-blur-md bg-slate-950/20">
                <h3 className="text-[10px] font-black uppercase tracking-[0.3em] text-emerald-500 border-l-4 border-emerald-500 pl-3 italic">{dia}</h3>
              </div>
              <div className="space-y-8 ml-2 border-l border-white/5 pl-4">
                {Object.entries(horarios).map(([hora, listaPartidos]) => (
                  <div key={hora} className="relative">
                    <div className="flex items-center gap-3 mb-4">
                      <span className="text-[9px] font-black text-slate-400 bg-slate-900 px-3 py-1 rounded-full border border-white/5">🕒 {hora}</span>
                      <div className="h-[1px] flex-1 bg-gradient-to-r from-white/5 to-transparent"></div>
                    </div>
                    <div className="grid grid-cols-1 gap-4">
                      {listaPartidos.map(e => {
                        const esCopa = e.tipo === 'Copa de Clubes' || e.categoria === 'Copa de Clubes';
                        const ganoAstros = parseInt(e.resAstros) > parseInt(e.resRival);
                        return (
                          <div key={e.id} className={`relative bg-slate-900/60 backdrop-blur-xl p-5 rounded-[28px] border border-white/10 shadow-xl overflow-hidden ${esCopa ? 'ring-1 ring-purple-500/30' : ''}`}>
                            <div className="absolute top-0 right-0">
                              <div className={`px-4 py-1.5 rounded-bl-2xl text-[9px] font-black uppercase tracking-tighter ${esCopa ? 'bg-purple-600' : 'bg-slate-800'} text-white`}>{e.categoria}</div>
                            </div>
                            <div className="text-[8px] font-black uppercase tracking-[0.2em] text-slate-500 mb-4">{esCopa ? '🏆 ' + e.tipo : e.tipo} {e.fase && `• ${e.fase}`}</div>
                            <div className="flex items-center justify-between gap-2 mb-4">
                              <div className="flex-1 text-center"><div className="text-[11px] font-black text-slate-100 uppercase truncate">{e.equipo}</div></div>
                              <div className={`flex items-center gap-2 px-3 py-1.5 rounded-xl border ${ganoAstros ? 'bg-emerald-500/20 border-emerald-500/40' : 'bg-slate-950/50 border-white/5'}`}>
                                <span className={`text-lg font-black ${ganoAstros ? 'text-emerald-400' : 'text-slate-400'}`}>{e.resAstros}</span>
                                <span className="text-slate-700 text-xs">-</span>
                                <span className={`text-lg font-black ${!ganoAstros && e.resRival > e.resAstros ? 'text-red-400' : 'text-slate-400'}`}>{e.resRival}</span>
                              </div>
                              <div className="flex-1 text-center"><div className="text-[11px] font-black text-slate-100 uppercase truncate">{e.rival}</div></div>
                            </div>
                            <div className="flex items-center justify-between pt-3 border-t border-white/5">
                              <div className="text-[8px] text-slate-500 font-bold italic uppercase">{e.ubicacion || 'Finalizado'}</div>
                              <div className="flex -space-x-1.5">
                                {e.plantel?.slice(0, 3).map((p, i) => (
                                  <div key={i} className="w-5 h-5 rounded-full bg-slate-800 border border-slate-950 flex items-center justify-center text-[7px] font-black text-slate-400">{p.charAt(0)}</div>
                                ))}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    )}

    {/* --- SUB-PESTAÑA ADMIN (CON GESTIÓN FILTRADA) --- */}
    {subPestañaComp === "admin" && (user?.email === ADMIN_EMAIL || user?.email === STAFF_EMAIL) && (
      <div className="animate-in slide-in-from-bottom-4 duration-300">
        <div className="bg-slate-800/60 p-6 rounded-[2rem] border border-white/10 shadow-2xl mb-8">
          <SeccionAdminComp /> 
        </div>

        <div className="flex flex-col sm:flex-row gap-3 mb-6 bg-slate-900/60 p-4 rounded-[2rem] border border-white/5">
          <div className="flex-1">
            <label className="text-[10px] uppercase tracking-widest text-cyan-500/70 ml-2 mb-1 block font-bold">Temporada</label>
            <select value={filtroSemestreGestion} onChange={(e) => setFiltroSemestreGestion(e.target.value)} className="w-full bg-slate-800 border border-slate-700 text-slate-200 p-3 rounded-xl focus:ring-2 focus:ring-cyan-600 text-sm [color-scheme:dark]">
              <option value="2026-1">1° Semestre 2026</option>
              <option value="2026-2">2° Semestre 2026</option>
            </select>
          </div>
          <div className="flex-1">
            <label className="text-[10px] uppercase tracking-widest text-cyan-500/70 ml-2 mb-1 block font-bold">Categoría</label>
            <select value={filtroCatGestion} onChange={(e) => setFiltroCatGestion(e.target.value)} className="w-full bg-slate-800 border border-slate-700 text-slate-200 p-3 rounded-xl focus:ring-2 focus:ring-cyan-600 text-sm [color-scheme:dark]">
              <option value="TODAS">Todas las categorías</option>
              {categoriasPosibles.filter(c => c !== 'TODAS').map(cat => (
                <option key={cat} value={cat}>{cat}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="bg-slate-900/40 p-5 rounded-[2rem] border border-white/5 mb-8">
          <h4 className="text-xs font-black mb-6 text-slate-500 text-center uppercase tracking-widest">📝 Gestionar Encuentros</h4>
          {encuentros && encuentros.filter(e => {
            const coincideSemestre = e.semestre === filtroSemestreGestion;
            const coincideCat = filtroCatGestion === "TODAS" || e.categoria === filtroCatGestion || (filtroCatGestion === "Copa de Clubes" && e.tipo === "Copa de Clubes");
            return coincideSemestre && coincideCat;
          }).length === 0 ? (
            <div className="text-center py-10 border border-dashed border-slate-800 rounded-2xl italic">
              <p className="text-xs text-slate-600 uppercase font-black">Sin partidos en esta selección</p>
            </div>
          ) : (
            encuentros
              .filter(e => {
                const coincideSemestre = e.semestre === filtroSemestreGestion;
                const coincideCat = filtroCatGestion === "TODAS" || e.categoria === filtroCatGestion || (filtroCatGestion === "Copa de Clubes" && e.tipo === "Copa de Clubes");
                return coincideSemestre && coincideCat;
              })
              .sort((a, b) => new Date(a.fecha) - new Date(b.fecha))
              .map(e => (
                <div key={e.id} className={`bg-slate-900/80 p-4 rounded-2xl mb-3 border ${e.estado === 'finalizado' ? 'border-white/5 opacity-60' : 'border-cyan-500/30'}`}>
                  <div className="flex justify-between items-start mb-4">
                    <div className="flex-1">
                      <div className="text-[8px] font-black text-cyan-500 uppercase mb-1 tracking-tighter">{e.categoria} • {e.tipo}</div>
                      <div className="text-[11px] font-black text-white uppercase">{e.equipo} vs {e.rival} {e.estado === 'finalizado' && '✅'}</div>
                      <div className="text-[9px] text-slate-500 mt-0.5">{new Date(e.fecha).toLocaleDateString()} {e.mesa && `• Mesa ${e.mesa}`}</div>
                    </div>
                    <button onClick={() => window.confirm("¿Borrar encuentro?") && remove(ref(db, `competencias/encuentros/${e.id}`))} className="p-2 text-slate-600 hover:text-red-500 transition-colors">🗑️</button>
                  </div>
                  {e.estado === "proximo" && (
                    <div className="flex items-center gap-3 bg-black/30 p-3 rounded-xl border border-white/5">
                      <input type="number" placeholder="AST" id={`resA-${e.id}`} className="bg-slate-800 text-white w-12 text-center py-2 rounded-lg font-black focus:ring-1 focus:ring-emerald-500 outline-none" />
                      <span className="text-slate-600 font-bold">-</span>
                      <input type="number" placeholder="RIV" id={`resR-${e.id}`} className="bg-slate-800 text-white w-12 text-center py-2 rounded-lg font-black focus:ring-1 focus:ring-emerald-500 outline-none" />
                      <button 
                        onClick={() => {
                          const ra = document.getElementById(`resA-${e.id}`).value;
                          const rr = document.getElementById(`resR-${e.id}`).value;
                          if (ra === "" || rr === "") return alert("Carga ambos resultados");
                          finalizarEncuentro(e.id, ra, rr);
                        }}
                        className="flex-1 bg-emerald-600 text-white py-2 rounded-lg font-black text-[10px] uppercase tracking-wider shadow-lg active:scale-95 transition-all"
                      > Finalizar </button>
                    </div>
                  )}
                </div>
              ))
          )}
        </div>

        {/* --- PANEL ADMIN: VITRINA DE TROFEOS (INTACTO) --- */}
        <section className="bg-slate-900/80 border border-purple-500/20 rounded-3xl p-6 mb-8">
          <h3 className="text-purple-400 font-black uppercase italic text-sm mb-4">🏆 Cargar Trofeo Colectivo</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
            <input type="text" placeholder="Periodo (Ej: Verano 2026)" className="bg-black/40 border border-white/10 p-3 rounded-xl text-white text-sm outline-none" id="vit-periodo" />
            <input type="text" placeholder="Competencia (Ej: Liga de Equipos)" className="bg-black/40 border border-white/10 p-3 rounded-xl text-white text-sm outline-none" id="vit-comp" />
            <input type="text" placeholder="Categoría (Ej: Primera)" className="bg-black/40 border border-white/10 p-3 rounded-xl text-white text-sm outline-none" id="vit-cat" />
            <select className="bg-black/40 border border-white/10 p-3 rounded-xl text-white text-sm outline-none font-bold" id="vit-pos">
              <option value="CAMPEÓN">🏆 CAMPEÓN</option>
              <option value="SUB-CAMPEÓN">🥈 SUB-CAMPEÓN</option>
              <option value="3ER PUESTO">🥉 3ER PUESTO</option>
            </select>
            <input type="text" placeholder="Circuito (Ej: FETEMBA)" className="bg-black/40 border border-white/10 p-3 rounded-xl text-white text-sm outline-none" id="vit-circ" />
          </div>
          <button 
            onClick={() => {
                const nuevoTrofeo = {
                    periodo: document.getElementById('vit-periodo').value,
                    competencia: document.getElementById('vit-comp').value,
                    categoria: document.getElementById('vit-cat').value,
                    posicion: document.getElementById('vit-pos').value,
                    circuito: document.getElementById('vit-circ').value,
                    fechaCarga: new Date().getTime()
                };
                push(ref(db, 'config/vitrinaColectiva'), nuevoTrofeo).then(() => alert("¡Trofeo a la vitrina! 🚀"));
            }}
            className="w-full bg-purple-600 hover:bg-purple-500 py-3 rounded-2xl font-black text-[10px] uppercase tracking-widest text-white transition-all shadow-lg shadow-purple-900/20"
          > AÑADIR A LA VITRINA COLECTIVA </button>
        </section>
      </div>
    )}
  </div>
)}

{pestañaActiva === "planilla" && (user?.email === ADMIN_EMAIL || user?.email === STAFF_EMAIL) && (
  <div className="animate-in fade-in duration-500 pb-20 px-1 sm:px-4">
    
   {/* --- CONSOLA DE DATOS ORGANIZADA POR FILAS --- */}
<div className="flex flex-col gap-4 mb-8 px-1">
  
  {/* FILA 1: POBLACIÓN (Socios, Activos, Invitados) */}
  <div className="grid grid-cols-3 gap-2">
    <div className="bg-slate-900/60 p-3 rounded-2xl border border-white/5 shadow-lg">
      <p className="text-[8px] font-black text-slate-500 uppercase tracking-widest">Total Socios</p>
      <div className="text-lg font-black text-white">{statsPlanilla.totales}</div>
    </div>
    <div className="bg-slate-900/60 p-3 rounded-2xl border border-cyan-500/20 shadow-lg">
      <p className="text-[8px] font-black text-cyan-500 uppercase tracking-widest">Activos</p>
      <div className="text-lg font-black text-cyan-400">{statsPlanilla.activos}</div>
    </div>
    <div className="bg-slate-900/60 p-3 rounded-2xl border border-orange-500/20 shadow-lg">
      <p className="text-[8px] font-black text-orange-500 uppercase tracking-widest">Invitados</p>
      <div className="text-lg font-black text-orange-400">{statsPlanilla.invitados}</div>
    </div>
  </div>

  {/* FILA 2: NIVELES (Negros, Violetas, Azules) */}
  <div className="grid grid-cols-3 gap-2">
    <div className="bg-slate-900/60 p-3 rounded-2xl border border-white/10 flex items-center justify-between">
      <div className="w-2 h-2 rounded-full bg-white shadow-[0_0_5px_white]"></div>
      <span className="text-[9px] font-black text-slate-400 uppercase">Negros</span>
      <span className="text-sm font-black text-white">{statsPlanilla.negros}</span>
    </div>
    <div className="bg-slate-900/60 p-3 rounded-2xl border border-purple-500/10 flex items-center justify-between">
      <div className="w-2 h-2 rounded-full bg-purple-500 shadow-[0_0_5px_purple]"></div>
      <span className="text-[9px] font-black text-slate-400 uppercase">Violetas</span>
      <span className="text-sm font-black text-white">{statsPlanilla.violetas}</span>
    </div>
    <div className="bg-slate-900/60 p-3 rounded-2xl border border-blue-500/10 flex items-center justify-between">
      <div className="w-2 h-2 rounded-full bg-blue-500 shadow-[0_0_5px_blue]"></div>
      <span className="text-[9px] font-black text-slate-400 uppercase">Azules</span>
      <span className="text-sm font-black text-white">{statsPlanilla.azules}</span>
    </div>
  </div>

  <div className="grid grid-cols-3 gap-2">
    {/* DEUDA DE TURNOS */}
    <div className="bg-red-500/5 p-3 rounded-2xl border border-red-500/20 shadow-lg">
      <p className="text-[8px] font-black text-red-500 uppercase tracking-widest leading-none mb-1">Deuda Turnos</p>
      <div className="text-sm font-black text-red-400">
        {statsPlanilla.deudoresTurnos} <span className="text-[8px] opacity-60">P.</span> 
        <span className="ml-1 text-[10px]">(-{statsPlanilla.totalDeudaCreditos}🚩)</span>
      </div>
    </div>

    {/* DEUDA DE DINERO ($) */}
    <div className="bg-red-500/5 p-3 rounded-2xl border border-red-500/20 shadow-lg">
      <p className="text-[8px] font-black text-red-500 uppercase tracking-widest leading-none mb-1">Deuda Dinero $</p>
      <div className="text-sm font-black text-red-400">
        {statsPlanilla.deudoresDinero} <span className="text-[8px] opacity-60">P.</span>
        <span className="ml-1 text-[10px]">(${statsPlanilla.totalDeudaDinero?.toLocaleString('es-AR')})</span>
      </div>
    </div>

    {/* CAJA TOTAL (NETO) */}
    <div className="bg-emerald-500/5 p-3 rounded-2xl border-l-4 border-l-emerald-500 shadow-lg flex flex-col justify-center">
      <p className="text-[8px] font-black text-emerald-500 uppercase tracking-widest leading-none mb-1">Caja Neta $</p>
      <div className={`text-base font-black tabular-nums ${statsPlanilla.totalCaja < 0 ? 'text-red-500' : 'text-emerald-500'}`}>
        ${statsPlanilla.totalCaja.toLocaleString('es-AR')}
      </div>
    </div>
  </div>

</div>

    {/* TABLA PRINCIPAL */}
    <section className="relative p-2 rounded-[2rem] bg-slate-800/40 backdrop-blur-xl border border-white/10 shadow-2xl overflow-hidden">
      
      {/* BUSCADOR Y ORDENAMIENTO */}
      <div className="flex gap-2 mb-4 p-2">
        <input 
          type="text" placeholder="Buscar socio..." value={busquedaPlanilla}
          onChange={(e) => setBusquedaPlanilla(e.target.value)}
          className="flex-1 bg-slate-900/80 border border-slate-700 text-slate-200 px-4 py-2 rounded-xl text-xs outline-none focus:ring-1 focus:ring-cyan-500"
        />
        <select 
          value={ordenPlanilla} 
          onChange={(e) => setOrdenPlanilla(e.target.value)}
          className="bg-slate-900/80 border border-slate-700 text-slate-200 px-3 py-2 rounded-xl text-[10px] font-black uppercase [color-scheme:dark]"
        >
          <option value="nombre">Nombre</option>
          <option value="mayor_deuda">Mayor Deuda ↑</option>
          <option value="mayor_credito">Mayor Crédito ↑</option>
        </select>
      </div>

      <div className="overflow-x-auto rounded-2xl border border-white/5 bg-black/20 shadow-inner">
        <table className="w-full border-collapse text-[10px] text-left min-w-[1150px]">
          <thead>
            <tr className="bg-slate-900/80 text-slate-500 font-black uppercase tracking-tighter border-b border-white/5">
              <th className="p-2 w-[150px] min-w-[140px]">Socio / Nivel</th>
              <th className="p-2 text-center">Saldo Dep.</th>
              <th className="p-2 text-center bg-white/5">Cuenta $</th>
              <th className="p-2 w-[80px]">Fijos</th>
              <th className="p-2 w-[280px]">Historial (15)</th>
              <th className="p-2 text-center">Apto Médico</th>
              <th className="p-2 w-[180px]">Ficha / Contacto</th>
              <th className="p-2 text-center">Estado</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {planillaFiltrada.map((u) => {
              const tieneTurnos = u.turnosAsignados && u.turnosAsignados.length > 0;
              
              // Lógica de cálculo de estado de Apto Médico
              const hoyTs = new Date().getTime();
              let estadoApto = { texto: "No Presentado", color: "bg-slate-800 text-slate-400 border-white/10" };
              
              if (u.aptoMedico) {
                if (u.fechaApto) {
                  const fechaAptoTs = new Date(u.fechaApto + "T00:00:00").getTime();
                  const unAñoEnMs = 365 * 24 * 60 * 60 * 1000;
                  const vencimientoTs = fechaAptoTs + unAñoEnMs;
                  const fechaVenc = new Date(vencimientoTs).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });

                  if (hoyTs > vencimientoTs) {
                    estadoApto = { texto: `Vencido (${fechaVenc})`, color: "bg-red-500/10 text-red-400 border-red-500/30" };
                  } else {
                    estadoApto = { texto: `Vigente (Vence: ${fechaVenc})`, color: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" };
                  }
                } else {
                  estadoApto = { texto: "Vigente (Sin fecha)", color: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" };
                }
              }

              return (
                <tr key={u.uid} className={`transition-colors hover:bg-white/5 ${u.bloqueado ? 'bg-red-500/10' : ''}`}>
                  
                  {/* COLUMNA SOCIO / NIVEL */}
                  <td className="p-3 whitespace-nowrap">
                    <div className="flex items-center gap-1.5">
                      <div className={`w-0.5 h-4 rounded-full ${u.turnosAsignados?.length > 0 ? 'bg-cyan-500 shadow-[0_0_5px_cyan]' : 'bg-orange-500/40'}`}></div>
                      <div className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${u.nivel === 'Negro' ? 'bg-white' : (u.nivel === 'Violeta' ? 'bg-purple-500' : 'bg-blue-500')}`}></div>
                      <div className="flex flex-col min-w-0">
                        <span className={`font-bold leading-tight truncate max-w-[110px] ${u.turnosAsignados?.length > 0 ? 'text-white' : 'text-orange-200'}`}>
                          {u.nombre}
                        </span>
                        <span className="text-[7px] text-slate-600 uppercase tracking-tighter leading-none">
                          {u.nivel}
                        </span>
                      </div>
                    </div>
                  </td>

                  {/* SALDO DEPORTIVO */}
                  <td className={`p-1 text-center font-black tabular-nums text-[11px] ${u.realDeuda > 0 ? 'text-red-400' : 'text-emerald-400'}`}>
                    {u.realDeuda > 0 ? `-${u.realDeuda}` : `+${u.realCreditos}`}
                  </td>

                  {/* CUENTA CORRIENTE ($) */}
                  <td className={`p-1 text-center font-black tabular-nums text-xs bg-white/[0.03] ${u.saldoCC < 0 ? 'text-red-500' : 'text-emerald-500'}`}>
                    ${u.saldoCC?.toLocaleString('es-AR')}
                  </td>

                  {/* TURNOS FIJOS */}
                  <td className="p-1">
                    <div className="flex flex-wrap gap-1 max-w-[65px]">
                      {u.turnosAsignados?.map((t, idx) => (
                        <span key={idx} className="bg-slate-900/80 text-[7px] px-1 rounded border border-white/5 text-slate-500 font-bold">
                          {t.dia.substring(0,2)}{t.h}
                        </span>
                      )) || <span className="opacity-10">-</span>}
                    </div>
                  </td>

                  {/* HISTORIAL MOVIMIENTOS */}
                  <td className="p-1">
                    <div className="h-[65px] overflow-y-auto bg-black/40 rounded-xl p-1 border border-white/5 text-[8px] leading-tight custom-scrollbar shadow-inner">
                      {(() => {
                        if (!u.historial_movimientos) {
                          return <span className="text-slate-700 italic flex justify-center py-4">Sin registros</span>;
                        }

                        const listaMovs = Array.isArray(u.historial_movimientos)
                          ? u.historial_movimientos.filter(Boolean)
                          : Object.values(u.historial_movimientos);

                        if (listaMovs.length === 0) {
                          return <span className="text-slate-700 italic flex justify-center py-4">Sin registros</span>;
                        }

                        const ultimos15 = listaMovs
                          .sort((a, b) => (Number(b?.fecha) || 0) - (Number(a?.fecha) || 0))
                          .slice(0, 15);

                        return ultimos15.map((h, i) => {
                          const textoMotivo = h?.motivo || h?.concepto || (h?.tipo === 'CARGA' ? 'Carga de Créditos' : 'Consumo / Turno');
                          const esCarga = h?.tipo === 'CARGA' || (h?.cantidad && Number(h.cantidad) > 0 && h?.tipo !== 'CONSUMO');

                          return (
                            <div key={i} className="flex justify-between items-center gap-2 border-b border-white/5 py-1 last:border-0">
                              <span className={`truncate max-w-[180px] font-medium ${esCarga ? 'text-emerald-400' : 'text-red-400'}`}>
                                {textoMotivo}
                              </span>
                              <span className="text-slate-500 tabular-nums font-bold text-[7.5px] whitespace-nowrap">
                                {h?.fecha ? new Date(Number(h.fecha)).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit' }) : '--/--'}
                              </span>
                            </div>
                          );
                        });
                      })()}
                    </div>
                  </td>

                  {/* COLUMNA DERECHA 1: APTO MÉDICO */}
                  <td className="p-2 text-center whitespace-nowrap">
                    <span className={`text-[8px] font-black px-2 py-0.5 rounded-full border ${estadoApto.color}`}>
                      {estadoApto.texto}
                    </span>
                  </td>

                  {/* COLUMNA DERECHA 2: FICHA Y CONTACTO */}
                  <td className="p-2 whitespace-nowrap">
                    <div className="flex flex-col gap-0.5 text-[8.5px]">
                      <div className="flex items-center gap-1 text-slate-300">
                        <span className="text-slate-500 font-bold">DNI:</span>
                        <span className="font-medium">{u.dni || "--"}</span>
                      </div>
                      <div className="flex items-center gap-1 text-slate-300">
                        <span className="text-slate-500 font-bold">Nac:</span>
                        <span className="font-medium">
                          {u.fechaNacimiento 
                            ? new Date(u.fechaNacimiento + "T00:00:00").toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' })
                            : "--"}
                        </span>
                      </div>
                      <div className="text-slate-400 font-medium truncate max-w-[160px]" title={u.email}>
                        {u.email || "--"}
                      </div>
                    </div>
                  </td>

                  {/* ESTADO DE ACCESO (BLOQUEADO / ACTIVO) */}
                  <td className="p-1 text-center">
                    {u.bloqueado ? "🚫" : "✅"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  </div>
)}

{/* --- PESTAÑA GRILLA TURNOS (ESTILO ASTRONÓMICO) --- */}
{pestañaActiva === "grilla" && (user?.email === ADMIN_EMAIL || user?.email === STAFF_EMAIL) && (
  <section style={{ 
    animation: 'fadeIn 0.5s', 
    paddingBottom: '100px',
    background: 'radial-gradient(circle at top, #1a1a2e 0%, #020205 100%)', // Fondo espacial
    minHeight: '100vh'
  }}>
    {obtenerGrillaReal().sedes.map(sede => (
      <div key={sede} style={{ marginBottom: '40px' }}>
        {/* Título Estelar de Sede */}
        <div style={{ padding: '0 20px' }}>
          <h2 style={{ 
            background: 'linear-gradient(90deg, #6c5ce7, #a29bfe)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontSize: '18px', 
            fontWeight: '900',
            letterSpacing: '2px',
            marginBottom: '15px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}>
            <span style={{ fontSize: '20px' }}>{sede.toLowerCase().includes('fulgor') ? '✨' : '☄️'}</span>
            SISTEMA {sede.toUpperCase()}
          </h2>
        </div>

        {/* Contenedor con Desplazamiento Horizontal (Fila de Días) */}
        <div style={{ 
          display: 'flex', 
          overflowX: 'auto', 
          gap: '15px', 
          padding: '10px 20px',
          scrollSnapType: 'x mandatory',
          WebkitOverflowScrolling: 'touch'
        }}>
          {obtenerGrillaReal().diasSemanales.map(dia => {
            const horariosDelDia = obtenerGrillaReal().estructura[sede][dia];
            if (Object.keys(horariosDelDia).length === 0) return null;

            return (
              <div key={dia} style={{ 
                minWidth: '200px', 
                maxWidth: '200px',
                background: 'rgba(255, 255, 255, 0.03)', 
                borderRadius: '20px', 
                border: '1px solid rgba(108, 92, 231, 0.2)', 
                backdropFilter: 'blur(10px)',
                overflow: 'hidden',
                scrollSnapAlign: 'start',
                display: 'flex',
                flexDirection: 'column',
                height: '400px' // Altura fija para permitir scroll vertical interno
              }}>
                {/* Cabecera del Día */}
                <div style={{ 
                  background: 'linear-gradient(135deg, #6c5ce7 0%, #4834d4 100%)', 
                  color: 'white', 
                  padding: '12px', 
                  textAlign: 'center', 
                  fontWeight: 'bold', 
                  fontSize: '13px',
                  textTransform: 'uppercase',
                  letterSpacing: '1px'
                }}>
                  {dia}
                </div>
                
                {/* Área de Turnos con Scroll Vertical */}
                <div style={{ 
                  padding: '12px', 
                  overflowY: 'auto', 
                  flex: 1,
                  scrollbarWidth: 'none' // Ocultar scrollbar en Firefox
                }}>
                  {Object.entries(horariosDelDia)
                    .sort((a, b) => a[0].localeCompare(b[0]))
                    .map(([hora, alumnos]) => (
                      <div key={hora} style={{ 
                        marginBottom: '12px', 
                        padding: '10px', 
                        borderRadius: '12px',
                        background: alumnos.length >= 12 ? 'rgba(231, 76, 60, 0.1)' : 'rgba(255, 255, 255, 0.05)',
                        border: `1px solid ${alumnos.length >= 12 ? '#e74c3c' : 'rgba(255, 255, 255, 0.1)'}`,
                        boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
                      }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                          <b style={{ fontSize: '11px', color: '#a29bfe' }}>🕒 {hora}</b>
                          <b style={{ 
                            fontSize: '11px', 
                            color: alumnos.length >= 12 ? '#ff7675' : '#55efc4',
                            textShadow: '0 0 5px rgba(0,0,0,0.5)'
                          }}>
                            {alumnos.length}/12
                          </b>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                          {alumnos.map((a, idx) => (
                            <div key={idx} style={{ 
                              fontSize: '10px', 
                              padding: '5px 8px', 
                              borderRadius: '8px',
                              background: 'rgba(0, 0, 0, 0.3)', 
                              borderLeft: `4px solid ${
                                a.nivel === "Negro" ? "#000000" : 
                                a.nivel === "Violeta" ? "#a29bfe" : "#74b9ff"
                              }`,
                              color: '#dfe6e9',
                              fontWeight: '500'
                            }}>
                              {a.nombre}
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    ))}
  </section>
)}

{/* --- PESTAÑA MAESTRA ADMIN --- */}
{pestañaActiva === "admin" && user?.email === ADMIN_EMAIL && (
  <div className="animate-in fade-in duration-300 p-4 pb-24">
    
    {/* MENÚ DE 5 SUB-PESTAÑAS ESTILO NATIVO */}
    <div className="flex gap-2 mb-8 overflow-x-auto bg-slate-800/60 backdrop-blur-md p-1.5 rounded-2xl border border-white/5 shadow-inner scrollbar-hide [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      {["socios", "cuentas", "cuotas", "feriados", "noticias"].map(sub => (
        <button 
          key={sub}
          onClick={() => setSubPestañaAdmin(sub)}
          className={`flex-1 min-w-[90px] py-3 rounded-xl text-[10px] font-black transition-all duration-300 uppercase tracking-[0.1em] border ${
            subPestañaAdmin === sub 
              ? 'bg-slate-700 text-cyan-400 border-white/10 shadow-lg shadow-black/20' 
              : 'text-slate-500 border-transparent hover:text-slate-300 hover:bg-white/5'
          }`}
        >
          {/* Opcional: Agregar un pequeño punto si estás en esa pestaña */}
          <div className="flex flex-col items-center gap-1">
            {sub}
            {subPestañaAdmin === sub && <div className="w-1 h-1 bg-cyan-400 rounded-full animate-pulse"></div>}
          </div>
        </button>
      ))}
    </div>

    {subPestañaAdmin === "socios" && (
  <div className="animate-in fade-in duration-500"> 
    <section className="relative p-5 rounded-3xl bg-slate-800/40 backdrop-blur-xl border border-white/10 shadow-xl mb-6 overflow-hidden">
      <div className="absolute top-0 right-0 w-32 h-32 bg-cyan-500/5 blur-3xl pointer-events-none"></div>
      
      {/* HEADER DE GESTIÓN */}
      <div className="flex justify-between items-center mb-6">
        <h4 className="text-lg font-black text-white flex items-center gap-2 tracking-wide">
          <span className="text-xl">👑</span> Gestión de Socios
        </h4>
        <span className="text-[10px] font-black bg-slate-900 text-cyan-400 border border-cyan-500/30 px-3 py-1 rounded-full shadow-lg">
          TOTAL: {totalSocios}
        </span>
      </div>
      
      {/* RESUMEN DE NIVELES */}
      <div className="grid grid-cols-3 gap-2 mb-6 text-[9px] font-black text-center uppercase tracking-tighter">
        <div className="bg-slate-900 border border-slate-700 text-white p-2 rounded-xl shadow-md">Negro: {totalNegro}</div>
        <div className="bg-purple-900/40 border border-purple-500/30 text-purple-300 p-2 rounded-xl shadow-md">Violeta: {totalVioleta}</div>
        <div className="bg-blue-900/40 border border-blue-500/30 text-blue-300 p-2 rounded-xl shadow-md">Azul: {totalAzul}</div>
      </div>

      {/* BUSCADOR Y FILTRO */}
      <div className="flex gap-2 mb-6">
        <input 
          type="text" 
          placeholder="🔍 Buscar socio por nombre, dni, mail..." 
          value={busqueda} 
          onChange={(e) => setBusqueda(e.target.value)} 
          className="flex-[2] bg-slate-900/60 border border-slate-700 text-white p-3 rounded-xl focus:ring-2 focus:ring-cyan-500 outline-none text-sm"
        />
        <select 
          value={filtroNivel} 
          onChange={(e) => setFiltroNivel(e.target.value)}
          className="flex-1 bg-slate-900/60 border border-slate-700 text-slate-300 p-3 rounded-xl text-xs font-bold [color-scheme:dark]"
        >
          <option value="Todos">Todos</option>
          <option value="Negro">Negro</option>
          <option value="Violeta">Violeta</option>
          <option value="Azul">Azul</option>
        </select>
      </div>

      {/* LISTA DE SOCIOS */}
      <div className="max-h-[600px] overflow-y-auto space-y-4 pr-1 custom-scrollbar">
        {usuariosAdmin
          .filter(u => 
            ((u.nombre || "") + " " + (u.dni || "") + " " + (u.email || "")).toLowerCase().includes(busqueda.toLowerCase()) && 
            (filtroNivel === "Todos" || u.nivel === filtroNivel)
          )
          .map(u => {
            // Lógica de Estado de Apto Médico
            const hoyTs = new Date().getTime();
            let estadoApto = { texto: "⚪ Sin Apto Médico", color: "bg-slate-800 text-slate-400 border-white/10" };
            
            if (u.aptoMedico) {
              if (u.fechaApto) {
                const fechaAptoTs = new Date(u.fechaApto + "T00:00:00").getTime();
                const unAñoEnMs = 365 * 24 * 60 * 60 * 1000;
                const vencimientoTs = fechaAptoTs + unAñoEnMs;
                const fechaVenc = new Date(vencimientoTs).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });

                if (hoyTs > vencimientoTs) {
                  estadoApto = { texto: `🔴 Apto Vencido (${fechaVenc})`, color: "bg-red-500/10 text-red-400 border-red-500/30" };
                } else {
                  estadoApto = { texto: `🟢 Apto Vigente (Vence: ${fechaVenc})`, color: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" };
                }
              } else {
                estadoApto = { texto: "🟢 Apto Presentado (Sin Fecha)", color: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" };
              }
            }

            return (
              <div key={u.uid} className="p-4 bg-slate-900/60 border border-white/10 rounded-2xl shadow-lg space-y-4">
                
                {/* ENCABEZADO Y CONTADORES */}
                <div className="flex justify-between items-start">
                  <div className="flex flex-col">
                    <b 
                      onClick={() => {
                        const nuevoNombre = window.prompt("Editar nombre del socio:", u.nombre);
                        if (nuevoNombre !== null && nuevoNombre.trim() !== "") {
                          update(ref(db, `usuarios/${u.uid}`), { nombre: nuevoNombre.trim() });
                        }
                      }} 
                      className="text-white text-base font-black cursor-pointer hover:text-cyan-400 transition-colors underline decoration-cyan-500/30 underline-offset-4"
                    >
                      {u.nombre || "Socio sin nombre"}
                    </b>

                    <div className="flex items-center gap-2 mt-1">
                      <span className="text-xs font-black">
                        {u.realDeuda > 0 ? <span className="text-red-400">(-{u.realDeuda}🚩)</span> : <span className="text-emerald-400">({u.realCreditos}🏓)</span>}
                      </span>

                      {/* BADGE APTO MÉDICO */}
                      <span className={`text-[9px] font-black px-2 py-0.5 rounded-full border ${estadoApto.color}`}>
                        {estadoApto.texto}
                      </span>
                    </div>
                  </div>

                  {/* CONTROLES RÁPIDOS DE RATING / DEUDA */}
                  <div className="flex gap-1.5">
                    <button 
                      onClick={() => {
                        const ahora = new Date().getTime();
                        const updates = {};
                        if (u.detalles_creditos && Object.keys(u.detalles_creditos).length > 0) {
                          if (window.confirm("El socio tiene créditos disponibles. ¿Consumir 1?")) {
                            const creditosKeys = Object.keys(u.detalles_creditos);
                            updates[`usuarios/${u.uid}/detalles_creditos/${creditosKeys[0]}`] = null;
                            update(ref(db), updates).then(() => {
                              push(ref(db, `usuarios/${u.uid}/historial_movimientos`), { 
                                fecha: ahora, tipo: 'CONSUMO', cantidad: 1, motivo: 'Consumo manual (Admin)' 
                              });
                            });
                          }
                        } else {
                          if (window.confirm("No hay créditos. ¿Generar 1 deuda?")) {
                            const nuevaDeudaRef = push(ref(db, `usuarios/${u.uid}/deudas`));
                            updates[`usuarios/${u.uid}/deudas/${nuevaDeudaRef.key}`] = { fecha: ahora, monto: 1 };
                            updates[`usuarios/${u.uid}/realDeuda`] = (u.realDeuda || 0) + 1;
                            update(ref(db), updates).then(() => {
                              push(ref(db, `usuarios/${u.uid}/historial_movimientos`), { 
                                fecha: ahora, tipo: 'DEUDA', cantidad: 1, motivo: 'Deuda generada (Admin)' 
                              });
                            });
                          }
                        }
                      }}
                      className="w-9 h-9 flex items-center justify-center rounded-xl bg-rose-600 text-white font-black text-xs shadow-md active:scale-90 transition-transform"
                      title="Restar crédito / Generar deuda"
                    > -1 </button>

                    <button 
                      onClick={() => {
                        const ahora = new Date().getTime();
                        if (u.realDeuda > 0 && u.deudas) {
                          if (window.confirm(`El socio debe ${u.realDeuda}. ¿Saldar 1 deuda?`)) {
                            const deudasKeys = Object.keys(u.deudas);
                            const updates = {};
                            updates[`usuarios/${u.uid}/deudas/${deudasKeys[0]}`] = null;
                            updates[`usuarios/${u.uid}/realDeuda`] = u.realDeuda - 1;
                            update(ref(db), updates).then(() => {
                              push(ref(db, `usuarios/${u.uid}/historial_movimientos`), { 
                                fecha: ahora, tipo: 'CARGA', cantidad: 1, motivo: 'Saldó deuda (Admin)' 
                              });
                            });
                          }
                        } else {
                          push(ref(db, `usuarios/${u.uid}/detalles_creditos`), { 
                            otorgado: ahora, vence: ahora + (10 * 24 * 60 * 60 * 1000) 
                          });
                          push(ref(db, `usuarios/${u.uid}/historial_movimientos`), { 
                            fecha: ahora, tipo: 'CARGA', cantidad: 1, motivo: 'Carga manual (Admin)' 
                          });
                        }
                      }}
                      className="w-9 h-9 flex items-center justify-center rounded-xl bg-emerald-600 text-white font-black text-xs shadow-md active:scale-90 transition-transform"
                      title="Saldar deuda / Cargar crédito"
                    > +1 </button>

                    <button 
                      onClick={() => { 
                        if(window.confirm("¿Resetear créditos y deudas?")) { 
                          const ahora = new Date().getTime();
                          const updates = {};
                          updates[`usuarios/${u.uid}/detalles_creditos`] = null; 
                          updates[`usuarios/${u.uid}/deudas`] = null; 
                          updates[`usuarios/${u.uid}/realDeuda`] = 0;
                          update(ref(db), updates).then(() => {
                            push(ref(db, `usuarios/${u.uid}/historial_movimientos`), { 
                              fecha: ahora, tipo: 'RESET', cantidad: 0, motivo: 'Reset total (Admin)' 
                            });
                          });
                        } 
                      }} 
                      className="px-2.5 rounded-xl bg-slate-800 text-slate-400 text-[9px] font-bold border border-white/5 hover:text-white transition-colors"
                      title="Resetear saldo a cero"
                    > RST </button>

                    <button 
                      onClick={() => { if(window.confirm(`¿ELIMINAR A ${(u.nombre || '').toUpperCase()}?`)) remove(ref(db, `usuarios/${u.uid}`)); }} 
                      className="p-2 text-red-400 hover:bg-red-500/10 rounded-xl transition-colors text-xs"
                      title="Eliminar usuario"
                    >🗑️</button>
                  </div>
                </div>

                {/* MODULO 1: DATOS DE CONTACTO OPCIONALES Y APTO MÉDICO */}
                <div className="bg-slate-950/40 p-3 rounded-xl border border-white/5 space-y-3">
                  <span className="text-[9px] font-black text-cyan-400/80 uppercase tracking-widest block">
                    📋 Ficha del Socio y Contacto
                  </span>

                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                    <input 
                      type="text" 
                      placeholder="DNI" 
                      defaultValue={u.dni || ""}
                      onBlur={(e) => update(ref(db, `usuarios/${u.uid}`), { dni: e.target.value.trim() })}
                      className="bg-slate-900 border border-slate-800 text-slate-200 px-3 py-1.5 rounded-lg text-xs outline-none focus:border-cyan-500 font-medium"
                    />
                    <input 
                      type="date" 
                      defaultValue={u.fechaNacimiento || ""}
                      onBlur={(e) => update(ref(db, `usuarios/${u.uid}`), { fechaNacimiento: e.target.value })}
                      className="bg-slate-900 border border-slate-800 text-slate-200 px-3 py-1.5 rounded-lg text-xs outline-none focus:border-cyan-500 font-medium [color-scheme:dark]"
                    />
                    <input 
                      type="email" 
                      placeholder="Correo Electrónico" 
                      defaultValue={u.email || ""}
                      onBlur={(e) => update(ref(db, `usuarios/${u.uid}`), { email: e.target.value.trim() })}
                      className="bg-slate-900 border border-slate-800 text-slate-200 px-3 py-1.5 rounded-lg text-xs outline-none focus:border-cyan-500 font-medium"
                    />
                  </div>

                  {/* CONTROLES DE APTO MÉDICO */}
                  <div className="flex flex-wrap items-center justify-between gap-2 pt-2 border-t border-white/5">
                    <label className="text-[10px] font-bold text-slate-300 uppercase tracking-wider flex items-center gap-2 cursor-pointer select-none">
                      <input 
                        type="checkbox"
                        checked={!!u.aptoMedico}
                        onChange={(e) => update(ref(db, `usuarios/${u.uid}`), { aptoMedico: e.target.checked })}
                        className="w-4 h-4 rounded bg-slate-900 border-slate-700 text-emerald-500 focus:ring-emerald-500 [color-scheme:dark]"
                      />
                      <span>Presentó Apto Médico</span>
                    </label>

                    <div className="flex items-center gap-2">
                      <label className="text-[9px] font-bold text-slate-500 uppercase">Fecha Apto:</label>
                      <input 
                        type="date"
                        defaultValue={u.fechaApto || ""}
                        onChange={(e) => update(ref(db, `usuarios/${u.uid}`), { fechaApto: e.target.value })}
                        className="bg-slate-900 border border-slate-800 text-white px-2 py-1 rounded-lg text-xs outline-none focus:border-emerald-500 [color-scheme:dark]"
                      />
                    </div>
                  </div>
                </div>

                {/* MODULO 2: NIVEL Y RANKING */}
                <div className="flex flex-wrap gap-2 items-center justify-between bg-black/20 p-2.5 rounded-xl border border-white/5">
                  <div className="flex items-center gap-2 flex-1 min-w-[180px]">
                    <label className="text-[9px] font-black text-slate-500 uppercase ml-1">Nivel:</label>
                    <select 
                      id={`nivel-${u.uid}`} 
                      defaultValue={u.nivel || "Azul"}
                      className="flex-1 bg-slate-800 text-white p-2 rounded-lg text-xs font-bold outline-none border border-transparent focus:border-cyan-500/50 [color-scheme:dark]"
                    >
                      <option value="Negro">⚫ Negro</option>
                      <option value="Violeta">🟣 Violeta</option>
                      <option value="Azul">🔵 Azul</option>
                    </select>
                    <button 
                      onClick={() => {
                        const sel = document.getElementById(`nivel-${u.uid}`);
                        if (window.confirm(`¿Cambiar nivel a ${sel.value}?`)) {
                          update(ref(db, `usuarios/${u.uid}`), { nivel: sel.value });
                        }
                      }}
                      className="bg-cyan-600 text-white px-3 py-2 rounded-lg text-[10px] font-bold shadow-md active:scale-95 transition-all"
                    > OK </button>
                  </div>

                  <label className="text-[10px] font-bold text-amber-400 uppercase tracking-wider flex items-center gap-2 cursor-pointer select-none bg-amber-500/10 px-3 py-2 rounded-lg border border-amber-500/20">
                    <input
                      type="checkbox"
                      checked={!!u.enRanking}
                      onChange={() => toggleRankingUsuario(u.uid, !!u.enRanking)}
                      className="w-4 h-4 rounded bg-slate-800 border-slate-700 text-amber-500 focus:ring-amber-500 [color-scheme:dark]"
                    />
                    <span>Activo en Ranking</span>
                  </label>
                </div>

                {/* APROBACIÓN */}
                {u.email !== ADMIN_EMAIL && !u.aprobado && (
                  <button 
                    onClick={() => { if(window.confirm(`¿Aprobar ingreso de ${u.nombre}?`)) update(ref(db, `usuarios/${u.uid}`), { aprobado: true }); }}
                    className="w-full py-3 rounded-xl bg-emerald-500 text-white font-black text-[10px] uppercase tracking-widest shadow-lg shadow-emerald-900/20 active:scale-95 transition-all"
                  > ✅ Aprobar Socio Nuevo </button>
                )}

                {/* BLOQUEO */}
                <button 
                  onClick={() => toggleBloqueo(u)}
                  className={`w-full py-2 rounded-xl font-black text-[10px] uppercase tracking-widest transition-all ${u.bloqueado ? 'bg-emerald-600 text-white' : 'bg-red-600/20 text-red-400 border border-red-500/30'}`}
                >
                  {u.bloqueado ? `🔓 Desbloquear (${u.motivoBloqueo})` : "🚫 Bloquear Acceso"}
                </button>

                {/* MEDALLAS */}
                <div className="grid grid-cols-3 gap-2 p-2 bg-black/20 rounded-xl border border-white/5">
                  {['tmt', 'fetemba', 'fatm'].map(liga => (
                    <div key={liga} className="flex flex-col gap-2 bg-slate-800/40 p-2 rounded-lg">
                      <div className="text-[8px] font-black text-center text-slate-500 uppercase italic">{liga}</div>
                      {[
                        { k: 'p1', i: '🥇', c: 'bg-yellow-500/20' },
                        { k: 'p2', i: '🥈', c: 'bg-slate-500/20' },
                        { k: 'p3', i: '🥉', c: 'bg-orange-500/20' }
                      ].map(p => (
                        <div key={p.k} className={`flex items-center justify-between p-1 rounded ${p.c}`}>
                          <span className="text-[10px] font-bold text-white ml-1">{u.podios?.[liga]?.[p.k] || 0}</span>
                          <div className="flex gap-1">
                            <button onClick={() => sumarPodio(u.uid, liga, p.k, 1)} className="w-5 h-5 flex items-center justify-center bg-white/10 rounded text-[10px] text-white hover:bg-white/20">+</button>
                            <button onClick={() => sumarPodio(u.uid, liga, p.k, -1)} className="w-5 h-5 flex items-center justify-center bg-white/10 rounded text-[10px] text-white hover:bg-white/20">-</button>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>

                {/* MODULO 3: ASIGNACIÓN Y VISUALIZACIÓN DE TURNOS ACTUALES */}
                <div className="border-t border-white/10 pt-4">
                  <div className="flex justify-between items-center mb-3">
                    <span className="text-[10px] font-black text-cyan-400 uppercase tracking-widest flex items-center gap-1.5">
                      <span>🗓️</span> Turnos Asignados Fijos:
                    </span>
                    <button 
                      onClick={() => {
                        const final = [0,1,2,3]
                          .map(i => {
                            const val = document.getElementById(`t${i}-${u.uid}`)?.value;
                            return val ? JSON.parse(val) : null;
                          })
                          .filter(Boolean);

                        update(ref(db, `usuarios/${u.uid}`), { turnosAsignados: final })
                          .then(() => alert("✅ Turnos fijos actualizados con éxito."));
                      }} 
                      className="bg-emerald-600 text-white px-3 py-1.5 rounded-lg text-[9px] font-black uppercase shadow-md active:scale-95 transition-all"
                    >
                      Guardar
                    </button>
                  </div>

                  {/* DESPLEGABLES CON AUTO-SELECCIÓN DEL TURNO ACTUAL */}
                  <div className="grid grid-cols-2 gap-2">
                    {[0,1,2,3].map(i => {
                      const turnoActual = u.turnosAsignados?.[i];
                      
                      // Buscamos cuál opción coincide exactamente con el turno guardado
                      const valorPorDefecto = turnoActual 
                        ? JSON.stringify(TODOS_LOS_TURNOS.find(t => t.dia === turnoActual.dia && t.h === turnoActual.h && t.s === turnoActual.s) || turnoActual)
                        : "";

                      return (
                        <select 
                          key={i} 
                          id={`t${i}-${u.uid}`} 
                          defaultValue={valorPorDefecto} 
                          className="bg-slate-800 text-slate-200 text-[10px] p-2.5 rounded-xl border border-slate-700 outline-none focus:border-cyan-500 [color-scheme:dark] font-bold"
                        >
                          <option value="">-- Turno {i + 1}: Vacío --</option>
                          {TODOS_LOS_TURNOS.map((opt, idx) => (
                            <option key={idx} value={JSON.stringify(opt)}>
                              {opt.dia} {opt.h}hs - {opt.s} ({opt.n})
                            </option>
                          ))}
                        </select>
                      );
                    })}
                  </div>
                </div>

              </div>
            );
          })
        }
      </div>
    </section>
  </div>
)}
    {subPestañaAdmin === "cuentas" && (
  <div className="animate-in fade-in duration-500 pb-20"> 
    {(() => {
      const alumnosConDeuda = usuariosAdmin.map(u => {
        const movimientos = u.cuenta_corriente ? Object.values(u.cuenta_corriente) : [];
        const saldo = movimientos.reduce((acc, curr) => acc + curr.monto, 0);
        return { ...u, saldoCalculado: saldo };
      }).filter(u => u.saldoCalculado < 0);
      const deudaTotal = alumnosConDeuda.reduce((acc, u) => acc + u.saldoCalculado, 0);
      const totalSociosActivos = usuariosAdmin.filter(u => u.turnosAsignados && u.turnosAsignados.length > 0).length;
      const totalInvitados = usuariosAdmin.length - totalSociosActivos;

      return (
        <div className="sticky top-0 z-40 bg-slate-900/95 backdrop-blur-md pt-2 pb-4 space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div className="bg-slate-800 border-b-2 border-red-500 p-4 rounded-2xl shadow-lg">
              <div className="text-[9px] font-black text-slate-500 uppercase tracking-widest mb-1">Deudores</div>
              <div className="text-2xl font-black text-red-500 tabular-nums">{alumnosConDeuda.length} <small className="text-[10px] text-slate-400 font-medium">Jugadores</small></div>
            </div>
            <div className="bg-slate-800 border-b-2 border-red-700 p-4 rounded-2xl shadow-lg">
              <div className="text-[9px] font-black text-slate-500 uppercase tracking-widest mb-1">Total Deuda</div>
              <div className="text-2xl font-black text-red-700 tabular-nums">${Math.abs(deudaTotal).toLocaleString('es-AR')}</div>
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-3">
            <div className="bg-slate-800 border-b-2 border-cyan-500 p-3 rounded-2xl">
              <div className="text-[9px] font-black text-slate-500 uppercase mb-1 tracking-widest">Socios</div>
              <div className="text-lg font-black text-cyan-400">{totalSociosActivos}</div>
            </div>
            <div className="bg-slate-800 border-b-2 border-slate-600 p-3 rounded-2xl">
              <div className="text-[9px] font-black text-slate-500 uppercase mb-1 tracking-widest">Invitados</div>
              <div className="text-lg font-black text-slate-400">{totalInvitados}</div>
            </div>
          </div>

          <div className="relative">
            <input 
              type="text" 
              placeholder="🔍 Buscar alumno..." 
              value={busquedaFinanzas}
              onChange={(e) => setBusquedaFinanzas(e.target.value)}
              className="w-full bg-slate-900 border border-slate-700 text-white p-3.5 rounded-2xl outline-none focus:ring-2 focus:ring-cyan-500 shadow-xl"
            />
          </div>
        </div>
      );
    })()}

    <h4 className="text-white font-black text-sm uppercase tracking-widest mt-8 mb-4 ml-2">💰 Estados de Cuenta</h4>
    <div className="flex flex-col gap-4">
      {usuariosAdmin
        .filter(u => u.nombre.toLowerCase().includes(busquedaFinanzas.toLowerCase()))
        .map(u => {
          const movimientos = u.cuenta_corriente ? Object.values(u.cuenta_corriente) : [];
          const saldo = movimientos.reduce((acc, curr) => acc + curr.monto, 0);
          return { ...u, saldoCalculado: saldo, listaMovimientos: movimientos };
        })
        .sort((a, b) => a.saldoCalculado - b.saldoCalculado)
        .map(u => (
          <div key={u.uid} className={`bg-slate-900/60 p-5 rounded-3xl border border-white/5 shadow-md ${u.saldoCalculado < 0 ? 'border-l-8 border-l-red-600' : 'border-l-8 border-l-emerald-600'}`}>
            <div className="flex justify-between items-start mb-6">
              <div>
                <b className="text-base text-white block mb-1">{u.nombre}</b>
                <div className="flex flex-wrap gap-2 items-center">
                  <span className={`text-[9px] font-black px-2 py-0.5 rounded uppercase border ${u.isManual ? 'bg-orange-500/10 border-orange-500/30 text-orange-400' : 'bg-emerald-500/10 border-emerald-500/30 text-emerald-400'}`}>
                    {u.isManual ? '⚠️ Ficha Manual' : '📧 Google Account'}
                  </span>
                  <div className="flex gap-2">
                    {u.isManual && <button onClick={() => window.confirm(`¿Eliminar ficha?`) && remove(ref(db, `usuarios/${u.uid}`))} className="text-[9px] font-bold text-red-500 underline uppercase">Eliminar</button>}
                    {!u.isManual && <button onClick={() => {
                        const manuales = usuariosAdmin.filter(x => x.isManual);
                        const mId = window.prompt("ID ficha manual:\n" + manuales.map(x => `- ${x.nombre} (${x.uid})`).join("\n"));
                        if (mId) vincularCuentas(mId, u.uid);
                      }} className="bg-slate-800 text-slate-400 text-[8px] px-2 py-1 rounded-lg uppercase font-black tracking-widest border border-white/5">🔗 Vincular</button>}
                    <button onClick={() => resetearCuentaIndividual(u.uid, u.nombre)} className="bg-slate-800 text-slate-400 text-[8px] px-2 py-1 rounded-lg uppercase font-black tracking-widest border border-white/5">🗑️ Reset</button>
                  </div>
                </div>
              </div>
              <div className={`text-xl font-black tabular-nums ${u.saldoCalculado < 0 ? 'text-red-500' : 'text-emerald-500'}`}>
                ${u.saldoCalculado.toLocaleString('es-AR')}
              </div>
            </div>

            <div className="flex flex-col gap-3">
              <div className="flex gap-2 bg-slate-950/60 p-2 rounded-2xl border border-white/5">
                <input type="number" id={`pago-${u.uid}`} placeholder="Monto pago $" className="flex-1 bg-transparent text-emerald-400 p-2 text-sm outline-none font-bold" />
                <button onClick={() => {
                  const val = parseFloat(document.getElementById(`pago-${u.uid}`).value);
                  if (val > 0) {
                    push(ref(db, `usuarios/${u.uid}/cuenta_corriente`), { fecha: Date.now(), concepto: 'Pago Recibido', monto: val, tipo: 'PAGO' });
                    document.getElementById(`pago-${u.uid}`).value = "";
                  }
                }} className="bg-emerald-600 text-white px-4 py-2 rounded-xl text-[10px] font-black uppercase shadow-lg shadow-emerald-900/20 active:scale-95 transition-all">PAGÓ</button>
              </div>
              <button onClick={() => cargarCargoManual(u.uid, u.nombre)} className="w-full bg-slate-800 text-red-400 border border-red-500/20 py-3 rounded-2xl text-[10px] font-black uppercase tracking-widest active:scale-95 transition-all">➕ Cargar Deuda / Gasto Extra</button>
            </div>

            <details className="mt-6 group">
              <summary className="text-[10px] font-black text-slate-500 uppercase tracking-widest cursor-pointer list-none flex items-center gap-2 group-open:mb-4">
                <span className="group-open:rotate-90 transition-transform">▶</span> Ver movimientos
              </summary>
              <div className="max-h-[150px] overflow-y-auto space-y-2 bg-black/30 rounded-2xl p-3 border border-white/5 custom-scrollbar">
                {[...u.listaMovimientos].reverse().map((m, idx) => (
                  <div key={idx} className="flex justify-between items-center py-2 border-b border-white/5 last:border-0 text-[11px]">
                    <div className="flex flex-col">
                      <span className="text-slate-200 font-medium">{m.concepto}</span>
                      <small className="text-slate-600 text-[9px] uppercase">{new Date(m.fecha).toLocaleDateString()}</small>
                    </div>
                    <b className={`font-black tabular-nums ${m.monto < 0 ? 'text-red-400' : 'text-emerald-400'}`}>
                      {m.monto > 0 ? '+' : ''}${m.monto.toLocaleString()}
                    </b>
                  </div>
                ))}
              </div>
            </details>
          </div>
        ))}
    </div>
  </div>
)}
    {subPestañaAdmin === "cuotas" && (
  <div className="animate-in fade-in duration-500 p-1"> 
    <div className="flex flex-col gap-6 mt-4">
      
      {/* BOTÓN CREAR SOCIO MANUAL */}
      <button 
        onClick={crearSocioManual}
        className="w-full bg-gradient-to-r from-emerald-600 to-teal-600 text-white py-4 rounded-2xl font-black text-xs uppercase tracking-widest shadow-lg shadow-emerald-900/20 active:scale-95 transition-all flex items-center justify-center gap-2"
      >
        <span>➕</span> Crear Socio Manual (Excel)
      </button>

{/* TARJETA UNIFICADA: CONFIGURACIÓN GENERAL DE PRECIOS Y CUOTAS */}
<div className="relative p-6 rounded-3xl bg-slate-900/60 backdrop-blur-xl border border-cyan-500/20 shadow-xl overflow-hidden">
  {/* Resplandor de fondo */}
  <div className="absolute -top-10 -right-10 w-32 h-32 bg-cyan-500/5 blur-3xl pointer-events-none"></div>

  {/* SECCIÓN 1: TARIFA Y PAGOS PIZARRÓN */}
  <h4 className="relative text-sm font-black text-cyan-400 mb-4 flex items-center gap-2 uppercase tracking-widest">
    <span>🏓</span> Tarifas del Pizarrón
  </h4>

  <div className="grid grid-cols-2 gap-4 mb-4">
    <div className="flex flex-col gap-1.5">
      <label className="text-[9px] font-black text-slate-500 uppercase ml-1">
        Turno Invitado
      </label>
      <div className="relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 text-xs">$</span>
        <input 
          type="number" 
          id="input-invitado" 
          defaultValue={preciosCuotas?.invitado ?? 12000} 
          className="w-full bg-slate-800 border border-slate-700 text-emerald-400 pl-7 pr-3 py-2.5 rounded-xl focus:ring-2 focus:ring-cyan-500 outline-none font-bold text-sm transition-all"
        />
      </div>
    </div>

    <div className="flex flex-col gap-1.5">
      <label className="text-[9px] font-black text-slate-500 uppercase ml-1">
        Turno Socio
      </label>
      <div className="relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 text-xs">$</span>
        <input 
          type="number" 
          id="input-socio" 
          defaultValue={preciosCuotas?.socio ?? 9000} 
          className="w-full bg-slate-800 border border-slate-700 text-emerald-400 pl-7 pr-3 py-2.5 rounded-xl focus:ring-2 focus:ring-cyan-500 outline-none font-bold text-sm transition-all"
        />
      </div>
    </div>
  </div>

  <div className="flex flex-col gap-1.5 mb-6">
    <label className="text-[9px] font-black text-slate-500 uppercase ml-1">
      Alias Mercado Pago / Banco
    </label>
    <input 
      type="text" 
      id="input-alias" 
      defaultValue={preciosCuotas?.alias || 'alejomartin'} 
      className="w-full bg-slate-800 border border-slate-700 text-cyan-300 px-3.5 py-2.5 rounded-xl focus:ring-2 focus:ring-cyan-500 outline-none font-bold text-sm transition-all"
    />
  </div>

  {/* SEPARADOR SUTIL CON LÍNEA Y DEGRADADO */}
  <div className="relative my-6 flex items-center">
    <div className="flex-grow border-t border-white/10"></div>
    <span className="flex-shrink mx-3 text-[9px] font-black text-slate-500 uppercase tracking-widest">
      Cuotas Mensuales
    </span>
    <div className="flex-grow border-t border-white/10"></div>
  </div>

  {/* SECCIÓN 2: PLANES DE CUOTAS */}
  <div className="grid grid-cols-2 gap-4">
    {[1, 2, 3, 4].map(num => (
      <div key={num} className="flex flex-col gap-1.5">
        <label className="text-[9px] font-black text-slate-500 uppercase ml-1">
          Plan {num} {num === 1 ? 'Día' : (num === 4 ? 'Full' : 'Días')}
        </label>
        <div className="relative">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 text-xs">$</span>
          <input 
            type="number" 
            id={`input-p${num}`} 
            defaultValue={preciosCuotas?.[`p${num}`] || 0} 
            className="w-full bg-slate-800 border border-slate-700 text-emerald-400 pl-7 pr-3 py-2.5 rounded-xl focus:ring-2 focus:ring-cyan-500 outline-none font-bold text-sm transition-all"
          />
        </div>
      </div>
    ))}
  </div>

  {/* BOTÓN ÚNICO DE GUARDADO */}
  <button 
    onClick={() => {
      const updates = {
        p1: parseInt(document.getElementById('input-p1').value) || 0,
        p2: parseInt(document.getElementById('input-p2').value) || 0,
        p3: parseInt(document.getElementById('input-p3').value) || 0,
        p4: parseInt(document.getElementById('input-p4').value) || 0,
        invitado: parseInt(document.getElementById('input-invitado').value) || 12000,
        socio: parseInt(document.getElementById('input-socio').value) || 9000,
        alias: document.getElementById('input-alias').value.trim() || 'alejomartin'
      };
      update(ref(db, 'config/precios_cuotas'), updates)
        .then(() => Toast.fire({ icon: 'success', title: 'Tarifas y cuotas actualizadas' }))
        .catch(err => console.error("Error guardando precios:", err));
    }}
    className="w-full mt-6 bg-cyan-600/20 hover:bg-cyan-600 text-cyan-400 hover:text-white border border-cyan-500/30 py-3.5 rounded-xl font-black text-[10px] uppercase tracking-widest transition-all shadow-md active:scale-95 flex items-center justify-center gap-2"
  >
    <span>💾</span> Guardar Configuración General
  </button>
</div>

      {/* GENERAR COBROS DEL MES */}
      <button 
        onClick={generarCuotasDelMes}
        className="w-full bg-gradient-to-r from-orange-600 to-amber-600 text-white py-4 rounded-2xl font-black text-xs uppercase tracking-[0.15em] shadow-lg shadow-orange-900/20 active:scale-95 transition-all flex items-center justify-center gap-2"
      >
        <span>🚀</span> Generar Cobros del Mes
      </button>

      <button 
  onClick={manualLimpiezaVencidos}
  className="px-4 py-2 rounded-2xl bg-amber-500/10 text-amber-500 border border-amber-500/20 hover:bg-amber-500 hover:text-white transition-all font-bold text-[10px] uppercase tracking-widest"
>
  🧹 Limpiar Créditos Vencidos de Todos
</button>

<button 
  type="button" 
  onClick={borrarNodos60Dias} 
  className="w-full bg-red-600/20 hover:bg-red-600 text-red-400 hover:text-white border border-red-500/30 py-3 rounded-xl font-black text-[10px] uppercase tracking-widest transition-all shadow-md active:scale-95 flex items-center justify-center gap-2"
>
  <span>🗑️</span> Borrar registros (+60 días)
</button>

      {/* ZONA DE PELIGRO: RESET */}
      {/* ZONA DE PELIGRO: RESET CON DOBLE CONFIRMACIÓN */}
<div className="mt-4 p-4 rounded-2xl border-2 border-red-500/20 bg-red-500/5 shadow-[0_0_20px_rgba(239,68,68,0.05)] text-center">
  <h5 className="text-[8px] font-black text-red-500/60 uppercase mb-3 italic tracking-[0.2em]">
  Zona de Control Crítico
</h5>
  <button 
    onClick={() => {
      const primero = window.confirm("⚠️ PRIMER AVISO: Vas a resetear TODAS las cuentas corrientes a $0. ¿Estás seguro?");
      if (primero) {
        setTimeout(() => {
          const segundo = window.confirm("🚫 ¡ALTO! Esta acción NO se puede deshacer. ¿Confirmás que querés borrar el saldo de TODOS los socios ahora mismo?");
          if (segundo) {
            resetearTodasLasCuentas();
          }
        }, 300); // Un pequeño delay para que el Admin no haga "doble enter" por inercia
      }
    }} 
    className="w-full bg-red-600/10 hover:bg-red-600 text-red-500 hover:text-white border border-red-500/40 py-4 rounded-xl font-black text-[10px] uppercase tracking-widest transition-all shadow-sm active:scale-95"
  >
    ⚠️ RESET TOTAL DE CUENTAS CORRIENTES
  </button>
</div>

    </div>
  </div>
)}
    {subPestañaAdmin === "feriados" && (
  <div className="animate-in fade-in duration-500 p-1">
    <section className="relative p-6 rounded-3xl bg-slate-900/60 backdrop-blur-xl border border-orange-500/20 shadow-xl overflow-hidden">
      
      {/* Resplandor ámbar de fondo */}
      <div className="absolute -top-10 -right-10 w-32 h-32 bg-orange-500/10 blur-3xl rounded-full pointer-events-none"></div>

      <h4 className="relative text-base font-black text-orange-400 mb-2 flex items-center gap-2 uppercase tracking-widest">
        <span>📅</span> Bloquear Días (Feriados)
      </h4>
      
      <p className="relative text-[11px] text-slate-400 mb-6 leading-relaxed">
        Los días marcados aquí <span className="text-orange-300/80 font-bold underline decoration-orange-500/30">quedarán inhabilitados</span> para que los socios liberen o tomen turnos.
      </p>
      
      <div className="relative flex flex-col sm:flex-row gap-3 mb-8">
        <input 
          type="date" 
          id="input-fecha-feriado" 
          className="flex-1 bg-slate-800 border border-slate-700 text-white p-3.5 rounded-xl focus:ring-2 focus:ring-orange-500 outline-none transition-all [color-scheme:dark] font-bold shadow-inner"
        />
        <button 
          onClick={() => {
            const fechaRaw = document.getElementById('input-fecha-feriado').value;
            if (!fechaRaw) return alert("Seleccioná una fecha primero");
            
            const fechaKey = fechaRaw.replace(/-/g, ""); // "20240525"
            update(ref(db, `config/feriados`), { [fechaKey]: true })
              .then(() => {
                alert("✅ Día bloqueado con éxito");
                document.getElementById('input-fecha-feriado').value = "";
              });
          }}
          className="bg-orange-600 hover:bg-orange-500 text-white px-8 py-3.5 rounded-xl font-black text-xs uppercase tracking-widest shadow-lg shadow-orange-900/20 active:scale-95 transition-all"
        >
          BLOQUEAR
        </button>
      </div>

      {/* LISTA DE DÍAS BLOQUEADOS (ESTILO CHIPS) */}
      <div className="relative border-t border-white/5 pt-6">
        <h5 className="text-[9px] font-black text-slate-500 uppercase tracking-[0.2em] mb-4">Días actualmente bloqueados:</h5>
        
        <div className="flex flex-wrap gap-2.5 min-h-[40px]">
          {Object.keys(feriados || {}).length === 0 ? (
            <span className="text-[10px] text-slate-600 italic">No hay días bloqueados en la agenda.</span>
          ) : (
            Object.keys(feriados || {}).map(f => (
              <div key={f} className="flex items-center gap-3 bg-slate-800/80 px-3 py-2 rounded-xl border border-orange-500/20 shadow-sm group hover:border-orange-500/50 transition-colors">
                <span className="text-[11px] font-bold text-slate-200 tabular-nums">
                  📅 {f.substring(6,8)}/{f.substring(4,6)}/{f.substring(0,4)}
                </span>
                <button 
                  onClick={() => {
                    if(window.confirm("¿Habilitar este día nuevamente?")) {
                      remove(ref(db, `config/feriados/${f}`));
                    }
                  }}
                  className="w-5 h-5 flex items-center justify-center bg-red-500/20 hover:bg-red-500 text-red-400 hover:text-white rounded-full transition-all text-xs leading-none"
                  title="Eliminar bloqueo"
                >
                  ✕
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  </div>
)}
    {subPestañaAdmin === "noticias" && (
  <div className="animate-in fade-in duration-500 p-1"> 
    {/* --- FORMULARIO DE CARGA --- */}
    <section className="relative p-5 rounded-3xl bg-slate-900/60 backdrop-blur-xl border border-cyan-500/20 shadow-xl overflow-hidden mb-8">
      <div className="absolute -top-10 -right-10 w-32 h-32 bg-cyan-500/5 blur-3xl rounded-full pointer-events-none"></div>
      
      <h5 className="relative text-sm font-black text-white mb-4 flex items-center gap-2 uppercase tracking-widest">
        <span className="text-cyan-400 text-lg">📣</span> Publicar en el Muro
      </h5>

      <div className="space-y-3 relative z-10">
        <input 
          placeholder="Título de la noticia..." 
          value={nuevaNoticia.titulo}
          onChange={(e) => setNuevaNoticia({...nuevaNoticia, titulo: e.target.value})}
          className="w-full bg-slate-800 border border-slate-700 text-white p-3.5 rounded-xl focus:ring-2 focus:ring-cyan-500 outline-none text-sm font-bold placeholder:text-slate-600 transition-all"
        />
        
        <textarea 
          placeholder="Escribí el mensaje para los socios..." 
          value={nuevaNoticia.contenido}
          onChange={(e) => setNuevaNoticia({...nuevaNoticia, contenido: e.target.value})}
          className="w-full bg-slate-800 border border-slate-700 text-white p-3.5 h-24 rounded-xl focus:ring-2 focus:ring-cyan-500 outline-none text-sm placeholder:text-slate-600 transition-all resize-none pt-3"
        />

        <button 
          onClick={publicarNoticia} 
          className="w-full bg-gradient-to-r from-cyan-600 to-blue-600 hover:from-cyan-500 hover:to-blue-500 text-white py-4 rounded-xl font-black text-xs uppercase tracking-[0.2em] shadow-lg shadow-cyan-900/20 active:scale-95 transition-all mt-2"
        >
          Publicar Novedad 🚀
        </button>
      </div>
    </section>

    {/* --- LISTADO DE GESTIÓN --- */}
    <div className="px-2">
      <h6 className="text-[10px] font-black text-slate-500 uppercase tracking-[0.2em] mb-4 flex items-center gap-2">
        <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse"></div>
        Noticias Activas
      </h6>

      <div className="space-y-2">
        {noticias.length === 0 ? (
          <p className="text-[11px] text-slate-600 italic text-center py-4 bg-slate-900/20 rounded-2xl border border-white/5 border-dashed">
            No hay noticias publicadas en este momento.
          </p>
        ) : (
          noticias.map(n => (
            <div 
              key={n.id} 
              className="flex justify-between items-center bg-slate-800/40 backdrop-blur-md p-3.5 rounded-2xl border border-white/5 shadow-sm hover:bg-slate-800/60 transition-all group"
            >
              <div className="flex flex-col min-w-0 pr-4">
                <span className="text-[12px] font-black text-slate-200 truncate uppercase tracking-tight">
                  {n.titulo}
                </span>
                <span className="text-[9px] text-slate-500 font-bold uppercase mt-0.5">
                  ID: {n.id.toString().slice(-6)}
                </span>
              </div>
              
              <button 
                onClick={() => { if(window.confirm("¿Borrar esta noticia?")) borrarNoticia(n.id) }} 
                className="w-10 h-10 flex items-center justify-center rounded-xl bg-red-500/10 hover:bg-red-500 text-red-500 hover:text-white transition-all border border-red-500/20 shadow-sm"
                title="Eliminar noticia"
              >
                <span className="text-lg">🗑️</span>
              </button>
            </div>
          ))
        )}
      </div>
    </div>
    {/* --- PANEL ADMIN: CARGA DE LOGROS SEMANALES --- */}
<section className="bg-slate-900/80 border border-cyan-500/20 rounded-3xl p-6 mb-8">
  <h3 className="text-cyan-400 font-black uppercase italic text-sm mb-4">📢 Cargar Logro Semanal</h3>
  
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
    <input type="text" placeholder="Nombre del Socio" className="bg-black/40 border border-white/10 p-3 rounded-xl text-white text-sm outline-none focus:border-cyan-500/50" id="podio-nombre" />
    <select className="bg-black/40 border border-white/10 p-3 rounded-xl text-white text-sm outline-none" id="podio-puesto">
      <option value="🥇">🥇 1er Puesto</option>
      <option value="🥈">🥈 2do Puesto</option>
      <option value="🥉">🥉 3er Puesto</option>
    </select>
    <input type="text" placeholder="Categoría (Ej: 4ta)" className="bg-black/40 border border-white/10 p-3 rounded-xl text-white text-sm outline-none" id="podio-cat" />
    <input type="text" placeholder="Circuito (Ej: TMT)" className="bg-black/40 border border-white/10 p-3 rounded-xl text-white text-sm outline-none" id="podio-circ" />
    <input type="text" placeholder="Lugar (Ej: Club Alvear)" className="bg-black/40 border border-white/10 p-3 rounded-xl text-white text-sm outline-none" id="podio-lugar" />
  </div>

  <button 
    onClick={() => {
        // Lógica para pushear un nuevo podio a la lista semanal
        const nuevoPodio = {
            nombre: document.getElementById('podio-nombre').value,
            puesto: document.getElementById('podio-puesto').value,
            categoria: document.getElementById('podio-cat').value,
            circuito: document.getElementById('podio-circ').value,
            lugar: document.getElementById('podio-lugar').value,
            fecha: new Date().getTime()
        };
        const podioRef = ref(db, 'config/podiosSemanales');
        push(podioRef, nuevoPodio).then(() => alert("Logro cargado con éxito 🏓"));
    }}
    className="w-full bg-cyan-600 hover:bg-cyan-500 py-3 rounded-2xl font-black text-[10px] uppercase tracking-widest text-white transition-all shadow-lg shadow-cyan-900/20"
  >
    Publicar en Podios Semanales
  </button>
  
  <button 
    onClick={() => { if(confirm("¿Borrar todos los de la semana?")) remove(ref(db, 'config/podiosSemanales')) }}
    className="w-full mt-2 text-[9px] font-bold text-red-500/60 hover:text-red-500 uppercase tracking-widest transition-all"
  >
    Limpiar lista semanal
  </button>
</section>

{/* TARJETA MODO VACACIONES - PANEL ADMIN */}
<div className="p-4 rounded-2xl bg-slate-800/80 backdrop-blur-2xl border border-white/10 shadow-lg mb-6">
  <div className="flex items-center justify-between gap-3">
    
    <div className="flex items-center gap-3 min-w-0">
      <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${
        modoVacaciones 
          ? 'bg-amber-500/20 text-amber-400 border border-amber-500/30' 
          : 'bg-slate-700/50 text-slate-400 border border-white/5'
      }`}>
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3v1m0 16v1m9-9h-1m-16 0H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      </div>
      <div className="flex flex-col min-w-0">
        <h4 className="text-xs font-black text-white uppercase tracking-wider">Modo Vacaciones</h4>
        <span className="text-[10px] font-bold uppercase tracking-tight text-slate-400">
          {modoVacaciones ? "🟢 ACTIVADO (Socios congelados)" : "🔴 DESACTIVADO (Funcionamiento normal)"}
        </span>
      </div>
    </div>
    {/* BOTÓN SWITCH EN EL PANEL ADMIN QUE GUARDA EN 'config/modoVacaciones' */}
<button
  type="button"
  onClick={() => {
    const nuevoEstado = !modoVacaciones;
    const mensaje = nuevoEstado 
      ? "¿Activar Modo Vacaciones? Los socios no podrán soltar turnos." 
      : "¿Desactivar Modo Vacaciones? La app volverá a funcionar normalmente.";

    if (window.confirm(mensaje)) {
      set(ref(db, 'config/modoVacaciones'), nuevoEstado);
    }
  }}
  className={`px-3.5 py-2 rounded-xl font-black text-xs uppercase tracking-wider transition-all active:scale-95 shrink-0 ${
    modoVacaciones
      ? 'bg-amber-500 hover:bg-amber-400 text-slate-950 shadow-[0_0_15px_rgba(245,158,11,0.4)]'
      : 'bg-slate-700 hover:bg-slate-600 text-slate-200 border border-slate-500'
  }`}
>
  {modoVacaciones ? "Desactivar" : "Activar"}
</button>
</div>
</div>

        {/* --- CONTROL DEL PODIO --- */}
<div className="bg-slate-900/80 p-6 rounded-[24px] border border-yellow-500/20 mb-6">
  <h3 className="text-yellow-500 font-black uppercase italic mb-4">🏆 Configurar Podio</h3>
  
  <div className="space-y-3">
    <input 
      type="text" placeholder="🥇 Puesto 1"
      className="w-full bg-black/40 border border-white/10 p-3 rounded-xl text-yellow-400 font-bold outline-none"
      value={podioData?.p1 || ''} 
      onChange={e => setPodioData({...podioData, p1: e.target.value})}
    />
    <div className="grid grid-cols-2 gap-2">
      <input 
        type="text" placeholder="🥈 Puesto 2"
        className="bg-black/40 border border-white/10 p-3 rounded-xl text-slate-200 font-bold outline-none"
        value={podioData?.p2 || ''} 
        onChange={e => setPodioData({...podioData, p2: e.target.value})}
      />
      <input 
        type="text" placeholder="🥉 Puesto 3"
        className="bg-black/40 border border-white/10 p-3 rounded-xl text-orange-400 font-bold outline-none"
        value={podioData?.p3 || ''} 
        onChange={e => setPodioData({...podioData, p3: e.target.value})}
      />
    </div>

    <button 
      onClick={() => {
        const updates = {};
        updates['/config/podioMensual'] = { ...podioData, activo: !podioData.activo };
        update(ref(db), updates).then(() => alert("Podio Actualizado"));
      }}
      className={`w-full py-3 rounded-xl font-black uppercase tracking-widest transition-all ${
        podioData?.activo ? 'bg-yellow-500 text-black' : 'bg-slate-700 text-slate-400'
      }`}
    >
      {podioData?.activo ? '✅ PODIO ACTIVO (Click para Apagar)' : '❌ PODIO OCULTO (Click para Prender)'}
    </button>
  </div>
</div>

  </div>
)}

  </div>
)}
    </div>
  );
}